import {GlobalConfig, PageTypes} from './types';

export const GLOBAL_CONFIG: GlobalConfig = {
    title: 'Федеральные образовательные программы',
    cards: [
        {
            title: 'Начальное общее образование',
            icon: './images/elementary.png',
            url: '/sections/1',
            buttonName: 'Открыть'
        },
        {
            title: 'Основное общее образование',
            icon: './images/basic.png',
            url: '/sections/2',
            buttonName: 'Открыть'
        },
        {
            title: 'Среднее общее образование',
            icon: './images/intermediate.png',
            url: '/sections/3',
            buttonName: 'Открыть'
        }
    ],
    pages: [
        {
            id: 1,
            parentId: null,
            type: PageTypes.SECTION,
            title: 'Федеральная образовательная программа начального общего образования',
            description: 'Приказ Министерства просвещения Российской Федерации от 18.05.2023 № 372 "Об утверждении федеральной образовательной программы начального общего образования" (Зарегистрирован 12.07.2023 № 74229)',
            filesToDownload: [
                {url: './files/noo/fop_noo.docx', downloadButtonName: 'Скачать документ'}
            ],
            childrenLinks: [
                {
                    id: 1000,
                    parentId: 1,
                    name: 'I. Общие положения',
                    childrenLinks: [],
                    url: '/sections/1000'
                },
                {
                    id: 1001,
                    parentId: 1,
                    name: 'II. Целевой раздел',
                    childrenLinks: [
                        {
                            id: 1001001,
                            parentId: 1001,
                            name: 'Пояснительная записка',
                            childrenLinks: [],
                            url: '/sections/1001001'
                        },
                        {
                            id: 1001002,
                            parentId: 1001,
                            name: 'Планируемые результаты освоения ФОП НОО',
                            childrenLinks: [],
                            url: '/sections/1001002'
                        },
                        {
                            id: 1001003,
                            parentId: 1001,
                            name: 'Система оценки достижения планируемых результатов освоения\n' +
                                'ФОП НОО',
                            childrenLinks: [],
                            url: '/sections/1001003'
                        }
                    ],
                    url: '/sections/1001'
                },
                {
                    id: 1002,
                    parentId: 1,
                    name: 'III. Содержательный раздел',
                    childrenLinks: [
                        {
                            id: 1002001,
                            parentId: 1002,
                            name: 'Федеральная рабочая программа по учебному предмету «Русский\n' +
                                'язык»',
                            childrenLinks: [],
                            url: '/sections/1002001'
                        },
                        {
                            id: 1002002,
                            parentId: 1002,
                            name: 'Федеральная рабочая программа по учебному предмету «Литературное чтение»',
                            childrenLinks: [],
                            url: '/sections/1002002'
                        },
                        {
                            id: 1002003,
                            parentId: 1002,
                            name: 'Федеральные рабочие программы по учебному предмету «Родной язык»',
                            childrenLinks: [
                                {
                                    id: 100200301,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(русский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200301'
                                },
                                {
                                    id: 100200302,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(абазинский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200302'
                                },
                                {
                                    id: 100200303,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(аварский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200303'
                                },
                                {
                                    id: 100200304,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(агульский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200304'
                                },
                                {
                                    id: 100200305,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(адыгейский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200305'
                                },
                                {
                                    id: 100200306,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(алтайский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200306'
                                },
                                {
                                    id: 100200307,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(балкарский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200307'
                                },
                                {
                                    id: 100200308,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(балкарский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200308'
                                },
                                {
                                    id: 100200309,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(башкирский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200309'
                                },
                                {
                                    id: 100200310,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(башкирский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200310'
                                },
                                {
                                    id: 100200311,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Государственный (башкирский) язык Республики Башкортостан»',
                                    childrenLinks: [],
                                    url: '/sections/100200311'
                                },
                                {
                                    id: 100200312,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(бурятский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200312'
                                },
                                {
                                    id: 100200313,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Государственный (бурятский) язык Республики Бурятия»',
                                    childrenLinks: [],
                                    url: '/sections/100200313'
                                },
                                {
                                    id: 100200314,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(вепсский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200314'
                                },
                                {
                                    id: 100200315,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(даргинский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200315'
                                },
                                {
                                    id: 100200316,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(долганский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200316'
                                },
                                {
                                    id: 100200317,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(ингушский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200317'
                                },
                                {
                                    id: 100200318,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(кабардино-черкесский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200318'
                                },
                                {
                                    id: 100200319,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(кабардино-черкесский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200319'
                                },
                                {
                                    id: 100200320,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(калмыцкий) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200320'
                                },
                                {
                                    id: 100200321,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(карачаевский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200321'
                                },
                                {
                                    id: 100200322,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(карельский) язык (ливвиковское наречие)»',
                                    childrenLinks: [],
                                    url: '/sections/100200322'
                                },
                                {
                                    id: 100200323,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(карельский) язык (собственно карельское наречие)»',
                                    childrenLinks: [],
                                    url: '/sections/100200323'
                                },
                                {
                                    id: 100200324,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(коми) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200324'
                                },
                                {
                                    id: 100200325,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Государственный (коми) язык Республики Коми»',
                                    childrenLinks: [],
                                    url: '/sections/100200325'
                                },
                                {
                                    id: 100200326,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(коми-пермяцкий) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200326'
                                },
                                {
                                    id: 100200327,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(корякский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200327'
                                },
                                {
                                    id: 100200328,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(крымскотатарский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200328'
                                },
                                {
                                    id: 100200329,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Государственный (крымскотатарский) язык Республики Крым»',
                                    childrenLinks: [],
                                    url: '/sections/100200329'
                                },
                                {
                                    id: 100200330,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(кумыкский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200330'
                                },
                                {
                                    id: 100200331,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(лакский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200331'
                                },
                                {
                                    id: 100200332,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(лезгинский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200332'
                                },
                                {
                                    id: 100200333,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(марийский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200333'
                                },
                                {
                                    id: 100200334,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Государственный (марийский (горный, луговой) язык Республики\n' +
                                        'Марий Эл»',
                                    childrenLinks: [],
                                    url: '/sections/100200334'
                                },
                                {
                                    id: 100200335,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(мокшанский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200335'
                                },
                                {
                                    id: 100200336,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(нанайский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200336'
                                },
                                {
                                    id: 100200337,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(негидальский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200337'
                                },
                                {
                                    id: 100200338,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(ненецкий) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200338'
                                },
                                {
                                    id: 100200339,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(ненецкий) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200339'
                                },
                                {
                                    id: 100200340,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(нивхский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200340'
                                },
                                {
                                    id: 100200341,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(ногайский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200341'
                                },
                                {
                                    id: 100200342,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(осетинский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200342'
                                },
                                {
                                    id: 100200343,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Государственный (осетинский) язык Республики Северная Осетия-\n' +
                                        'Алания»',
                                    childrenLinks: [],
                                    url: '/sections/100200343'
                                },
                                {
                                    id: 100200344,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(селькупский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200344'
                                },
                                {
                                    id: 100200345,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(табасаранский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200345'
                                },
                                {
                                    id: 100200346,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(татарский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200346'
                                },
                                {
                                    id: 100200347,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(татарский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200347'
                                },
                                {
                                    id: 100200348,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Государственный (татарский) язык Республики Татарстан»',
                                    childrenLinks: [],
                                    url: '/sections/100200348'
                                },
                                {
                                    id: 100200349,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(телеутский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200349'
                                },
                                {
                                    id: 100200350,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(телеутский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200350'
                                },
                                {
                                    id: 100200351,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(тувинский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200351'
                                },
                                {
                                    id: 100200352,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(удмуртский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200352'
                                },
                                {
                                    id: 100200353,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(удмуртский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200353'
                                },
                                {
                                    id: 100200354,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(удэгейский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200354'
                                },
                                // {
                                //     id: 100200355,
                                //     parentId: 1002003,
                                //     name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                //         '(украинский) язык»',
                                //     childrenLinks: [],
                                //     url: '/sections/100200355'
                                // },
                                {
                                    id: 100200356,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(ульчский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200356'
                                },
                                {
                                    id: 100200357,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(финский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200357'
                                },
                                {
                                    id: 100200358,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(хакасский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200358'
                                },
                                {
                                    id: 100200359,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(хакасский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200359'
                                },
                                {
                                    id: 100200360,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Государственный (хакасский) язык Республики Хакасия»',
                                    childrenLinks: [],
                                    url: '/sections/100200360'
                                },
                                {
                                    id: 100200361,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(хантыйский) язык (шурышкарский диалект)»',
                                    childrenLinks: [],
                                    url: '/sections/100200361'
                                },
                                {
                                    id: 100200362,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(цахурский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200362'
                                },
                                {
                                    id: 100200363,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(черкесский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200363'
                                },
                                {
                                    id: 100200364,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(чеченский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200364'
                                },
                                {
                                    id: 100200365,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(чувашский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200365'
                                },
                                {
                                    id: 100200366,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(чувашский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200366'
                                },
                                {
                                    id: 100200367,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Государственный (чувашский) язык Чувашской Республики –\n' +
                                        'Чувашии»',
                                    childrenLinks: [],
                                    url: '/sections/100200367'
                                },
                                {
                                    id: 1002003672,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (чукотский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/1002003672'
                                },
                                {
                                    id: 1002003671,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (шорский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/1002003671'
                                },
                                {
                                    id: 100200368,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(эвенкийский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200368'
                                },
                                {
                                    id: 100200369,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(эвенкийский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200369'
                                },
                                {
                                    id: 100200370,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(эвенский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200370'
                                },
                                {
                                    id: 100200371,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(энецкий) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200371'
                                },
                                {
                                    id: 100200372,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(эрзянский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200372'
                                },
                                {
                                    id: 100200373,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(лесной юкагирский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200373'
                                },
                                {
                                    id: 100200374,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(тундренный юкагирский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200374'
                                },
                                {
                                    id: 100200375,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                        '(якутский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/100200375'
                                },
                                {
                                    id: 100200376,
                                    parentId: 1002003,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Государственный язык (саха) Республики Саха (Якутия)»',
                                    childrenLinks: [],
                                    url: '/sections/100200376'
                                }
                            ],
                            url: '/sections/1002003'
                        },
                        {
                            id: 1002004,
                            parentId: 1002,
                            name: 'Федеральные рабочие программы по учебному предмету «Литературное чтение на родном языке»',
                            childrenLinks: [
                                {
                                    id: 100200401,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (русском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200401'
                                },
                                {
                                    id: 100200402,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (абазинском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200402'
                                },
                                {
                                    id: 100200403,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (аварском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200403'
                                },
                                {
                                    id: 100200404,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (агульском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200404'
                                },
                                {
                                    id: 100200405,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (адыгейском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200405'
                                },
                                {
                                    id: 100200406,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (алтайском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200406'
                                },
                                {
                                    id: 100200407,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (балкарском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200407'
                                },
                                {
                                    id: 100200408,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (башкирском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200408'
                                },
                                {
                                    id: 100200409,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (башкирском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200409'
                                },
                                {
                                    id: 100200410,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (бурятском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200410'
                                },
                                {
                                    id: 100200411,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (вепсском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200411'
                                },
                                {
                                    id: 100200412,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (даргинском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200412'
                                },
                                {
                                    id: 100200413,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (долганском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200413'
                                },
                                {
                                    id: 1002004131,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету «Литературное чтение на родном (ингушском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/1002004131'
                                },
                                {
                                    id: 100200414,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (кабардино-черкесском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200414'
                                },
                                {
                                    id: 100200415,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (калмыцком) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200415'
                                },
                                {
                                    id: 100200416,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (карачаевском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200416'
                                },
                                {
                                    id: 100200417,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (карельском) языке (ливвиковское\n' +
                                        'наречие)».',
                                    childrenLinks: [],
                                    url: '/sections/100200417'
                                },
                                {
                                    id: 100200418,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (карельском) языке (собственно\n' +
                                        'карельское наречие)»',
                                    childrenLinks: [],
                                    url: '/sections/100200418'
                                },
                                {
                                    id: 100200419,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (коми) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200419'
                                },
                                {
                                    id: 100200420,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (коми-пермяцком) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200420'
                                },
                                {
                                    id: 100200421,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (крымскотатарском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200421'
                                },
                                {
                                    id: 100200422,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (кумыкском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200422'
                                },
                                {
                                    id: 100200423,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (лакском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200423'
                                },
                                {
                                    id: 100200424,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (лезгинском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200424'
                                },
                                {
                                    id: 100200425,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (марийском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200425'
                                },
                                {
                                    id: 100200426,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (мокшанском, эрзянском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200426'
                                },
                                {
                                    id: 1002004261,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету «Литературное чтение на родном (нанайском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/1002004261'
                                },
                                {
                                    id: 100200427,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (негидальском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200427'
                                },
                                {
                                    id: 100200428,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (ненецком) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200428'
                                },
                                {
                                    id: 100200429,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (ненецком) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200429'
                                },
                                {
                                    id: 100200430,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (нивхском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200430'
                                },
                                {
                                    id: 100200431,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (ногайском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200431'
                                },
                                {
                                    id: 100200432,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (осетинском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200432'
                                },
                                {
                                    id: 100200433,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (селькупском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200433'
                                },
                                {
                                    id: 100200434,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (табасаранском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200434'
                                },
                                {
                                    id: 100200435,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (татарском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200435'
                                },
                                {
                                    id: 100200436,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (татарском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200436'
                                },
                                {
                                    id: 100200437,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (телеутском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200437'
                                },
                                {
                                    id: 100200438,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (тувинском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200438'
                                },
                                {
                                    id: 100200439,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (удмуртском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200439'
                                },
                                {
                                    id: 100200440,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (удэгейском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200440'
                                },
                                // {
                                //     id: 100200441,
                                //     parentId: 1002004,
                                //     name: 'Федеральная рабочая программа по учебному предмету\n' +
                                //         '«Литературное чтение на родном (украинском) языке»',
                                //     childrenLinks: [],
                                //     url: '/sections/100200441'
                                // },
                                {
                                    id: 100200442,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (ульчском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200442'
                                },
                                {
                                    id: 100200443,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (финском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200443'
                                },
                                {
                                    id: 1002004431,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (хакасском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/1002004431'
                                },
                                {
                                    id: 100200444,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (хакасском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200444'
                                },
                                {
                                    id: 1002004441,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (хантыйском) языке (шурышкарский диалект)',
                                    childrenLinks: [],
                                    url: '/sections/1002004441'
                                },
                                {
                                    id: 100200445,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (цахурском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200445'
                                },
                                {
                                    id: 100200446,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (черкесском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200446'
                                },
                                {
                                    id: 100200447,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (чеченском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200447'
                                },
                                {
                                    id: 100200448,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (чувашском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200448'
                                },
                                {
                                    id: 100200449,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (чувашском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200449'
                                },
                                {
                                    id: 100200450,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (эвенкийском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200450'
                                },
                                {
                                    id: 1002004501,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету «Литературное чтение на родном (эвенском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/1002004501'
                                },
                                {
                                    id: 100200451,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (лесном юкагирском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200451'
                                },
                                {
                                    id: 100200452,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (тундренном юкагирском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200452'
                                },
                                {
                                    id: 100200453,
                                    parentId: 1002004,
                                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                                        '«Литературное чтение на родном (якутском) языке»',
                                    childrenLinks: [],
                                    url: '/sections/100200453'
                                }
                            ],
                            url: '/sections/1002004'
                        },
                        {
                            id: 1002005,
                            parentId: 1002,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Иностранный (английский) язык»',
                            childrenLinks: [],
                            url: '/sections/1002005'
                        },
                        {
                            id: 1002006,
                            parentId: 1002,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Иностранный (немецкий) язык»',
                            childrenLinks: [],
                            url: '/sections/1002006'
                        },
                        {
                            id: 1002007,
                            parentId: 1002,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Иностранный (французский) язык»',
                            childrenLinks: [],
                            url: '/sections/1002007'
                        },
                        {
                            id: 1002008,
                            parentId: 1002,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Иностранный (испанский) язык»',
                            childrenLinks: [],
                            url: '/sections/1002008'
                        },
                        {
                            id: 1002009,
                            parentId: 1002,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Иностранный (китайский) язык»',
                            childrenLinks: [],
                            url: '/sections/1002009'
                        },
                        {
                            id: 1002010,
                            parentId: 1002,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Математика»',
                            childrenLinks: [],
                            url: '/sections/1002010'
                        },
                        {
                            id: 1002011,
                            parentId: 1002,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Окружающий мир»',
                            childrenLinks: [],
                            url: '/sections/1002011'
                        },
                        {
                            id: 10020111,
                            parentId: 1002,
                            name: 'Федеральная рабочая программа по учебному предмету «Основы\n' +
                                'религиозных культур и светской этики»',
                            childrenLinks: [],
                            url: '/sections/10020111'
                        },
                        {
                            id: 1002012,
                            parentId: 1002,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Изобразительное искусство»',
                            childrenLinks: [],
                            url: '/sections/1002012'
                        },
                        {
                            id: 1002013,
                            parentId: 1002,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Музыка»',
                            childrenLinks: [],
                            url: '/sections/1002013'
                        },
                        {
                            id: 1002014,
                            parentId: 1002,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Труд (технология)»',
                            childrenLinks: [],
                            url: '/sections/1002014'
                        },
                        {
                            id: 1002015,
                            parentId: 1002,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Физическая культура»',
                            childrenLinks: [],
                            url: '/sections/1002015'
                        },
                        {
                            id: 1002016,
                            parentId: 1002,
                            name: 'Программа формирования универсальных учебных действий',
                            childrenLinks: [],
                            url: '/sections/1002016'
                        },
                        {
                            id: 1002017,
                            parentId: 1002,
                            name: 'Федеральная рабочая программа воспитания',
                            childrenLinks: [],
                            url: '/sections/1002017'
                        }
                    ],
                    url: '/sections/1002'
                },
                {
                    id: 1003,
                    parentId: 1,
                    name: 'IV. Организационный раздел',
                    childrenLinks: [
                        {
                            id: 1003001,
                            parentId: 1003,
                            name: 'Федеральный учебный план начального общего образования',
                            childrenLinks: [
                                {
                                    id: 10030010,
                                    parentId: 1003001,
                                    name: 'Пояснительная записка',
                                    childrenLinks: [],
                                    url: '/sections/10030010'
                                },
                                {
                                    id: 10030011,
                                    parentId: 1003001,
                                    name: 'Вариант 1',
                                    childrenLinks: [],
                                    url: '/sections/10030011'
                                },
                                {
                                    id: 10030012,
                                    parentId: 1003001,
                                    name: 'Вариант 2',
                                    childrenLinks: [],
                                    url: '/sections/10030012'
                                },
                                {
                                    id: 10030013,
                                    parentId: 1003001,
                                    name: 'Вариант 3',
                                    childrenLinks: [],
                                    url: '/sections/10030013'
                                },
                                {
                                    id: 10030014,
                                    parentId: 1003001,
                                    name: 'Вариант 4',
                                    childrenLinks: [],
                                    url: '/sections/10030014'
                                },
                                {
                                    id: 10030015,
                                    parentId: 1003001,
                                    name: 'Вариант 5',
                                    childrenLinks: [],
                                    url: '/sections/10030015'
                                }
                            ],
                            url: '/sections/1003001'
                        },
                        {
                            id: 1003002,
                            parentId: 1003,
                            name: 'Федеральный календарный учебный график',
                            childrenLinks: [],
                            url: '/sections/1003002'
                        },
                        {
                            id: 1003003,
                            parentId: 1003,
                            name: 'План внеурочной деятельности',
                            childrenLinks: [],
                            url: '/sections/1003003'
                        },
                        {
                            id: 1003004,
                            parentId: 1003,
                            name: 'Федеральный календарный план воспитательной работы',
                            childrenLinks: [],
                            url: '/sections/1003004'
                        }
                    ],
                    url: '/sections/1003'
                },
            ]
        },
        {
            id: 2,
            parentId: null,
            type: PageTypes.SECTION,
            title: 'Федеральная образовательная программа основного общего образования',
            description: 'Приказ Министерства просвещения Российской Федерации от 18.05.2023 № 370 "Об утверждении федеральной образовательной программы основного общего образования" (Зарегистрирован 12.07.2023 № 74223)',
            filesToDownload: [
                {url: './files/ooo/fop_ooo.docx', downloadButtonName: 'Скачать документ'}
            ],
            childrenLinks: [
                {
                    id: 2000,
                    parentId: 2,
                    name: 'I. Общие положения',
                    childrenLinks: [],
                    url: '/sections/2000'
                },
                {
                    id: 2001,
                    parentId: 2,
                    name: 'II. Целевой раздел',
                    childrenLinks: [
                        {
                            id: 2001001,
                            parentId: 2001,
                            name: 'Пояснительная записка',
                            childrenLinks: [],
                            url: '/sections/2001001'
                        },
                        {
                            id: 2001002,
                            parentId: 2001,
                            name: 'Планируемые результаты освоения ФОП ООО',
                            childrenLinks: [],
                            url: '/sections/2001002'
                        },
                        {
                            id: 2001003,
                            parentId: 2001,
                            name: 'Система оценки достижения планируемых результатов освоения\n' +
                                'ФОП ООО',
                            childrenLinks: [],
                            url: '/sections/2001003'
                        }
                    ],
                    url: '/sections/2001'
                },
                {
                    id: 2002,
                    parentId: 2,
                    name: 'III. Содержательный раздел',
                    childrenLinks: [
                        {
                            id: 200201,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Русский язык»',
                            childrenLinks: [],
                            url: '/sections/200201'
                        },
                        {
                            id: 200202,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Литература»',
                            childrenLinks: [],
                            url: '/sections/200202'
                        },
                        {
                            id: 200203,
                            parentId: 2002,
                            name: 'Федеральные рабочие программы по учебному предмету «Родной язык»',
                            childrenLinks: [
                                {
                                    id: 20020301,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (русский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020301'
                                },
                                {
                                    id: 20020302,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (абазинский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020302'
                                },
                                {
                                    id: 20020303,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (аварский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020303'
                                },
                                {
                                    id: 20020304,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (адыгейский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020304'
                                },
                                {
                                    id: 20020305,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (алтайский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020305'
                                },
                                {
                                    id: 20020306,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (балкарский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020306'
                                },
                                {
                                    id: 20020307,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (балкарский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020307'
                                },
                                {
                                    id: 20020308,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (башкирский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020308'
                                },
                                {
                                    id: 200203081,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (башкирский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/200203081'
                                },
                                {
                                    id: 20020309,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (башкирский) язык Республики Башкортостан»',
                                    childrenLinks: [],
                                    url: '/sections/20020309'
                                },
                                {
                                    id: 20020310,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (бурятский) язык».',
                                    childrenLinks: [],
                                    url: '/sections/20020310'
                                },
                                {
                                    id: 20020311,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (бурятский) язык Республики Бурятия»',
                                    childrenLinks: [],
                                    url: '/sections/20020311'
                                },
                                {
                                    id: 20020312,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (вепсский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020312'
                                },
                                {
                                    id: 20020313,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (даргинский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020313'
                                },
                                {
                                    id: 20020314,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (долганский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020314'
                                },
                                {
                                    id: 20020315,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (ингушский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020315'
                                },
                                {
                                    id: 20020316,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (кабардино-черкесский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020316'
                                },
                                {
                                    id: 20020317,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (кабардино-черкесский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020317'
                                },
                                {
                                    id: 20020318,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (калмыцкий) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020318'
                                },
                                {
                                    id: 20020319,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (карачаевский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020319'
                                },
                                {
                                    id: 20020320,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (карельский) язык (ливвиковское наречие)»',
                                    childrenLinks: [],
                                    url: '/sections/20020320'
                                },
                                {
                                    id: 20020321,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (карельский) язык (собственно карельское наречие)»',
                                    childrenLinks: [],
                                    url: '/sections/20020321'
                                },
                                {
                                    id: 20020322,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (коми) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020322'
                                },
                                {
                                    id: 20020323,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (коми) язык Республики Коми»',
                                    childrenLinks: [],
                                    url: '/sections/20020323'
                                },
                                {
                                    id: 20020324,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (коми-пермяцкий) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020324'
                                },
                                {
                                    id: 20020325,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (крымскотатарский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020325'
                                },
                                {
                                    id: 20020326,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (крымскотатарский) язык Республики Крым»',
                                    childrenLinks: [],
                                    url: '/sections/20020326'
                                },
                                {
                                    id: 20020327,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (кумыкский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020327'
                                },
                                {
                                    id: 20020328,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (лакский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020328'
                                },
                                {
                                    id: 20020329,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (лезгинский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020329'
                                },
                                {
                                    id: 20020330,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (марийский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020330'
                                },
                                {
                                    id: 20020331,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (марийский (горный, луговой) язык Республики Марий Эл»',
                                    childrenLinks: [],
                                    url: '/sections/20020331'
                                },
                                {
                                    id: 20020332,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (мокшанский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020332'
                                },
                                {
                                    id: 20020333,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (нанайский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020333'
                                },
                                {
                                    id: 20020334,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (ненецкий) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020334'
                                },
                                {
                                    id: 20020335,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (ненецкий) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020335'
                                },
                                {
                                    id: 20020336,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (ногайский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020336'
                                },
                                {
                                    id: 20020337,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (осетинский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020337'
                                },
                                {
                                    id: 200203371,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (табасаранская) язык»',
                                    childrenLinks: [],
                                    url: '/sections/200203371'
                                },
                                {
                                    id: 20020338,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (осетинский) язык Республики Северная Осетия-Алания»',
                                    childrenLinks: [],
                                    url: '/sections/20020338'
                                },
                                {
                                    id: 20020339,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (селькупский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020339'
                                },
                                {
                                    id: 20020340,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (табасаранский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020340'
                                },
                                {
                                    id: 200203401,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (татарский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/200203401'
                                },
                                {
                                    id: 20020341,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (татарский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020341'
                                },
                                {
                                    id: 20020342,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (татарский) язык Республики Татарстан»',
                                    childrenLinks: [],
                                    url: '/sections/20020342'
                                },
                                {
                                    id: 20020343,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (тувинский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020343'
                                },
                                {
                                    id: 20020344,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (удмуртский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020344'
                                },
                                {
                                    id: 20020345,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (удмуртский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020345'
                                },
                                // {
                                //     id: 20020346,
                                //     parentId: 200203,
                                //     name: 'Федеральная рабочая программа по учебному предмету «Родной (украинский) язык»',
                                //     childrenLinks: [],
                                //     url: '/sections/20020346'
                                // },
                                {
                                    id: 20020347,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (финский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020347'
                                },
                                {
                                    id: 20020348,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (хакасский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020348'
                                },
                                {
                                    id: 20020349,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (хакасский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020349'
                                },
                                {
                                    id: 20020350,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (хакасский) язык Республики Хакасия»',
                                    childrenLinks: [],
                                    url: '/sections/20020350'
                                },
                                {
                                    id: 20020351,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (хантыйский) язык (шурышкарский диалект)»',
                                    childrenLinks: [],
                                    url: '/sections/20020351'
                                },
                                {
                                    id: 20020352,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (черкесский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020352'
                                },
                                {
                                    id: 20020353,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (чеченский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020353'
                                },
                                {
                                    id: 20020354,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (чувашский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020354'
                                },
                                {
                                    id: 20020355,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (чувашский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020355'
                                },
                                {
                                    id: 20020356,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (чувашский) язык Чувашской Республики – Чувашии»',
                                    childrenLinks: [],
                                    url: '/sections/20020356'
                                },
                                {
                                    id: 200203561,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (чукотский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/200203561'
                                },
                                {
                                    id: 20020357,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (эвенкийский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020357'
                                },
                                {
                                    id: 20020358,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (эвенский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020358'
                                },
                                {
                                    id: 20020359,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (эрзянский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020359'
                                },
                                {
                                    id: 20020360,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (лесной юкагирский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020360'
                                },
                                {
                                    id: 20020361,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (тундренный юкагирский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020361'
                                },
                                {
                                    id: 20020362,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (якутский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/20020362'
                                },
                                {
                                    id: 20020363,
                                    parentId: 200203,
                                    name: 'Федеральная рабочая программа по учебному предмету «Государственный язык (саха) Республики Саха (Якутия)»',
                                    childrenLinks: [],
                                    url: '/sections/20020363'
                                }

                            ],
                            url: '/sections/200203'
                        },
                        {
                            id: 200204,
                            parentId: 2002,
                            name: 'Федеральные рабочие программы по учебному предмету «Литература на родном языке».',
                            childrenLinks: [
                                {
                                    id: 20020401,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (русская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020401'
                                },
                                {
                                    id: 20020402,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (абазинская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020402'
                                },
                                {
                                    id: 20020403,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (аварская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020403'
                                },
                                {
                                    id: 20020404,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (адыгейская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020404'
                                },
                                {
                                    id: 20020405,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (алтайская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020405'
                                },
                                {
                                    id: 20020406,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (балкарская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020406'
                                },
                                {
                                    id: 20020407,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (башкирская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020407'
                                },
                                {
                                    id: 20020408,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (башкирская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020408'
                                },
                                {
                                    id: 20020409,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (бурятская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020409'
                                },
                                {
                                    id: 20020410,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (вепсская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020410'
                                },
                                {
                                    id: 20020411,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (даргинская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020411'
                                },
                                {
                                    id: 20020412,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (долганская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020412'
                                },
                                {
                                    id: 20020413,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (ингушская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020413'
                                },
                                {
                                    id: 20020414,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (кабардино-черкесская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020414'
                                },
                                {
                                    id: 20020415,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (калмыцкая) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020415'
                                },
                                {
                                    id: 20020416,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (карачаевская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020416'
                                },
                                {
                                    id: 20020417,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (карельская) литература (ливвиковское наречие)»',
                                    childrenLinks: [],
                                    url: '/sections/20020417'
                                },
                                {
                                    id: 20020418,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (карельская) литература (собственно карельское наречие)»',
                                    childrenLinks: [],
                                    url: '/sections/20020418'
                                },
                                {
                                    id: 20020419,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (коми) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020419'
                                },
                                {
                                    id: 20020420,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (коми-пермяцкая) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020420'
                                },
                                {
                                    id: 20020421,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (крымскотатарская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020421'
                                },
                                {
                                    id: 20020422,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (кумыкская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020422'
                                },
                                {
                                    id: 20020423,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (лакская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020423'
                                },
                                {
                                    id: 20020424,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (лезгинская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020424'
                                },
                                {
                                    id: 20020425,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (марийская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020425'
                                },
                                {
                                    id: 20020426,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (мордовская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020426'
                                },
                                {
                                    id: 20020427,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (нанайская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020427'
                                },
                                {
                                    id: 20020428,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (ненецкая) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020428'
                                },
                                {
                                    id: 20020429,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (ненецкая) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020429'
                                },
                                {
                                    id: 20020430,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (ногайская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020430'
                                },
                                {
                                    id: 20020431,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (осетинская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020431'
                                },
                                {
                                    id: 200204311,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (табасаранская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/200204311'
                                },
                                {
                                    id: 20020432,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (татарская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020432'
                                },
                                {
                                    id: 20020433,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (татарская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020433'
                                },
                                {
                                    id: 20020434,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (тувинская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020434'
                                },
                                {
                                    id: 20020435,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (удмуртская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020435'
                                },
                                // {
                                //     id: 20020436,
                                //     parentId: 200204,
                                //     name: 'Федеральная рабочая программа по учебному предмету «Родная (украинская) литература»',
                                //     childrenLinks: [],
                                //     url: '/sections/20020436'
                                // },
                                {
                                    id: 20020437,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (финская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020437'
                                },
                                {
                                    id: 20020438,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (хакасская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020438'
                                },
                                {
                                    id: 20020439,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (хакасская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020439'
                                },
                                {
                                    id: 20020440,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (хантыйская) литература (шурышкарский диалект)»',
                                    childrenLinks: [],
                                    url: '/sections/20020440'
                                },
                                {
                                    id: 20020441,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (черкесская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020441'
                                },
                                {
                                    id: 20020442,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (чеченская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020442'
                                },
                                {
                                    id: 20020443,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (чувашская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020443'
                                },
                                {
                                    id: 20020444,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (чувашская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020444'
                                },
                                {
                                    id: 20020445,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (эвенкийская) литература».',
                                    childrenLinks: [],
                                    url: '/sections/20020445'
                                },
                                {
                                    id: 20020446,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (эвенская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020446'
                                },
                                {
                                    id: 20020447,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (юкагирская) литература (на лесном юкагирском языке)»',
                                    childrenLinks: [],
                                    url: '/sections/20020447'
                                },
                                {
                                    id: 20020448,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (юкагирская) литература (на тундренном юкагирском языке)»',
                                    childrenLinks: [],
                                    url: '/sections/20020448'
                                },
                                {
                                    id: 20020449,
                                    parentId: 200204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (якутская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/20020449'
                                }
                            ],
                            url: '/sections/200204'
                        },
                        {
                            id: 200205,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Иностранный (английский) язык»',
                            childrenLinks: [],
                            url: '/sections/200205'
                        },
                        {
                            id: 200206,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Иностранный (немецкий) язык»',
                            childrenLinks: [],
                            url: '/sections/200206'
                        },
                        {
                            id: 200207,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Иностранный (французский) язык»',
                            childrenLinks: [],
                            url: '/sections/200207'
                        },
                        {
                            id: 200208,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Иностранный (испанский) язык»',
                            childrenLinks: [],
                            url: '/sections/200208'
                        },
                        {
                            id: 200209,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Иностранный (китайский) язык»',
                            childrenLinks: [],
                            url: '/sections/200209'
                        },
                        {
                            id: 200210,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (английский) язык»',
                            childrenLinks: [],
                            url: '/sections/200210'
                        },
                        {
                            id: 200211,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (немецкий) язык»',
                            childrenLinks: [],
                            url: '/sections/200211'
                        },
                        {
                            id: 200212,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (французский) язык»',
                            childrenLinks: [],
                            url: '/sections/200212'
                        },
                        {
                            id: 200213,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (испанский) язык»',
                            childrenLinks: [],
                            url: '/sections/200213'
                        },
                        {
                            id: 200214,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (китайский) язык»',
                            childrenLinks: [],
                            url: '/sections/200214'
                        },
                        {
                            id: 200215,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Математика» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/200215'
                        },
                        {
                            id: 200216,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Математика» (углублённый уровень)',
                            childrenLinks: [],
                            url: '/sections/200216'
                        },
                        {
                            id: 200217,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Информатика» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/200217'
                        },
                        {
                            id: 200218,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Информатика» (углублённый уровень)',
                            childrenLinks: [],
                            url: '/sections/200218'
                        },
                        {
                            id: 200219,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «История»',
                            childrenLinks: [],
                            url: '/sections/200219'
                        },
                        {
                            id: 200220,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Обществознание»',
                            childrenLinks: [],
                            url: '/sections/200220'
                        },
                        {
                            id: 200221,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «География»',
                            childrenLinks: [],
                            url: '/sections/200221'
                        },
                        {
                            id: 200222,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Физика» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/200222'
                        },
                        {
                            id: 200223,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Физика» (углублённый уровень)',
                            childrenLinks: [],
                            url: '/sections/200223'
                        },
                        {
                            id: 200224,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Химия» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/200224'
                        },
                        {
                            id: 200225,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Химия» (углубленный уровень)',
                            childrenLinks: [],
                            url: '/sections/200225'
                        },
                        {
                            id: 200226,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Биология» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/200226'
                        },
                        {
                            id: 200227,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Биология» (углублённый уровень)',
                            childrenLinks: [],
                            url: '/sections/200227'
                        },
                        {
                            id: 200229,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Изобразительное искусство»',
                            childrenLinks: [],
                            url: '/sections/200229'
                        },
                        {
                            id: 2002291,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Духовно-нравственная культура России»',
                            childrenLinks: [],
                            url: '/sections/2002291'
                        },
                        {
                            id: 200230,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Музыка»',
                            childrenLinks: [],
                            url: '/sections/200230'
                        },
                        {
                            id: 200231,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Труд (технология)»',
                            childrenLinks: [],
                            url: '/sections/200231'
                        },
                        {
                            id: 200233,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Основы безопасности и защиты Родины»',
                            childrenLinks: [],
                            url: '/sections/200233'
                        },
                        {
                            id: 200232,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа по учебному предмету «Физическая культура»',
                            childrenLinks: [],
                            url: '/sections/200232'
                        },
                        {
                            id: 200234,
                            parentId: 2002,
                            name: 'Программа формирования универсальных учебных действий',
                            childrenLinks: [],
                            url: '/sections/200234'
                        },
                        {
                            id: 200235,
                            parentId: 2002,
                            name: 'Федеральная рабочая программа воспитания',
                            childrenLinks: [],
                            url: '/sections/200235'
                        }
                    ],
                    url: '/sections/2002'
                },
                {
                    id: 2003,
                    parentId: 2,
                    name: 'IV. Организационный раздел',
                    childrenLinks: [
                        {
                            id: 2003001,
                            parentId: 2003,
                            name: 'Федеральный учебный план основного общего образования',
                            childrenLinks: [
                                {
                                    id: 20030010,
                                    parentId: 2003001,
                                    name: 'Пояснительная записка',
                                    childrenLinks: [],
                                    url: '/sections/20030010'
                                },
                                {
                                    id: 200301,
                                    parentId: 2003001,
                                    name: 'На 01.09.2024 г.',
                                    childrenLinks: [
                                        {
                                            id: 20030011,
                                            parentId: 200301,
                                            name: 'Вариант 1',
                                            childrenLinks: [],
                                            url: '/sections/20030011'
                                        },
                                        {
                                            id: 20030012,
                                            parentId: 200301,
                                            name: 'Вариант 2',
                                            childrenLinks: [],
                                            url: '/sections/20030012'
                                        },
                                        {
                                            id: 20030013,
                                            parentId: 200301,
                                            name: 'Вариант 3',
                                            childrenLinks: [],
                                            url: '/sections/20030013'
                                        },
                                        {
                                            id: 20030014,
                                            parentId: 200301,
                                            name: 'Вариант 4',
                                            childrenLinks: [],
                                            url: '/sections/20030014'
                                        },
                                        {
                                            id: 20030015,
                                            parentId: 200301,
                                            name: 'Вариант 5',
                                            childrenLinks: [],
                                            url: '/sections/20030015'
                                        },
                                        {
                                            id: 20030016,
                                            parentId: 200301,
                                            name: 'Вариант 6',
                                            childrenLinks: [],
                                            url: '/sections/20030016'
                                        }
                                    ],
                                    url: '/sections/200301'
                                },
                                {
                                    id: 200302,
                                    parentId: 2003001,
                                    name: 'На 01.09.2025 г.',
                                    childrenLinks: [
                                        {
                                            id: 200300111,
                                            parentId: 200301,
                                            name: 'Вариант 1',
                                            childrenLinks: [],
                                            url: '/sections/200300111'
                                        },
                                        {
                                            id: 200300121,
                                            parentId: 200301,
                                            name: 'Вариант 2',
                                            childrenLinks: [],
                                            url: '/sections/200300121'
                                        },
                                        {
                                            id: 200300131,
                                            parentId: 200301,
                                            name: 'Вариант 3',
                                            childrenLinks: [],
                                            url: '/sections/200300131'
                                        },
                                        {
                                            id: 200300141,
                                            parentId: 200301,
                                            name: 'Вариант 4',
                                            childrenLinks: [],
                                            url: '/sections/200300141'
                                        },
                                        {
                                            id: 200300151,
                                            parentId: 200301,
                                            name: 'Вариант 5',
                                            childrenLinks: [],
                                            url: '/sections/200300151'
                                        },
                                        {
                                            id: 200300161,
                                            parentId: 200301,
                                            name: 'Вариант 6',
                                            childrenLinks: [],
                                            url: '/sections/200300161'
                                        }
                                    ],
                                    url: '/sections/200302'
                                },
                            ],
                            url: '/sections/2003001'
                        },
                        {
                            id: 2003002,
                            parentId: 2003,
                            name: 'Федеральный календарный учебный график',
                            childrenLinks: [],
                            url: '/sections/2003002'
                        },
                        {
                            id: 2003003,
                            parentId: 2003,
                            name: 'План внеурочной деятельности',
                            childrenLinks: [],
                            url: '/sections/2003003'
                        },
                        {
                            id: 2003004,
                            parentId: 2003,
                            name: 'Федеральный календарный план воспитательной работы',
                            childrenLinks: [],
                            url: '/sections/2003004'
                        }
                    ],
                    url: '/sections/2003'
                },
            ]
        },
        {
            id: 3,
            parentId: null,
            type: PageTypes.SECTION,
            title: 'Федеральная образовательная программа среднего общего образования',
            description: 'Приказ Министерства просвещения Российской Федерации от 18.05.2023 № 371 "Об утверждении федеральной образовательной программы среднего общего образования" (Зарегистрирован 12.07.2023 № 74228)',
            filesToDownload: [
                {url: './files/soo/fop_soo.docx', downloadButtonName: 'Скачать документ'}
            ],
            childrenLinks: [
                {
                    id: 3000,
                    parentId: 3,
                    name: 'I. Общие положения',
                    childrenLinks: [],
                    url: '/sections/3000'
                },
                {
                    id: 3001,
                    parentId: 3,
                    name: 'II. Целевой раздел',
                    childrenLinks: [
                        {
                            id: 3001001,
                            parentId: 3001,
                            name: 'Пояснительная записка',
                            childrenLinks: [],
                            url: '/sections/3001001'
                        },
                        {
                            id: 3001002,
                            parentId: 3001,
                            name: 'Планируемые результаты освоения ФОП СОО',
                            childrenLinks: [],
                            url: '/sections/3001002'
                        },
                        {
                            id: 3001003,
                            parentId: 3001,
                            name: 'Система оценки достижения планируемых результатов освоения\n' +
                                'ФОП СОО',
                            childrenLinks: [],
                            url: '/sections/3001003'
                        }
                    ],
                    url: '/sections/3001'
                },
                {
                    id: 3002,
                    parentId: 3,
                    name: 'III. Содержательный раздел',
                    childrenLinks: [
                        {
                            id: 300201,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Русский язык» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/300201'
                        },
                        {
                            id: 300202,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Литература» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/300202'
                        },
                        {
                            id: 300203,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Литература» (углублённый уровень)',
                            childrenLinks: [],
                            url: '/sections/300203'
                        },
                        {
                            id: 300204,
                            parentId: 3002,
                            name: 'Федеральные рабочие программы по учебному предмету «Родной язык»',
                            childrenLinks: [
                                {
                                    id: 30020401,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной язык (русский)»',
                                    childrenLinks: [],
                                    url: '/sections/30020401'
                                },
                                {
                                    id: 30020402,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (абазинский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020402'
                                },
                                {
                                    id: 300204021,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (аварский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/300204021'
                                },
                                {
                                    id: 30020403,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (адыгейский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020403'
                                },
                                {
                                    id: 30020404,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (алтайский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020404'
                                },
                                {
                                    id: 30020405,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (балкарский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020405'
                                },
                                {
                                    id: 30020406,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (балкарский) язык».',
                                    childrenLinks: [],
                                    url: '/sections/30020406'
                                },
                                {
                                    id: 30020407,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (башкирский) язык» (базовый уровень)',
                                    childrenLinks: [],
                                    url: '/sections/30020407'
                                },
                                {
                                    id: 30020408,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (башкирский) язык Республики Башкортостан»',
                                    childrenLinks: [],
                                    url: '/sections/30020408'
                                },
                                {
                                    id: 30020409,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (бурятский) язык Республики Бурятия»',
                                    childrenLinks: [],
                                    url: '/sections/30020409'
                                },
                                {
                                    id: 30020410,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (вепсский) язык» (базовый уровень)',
                                    childrenLinks: [],
                                    url: '/sections/30020410'
                                },
                                {
                                    id: 300204101,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (даргинский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/300204101'
                                },
                                {
                                    id: 30020411,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (кабардино-черкесский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020411'
                                },
                                {
                                    id: 30020412,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (кабардино-черкесский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020412'
                                },
                                {
                                    id: 30020413,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (карачаевский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020413'
                                },
                                {
                                    id: 30020414,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (карельский) язык (ливвиковское наречие)» (базовый уровень)',
                                    childrenLinks: [],
                                    url: '/sections/30020414'
                                },
                                {
                                    id: 30020415,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (карельский) язык (собственно карельское наречие)» (базовый уровень)',
                                    childrenLinks: [],
                                    url: '/sections/30020415'
                                },
                                {
                                    id: 30020416,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (коми) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020416'
                                },
                                {
                                    id: 30020417,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (крымскотатарский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020417'
                                },
                                {
                                    id: 30020418,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (крымскотатарский) язык Республики Крым»',
                                    childrenLinks: [],
                                    url: '/sections/30020418'
                                },
                                {
                                    id: 300204181,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (кумыкский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/300204181'
                                },
                                {
                                    id: 300204182,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (лакский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/300204182'
                                },
                                {
                                    id: 300204183,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (лезгинский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/300204183'
                                },
                                {
                                    id: 30020419,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (марийский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020419'
                                },
                                {
                                    id: 30020420,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (марийский (горный, луговой) язык Республики Марий Эл»',
                                    childrenLinks: [],
                                    url: '/sections/30020420'
                                },
                                {
                                    id: 30020421,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (мокшанский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020421'
                                },
                                {
                                    id: 30020422,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (нанайский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020422'
                                },
                                {
                                    id: 30020423,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (ногайский) язык» (базовый уровень)',
                                    childrenLinks: [],
                                    url: '/sections/30020423'
                                },
                                {
                                    id: 30020424,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (осетинский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020424'
                                },
                                {
                                    id: 30020425,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (осетинский) язык Республики Северная Осетия – Алания»',
                                    childrenLinks: [],
                                    url: '/sections/30020425'
                                },
                                {
                                    id: 300204251,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (табасаранский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/300204251'
                                },
                                {
                                    id: 30020426,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (татарский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020426'
                                },
                                {
                                    id: 30020427,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (татарский) язык Республики Татарстан»',
                                    childrenLinks: [],
                                    url: '/sections/30020427'
                                },
                                {
                                    id: 30020428,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (тувинский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020428'
                                },
                                {
                                    id: 30020429,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (удмуртский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020429'
                                },
                                {
                                    id: 30020430,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (удмуртский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020430'
                                },
                                // {
                                //     id: 30020431,
                                //     parentId: 300204,
                                //     name: 'Федеральная рабочая программа по учебному предмету «Родной (украинский) язык»',
                                //     childrenLinks: [],
                                //     url: '/sections/30020431'
                                // },
                                {
                                    id: 30020432,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (финский) язык» (базовый уровень)',
                                    childrenLinks: [],
                                    url: '/sections/30020432'
                                },
                                {
                                    id: 30020433,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (хакасский) язык» (базовый уровень)',
                                    childrenLinks: [],
                                    url: '/sections/30020433'
                                },
                                {
                                    id: 30020434,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (хакасский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020434'
                                },
                                {
                                    id: 30020435,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (хантыйский) язык (шурышкарский диалект)»',
                                    childrenLinks: [],
                                    url: '/sections/30020435'
                                },
                                {
                                    id: 30020436,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (черкесский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020436'
                                },
                                {
                                    id: 30020437,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (чеченский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020437'
                                },
                                {
                                    id: 30020438,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (чувашский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020438'
                                },
                                {
                                    id: 30020439,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (чувашский) язык Чувашской Республики – Чувашии»',
                                    childrenLinks: [],
                                    url: '/sections/30020439'
                                },
                                {
                                    id: 30020440,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (эрзянский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020440'
                                },
                                {
                                    id: 30020441,
                                    parentId: 300204,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родной (якутский) язык»',
                                    childrenLinks: [],
                                    url: '/sections/30020441'
                                }
                            ],
                            url: '/sections/300204'
                        },
                        {
                            id: 300205,
                            parentId: 3002,
                            name: 'Федеральные рабочие программы по учебному предмету «Литература на родном языке»',
                            childrenLinks: [
                                {
                                    id: 30020501,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная литература (русская)»',
                                    childrenLinks: [],
                                    url: '/sections/30020501'
                                },
                                {
                                    id: 30020502,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (абазинская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020502'
                                },
                                {
                                    id: 300205021,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (аварская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/300205021'
                                },
                                {
                                    id: 30020503,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (адыгейская) литература».',
                                    childrenLinks: [],
                                    url: '/sections/30020503'
                                },
                                {
                                    id: 30020504,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (алтайская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020504'
                                },
                                {
                                    id: 30020505,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (балкарская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020505'
                                },
                                {
                                    id: 30020506,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (башкирская) литература» (базовый уровень)',
                                    childrenLinks: [],
                                    url: '/sections/30020506'
                                },
                                {
                                    id: 30020507,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (бурятская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020507'
                                },
                                {
                                    id: 30020508,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (вепсская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020508'
                                },
                                {
                                    id: 300205081,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (даргинская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/300205081'
                                },
                                {
                                    id: 30020509,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (ингушская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020509'
                                },
                                {
                                    id: 30020510,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (кабардино-черкесская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020510'
                                },
                                {
                                    id: 30020511,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (калмыцкая) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020511'
                                },
                                {
                                    id: 30020512,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (карачаевская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020512'
                                },
                                {
                                    id: 30020513,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (карельская) литература (ливвиковское наречие)»',
                                    childrenLinks: [],
                                    url: '/sections/30020513'
                                },
                                {
                                    id: 30020514,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (карельская) литература (собственно карельское наречие)»',
                                    childrenLinks: [],
                                    url: '/sections/30020514'
                                },
                                {
                                    id: 30020515,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (коми) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020515'
                                },
                                {
                                    id: 30020516,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (крымскотатарская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020516'
                                },
                                {
                                    id: 300205161,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (кумыкская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/300205161'
                                },
                                {
                                    id: 300205162,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (лакская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/300205162'
                                },
                                {
                                    id: 300205163,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (лезгинская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/300205163'
                                },
                                {
                                    id: 30020517,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (марийская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020517'
                                },
                                {
                                    id: 30020518,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (мордовская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020518'
                                },
                                {
                                    id: 30020519,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (нанайская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020519'
                                },
                                {
                                    id: 30020520,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (ногайская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020520'
                                },
                                {
                                    id: 30020521,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (осетинская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020521'
                                },
                                {
                                    id: 300205211,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (табасаранская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/300205211'
                                },
                                {
                                    id: 30020522,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (татарская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020522'
                                },
                                {
                                    id: 30020523,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (тувинская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020523'
                                },
                                {
                                    id: 30020524,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (удмуртская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020524'
                                },
                                // {
                                //     id: 30020525,
                                //     parentId: 300205,
                                //     name: 'Федеральная рабочая программа по учебному предмету «Родная (украинская) литература»',
                                //     childrenLinks: [],
                                //     url: '/sections/30020525'
                                // },
                                {
                                    id: 30020526,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (финская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020526'
                                },
                                {
                                    id: 30020527,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (хакасская) литература (базовый уровень)',
                                    childrenLinks: [],
                                    url: '/sections/30020527'
                                },
                                {
                                    id: 30020528,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (хакасская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020528'
                                },
                                {
                                    id: 30020529,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (хантыйская) литература (шурышкарский диалект)»',
                                    childrenLinks: [],
                                    url: '/sections/30020529'
                                },
                                {
                                    id: 30020530,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (черкесская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020530'
                                },
                                {
                                    id: 30020531,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (чеченская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020531'
                                },
                                {
                                    id: 30020532,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (чувашская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020532'
                                },
                                {
                                    id: 30020533,
                                    parentId: 300205,
                                    name: 'Федеральная рабочая программа по учебному предмету «Родная (якутская) литература»',
                                    childrenLinks: [],
                                    url: '/sections/30020533'
                                }
                            ],
                            url: '/sections/300205'
                        },
                        {
                            id: 300206,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Иностранный (английский) язык (базовый уровень)»',
                            childrenLinks: [],
                            url: '/sections/300206'
                        },
                        {
                            id: 300207,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Английский язык» (углублённый уровень)',
                            childrenLinks: [],
                            url: '/sections/300207'
                        },
                        {
                            id: 300208,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Иностранный (немецкий) язык (базовый уровень)»',
                            childrenLinks: [],
                            url: '/sections/300208'
                        },
                        {
                            id: 300209,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Иностранный (немецкий) язык (углублённый уровень)»',
                            childrenLinks: [],
                            url: '/sections/300209'
                        },
                        {
                            id: 300210,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Французский язык» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/300210'
                        },
                        {
                            id: 300211,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Французский язык» (углублённый уровень)',
                            childrenLinks: [],
                            url: '/sections/300211'
                        },
                        {
                            id: 300212,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Иностранный (испанский) язык (базовый уровень)»',
                            childrenLinks: [],
                            url: '/sections/300212'
                        },
                        {
                            id: 300213,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Иностранный (испанский) язык (углублённый уровень)»',
                            childrenLinks: [],
                            url: '/sections/300213'
                        },
                        {
                            id: 300214,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Китайский язык» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/300214'
                        },
                        {
                            id: 300215,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Китайский язык» (углублённый уровень)',
                            childrenLinks: [],
                            url: '/sections/300215'
                        },
                        {
                            id: 300216,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Английский язык. Второй иностранный язык» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/300216'
                        },
                        {
                            id: 300217,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (немецкий) язык (базовый уровень)»',
                            childrenLinks: [],
                            url: '/sections/300217'
                        },
                        {
                            id: 300218,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (французский) язык (базовый уровень)»',
                            childrenLinks: [],
                            url: '/sections/300218'
                        },
                        {
                            id: 300219,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (испанский) язык (базовый уровень)»',
                            childrenLinks: [],
                            url: '/sections/300219'
                        },
                        {
                            id: 300220,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Китайский язык. Второй иностранный язык» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/300220'
                        },
                        {
                            id: 300221,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Математика» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/300221'
                        },
                        {
                            id: 300222,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Математика» (углублённый уровень)',
                            childrenLinks: [],
                            url: '/sections/300222'
                        },
                        {
                            id: 300223,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Информатика» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/300223'
                        },
                        {
                            id: 300224,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Информатика» (углублённый уровень)',
                            childrenLinks: [],
                            url: '/sections/300224'
                        },
                        {
                            id: 300225,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Физика» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/300225'
                        },
                        {
                            id: 300226,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Физика» (углублённый уровень)',
                            childrenLinks: [],
                            url: '/sections/300226'
                        },
                        {
                            id: 300227,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Химия» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/300227'
                        },
                        {
                            id: 300228,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Химия» (углублённый уровень)',
                            childrenLinks: [],
                            url: '/sections/300228'
                        },
                        {
                            id: 300229,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Биология» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/300229'
                        },
                        {
                            id: 300230,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Биология» (углублённый уровень)',
                            childrenLinks: [],
                            url: '/sections/300230'
                        },
                        {
                            id: 300231,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «История» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/300231'
                        },
                        {
                            id: 3002311,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «История» (базовый уровень) (вступает в силу с 01 сентября 2025 года)',
                            childrenLinks: [],
                            url: '/sections/3002311'
                        },
                        {
                            id: 300232,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «История» (углублённый уровень)',
                            childrenLinks: [],
                            url: '/sections/300232'
                        },
                        {
                            id: 300233,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Обществознание» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/300233'
                        },
                        {
                            id: 3002331,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Обществознание» (базовый уровень) (вступает в силу с 01 сентября 2025 года) ',
                            childrenLinks: [],
                            url: '/sections/3002331'
                        },
                        {
                            id: 300234,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Обществознание» (углублённый уровень)',
                            childrenLinks: [],
                            url: '/sections/300234'
                        },
                        {
                            id: 300235,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «География» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/300235'
                        },
                        {
                            id: 300236,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «География» (углублённый уровень)',
                            childrenLinks: [],
                            url: '/sections/300236'
                        },
                        {
                            id: 300237,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Физическая культура»',
                            childrenLinks: [],
                            url: '/sections/300237'
                        },
                        {
                            id: 300238,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа по учебному предмету «Основы безопасности и защиты Родины» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/300238'
                        },
                        {
                            id: 300239,
                            parentId: 3002,
                            name: 'Программа формирования универсальных учебных действий',
                            childrenLinks: [],
                            url: '/sections/300239'
                        },
                        {
                            id: 300240,
                            parentId: 3002,
                            name: 'Федеральная рабочая программа воспитания',
                            childrenLinks: [],
                            url: '/sections/300240'
                        }
                    ],
                    url: '/sections/3002'
                },
                {
                    id: 3003,
                    parentId: 3,
                    name: 'IV. Организационный раздел',
                    childrenLinks: [
                        {
                            id: 3003001,
                            parentId: 3003,
                            name: 'Федеральный учебный план среднего общего образования',
                            childrenLinks: [
                                {
                                    id: 30030010,
                                    parentId: 3003001,
                                    name: 'Пояснительная записка',
                                    childrenLinks: [],
                                    url: '/sections/30030010'
                                },
                                {
                                    id: 300300111,
                                    parentId: 300302,
                                    name: 'Технологический профиль',
                                    childrenLinks: [
                                        {
                                            id: 30030011011,
                                            parentId: 300300111,
                                            name: 'Пример учебного плана технологического (инженерного) и агротехнологического профилей (с углубленным изучением математики и физики) (вариант 1)',
                                            childrenLinks: [],
                                            url: '/sections/30030011011'
                                        },
                                        {
                                            id: 30030011021,
                                            parentId: 300300111,
                                            name: 'Пример учебного плана технологического (информационно-технологического) профиля (с углубленным изучением математики и информатики) (вариант 2)',
                                            childrenLinks: [],
                                            url: '/sections/30030011021'
                                        }
                                    ],
                                    url: '/sections/300300111'
                                },
                                {
                                    id: 300300121,
                                    parentId: 300302,
                                    name: 'Естественно-научный и агротехнологический профили',
                                    childrenLinks: [
                                        {
                                            id: 30030012011,
                                            parentId: 300300121,
                                            name: 'Пример учебного плана естественно-научного и агротехнологического профилей',
                                            childrenLinks: [],
                                            url: '/sections/30030012011'
                                        }
                                    ],
                                    url: '/sections/300300121'
                                },
                                {
                                    id: 300300131,
                                    parentId: 300302,
                                    name: 'Гуманитарный профиль',
                                    childrenLinks: [
                                        {
                                            id: 30030013011,
                                            parentId: 300300131,
                                            name: 'Пример учебного плана гуманитарного профиля (вариант 1)',
                                            childrenLinks: [],
                                            url: '/sections/30030013011'
                                        },
                                        {
                                            id: 30030013021,
                                            parentId: 300300131,
                                            name: 'Пример учебного плана гуманитарного профиля (вариант 2)',
                                            childrenLinks: [],
                                            url: '/sections/30030013021'
                                        },
                                        {
                                            id: 30030013031,
                                            parentId: 300300131,
                                            name: 'Пример учебного плана гуманитарного профиля (вариант 3)',
                                            childrenLinks: [],
                                            url: '/sections/30030013031'
                                        },
                                        {
                                            id: 30030013041,
                                            parentId: 300300131,
                                            name: 'Пример учебного плана гуманитарного профиля (вариант 4)',
                                            childrenLinks: [],
                                            url: '/sections/30030013041'
                                        },
                                        {
                                            id: 30030013051,
                                            parentId: 300300131,
                                            name: 'Пример учебного плана гуманитарного профиля (вариант 5)',
                                            childrenLinks: [],
                                            url: '/sections/30030013051'
                                        },
                                        {
                                            id: 30030013061,
                                            parentId: 300300131,
                                            name: 'Пример учебного плана гуманитарного профиля (вариант 6)',
                                            childrenLinks: [],
                                            url: '/sections/30030013061'
                                        }
                                    ],
                                    url: '/sections/300300131'
                                },
                                {
                                    id: 300300141,
                                    parentId: 300302,
                                    name: 'Социально-экономический профиль',
                                    childrenLinks: [
                                        {
                                            id: 30030014011,
                                            parentId: 300300141,
                                            name: 'Пример учебного плана социально-экономического профиля (вариант 1)',
                                            childrenLinks: [],
                                            url: '/sections/30030014011'
                                        },
                                        {
                                            id: 30030014021,
                                            parentId: 300300141,
                                            name: 'Пример учебного плана социально-экономического профиля (вариант 2)',
                                            childrenLinks: [],
                                            url: '/sections/30030014021'
                                        },
                                        {
                                            id: 30030014031,
                                            parentId: 300300141,
                                            name: 'Пример учебного плана социально-экономического профиля (вариант 3 с углубленным изучением обществознания и географии)',
                                            childrenLinks: [],
                                            url: '/sections/30030014031'
                                        }
                                    ],
                                    url: '/sections/300300141'
                                },
                                {
                                    id: 300300151,
                                    parentId: 300302,
                                    name: 'Универсальный профиль',
                                    childrenLinks: [
                                        {
                                            id: 30030015011,
                                            parentId: 300300151,
                                            name: 'Универсальный профиль',
                                            childrenLinks: [],
                                            url: '/sections/30030015011'
                                        }
                                    ],
                                    url: '/sections/300300151'
                                },
                                {
                                    id: 300300161,
                                    parentId: 300302,
                                    name: 'Учебные планы с профильной возможностью, предусматривающие изучение государственных языков республик Российской Федерации из числа языков народов Российской Федерации',
                                    childrenLinks: [
                                        {
                                            id: 30030016011,
                                            parentId: 300300161,
                                            name: 'Пример учебного плана технологического (инженерного) профиля (с углубленным изучением математики и физики) с изучением родных языков',
                                            childrenLinks: [],
                                            url: '/sections/30030016011'
                                        },
                                        {
                                            id: 30030016021,
                                            parentId: 300300161,
                                            name: 'Пример учебного плана технологического (информационно-технологического) профиля (с углубленным изучением математики и информатики) с изучением родных языков',
                                            childrenLinks: [],
                                            url: '/sections/30030016021'
                                        },
                                        {
                                            id: 30030016031,
                                            parentId: 300300161,
                                            name: 'Пример учебного плана естественно-научного профиля с изучением родных языков',
                                            childrenLinks: [],
                                            url: '/sections/30030016031'
                                        },
                                        {
                                            id: 30030016041,
                                            parentId: 300300161,
                                            name: 'Пример учебного плана социально-экономического профиля с изучением родных языков',
                                            childrenLinks: [],
                                            url: '/sections/30030016041'
                                        },
                                        {
                                            id: 30030016051,
                                            parentId: 300300161,
                                            name: 'Пример учебного плана гуманитарного профиля с изучением родных языков',
                                            childrenLinks: [],
                                            url: '/sections/30030016051'
                                        },
                                        {
                                            id: 30030016061,
                                            parentId: 300300161,
                                            name: 'Пример учебного плана универсального профиля с изучением родных языков',
                                            childrenLinks: [],
                                            url: '/sections/30030016061'
                                        }
                                    ],
                                    url: '/sections/300300161'
                                },
                            ],
                            url: '/sections/3003001'
                        },
                        {
                            id: 3003002,
                            parentId: 3003,
                            name: 'Федеральный календарный учебный график',
                            childrenLinks: [],
                            url: '/sections/3003002'
                        },
                        {
                            id: 3003003,
                            parentId: 3003,
                            name: 'План внеурочной деятельности',
                            childrenLinks: [],
                            url: '/sections/3003003'
                        },
                        {
                            id: 3003004,
                            parentId: 3003,
                            name: 'Федеральный календарный план воспитательной работы',
                            childrenLinks: [],
                            url: '/sections/3003004'
                        }
                    ],
                    url: '/sections/3003'
                },
            ]
        },
        {
            id: 1000,
            parentId: 1,
            type: PageTypes.SECTION,
            title: 'I. Общие положения',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/I_noo.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/I_noo.pdf'
        },
        {
            id: 1001,
            parentId: 1,
            type: PageTypes.SECTION,
            title: 'II. Целевой раздел',
            childrenLinks: [
                {
                    id: 1001001,
                    parentId: 1001,
                    name: 'Пояснительная записка',
                    childrenLinks: [],
                    url: '/sections/1001001'
                },
                {
                    id: 1001002,
                    parentId: 1001,
                    name: 'Планируемые результаты освоения ФОП НОО',
                    childrenLinks: [],
                    url: '/sections/1001002'
                },
                {
                    id: 1001003,
                    parentId: 1001,
                    name: 'Система оценки достижения планируемых результатов освоения\n' +
                        'ФОП НОО',
                    childrenLinks: [],
                    url: '/sections/1001003'
                }
            ],
            filesToDownload: [{url: './files/noo/II_noo.docx', downloadButtonName: 'Скачать раздел'}]
        },
        {
            id: 1002,
            parentId: 1,
            type: PageTypes.SECTION,
            title: 'III. Содержательный раздел',
            childrenLinks: [
                {
                    id: 1002001,
                    parentId: 1002,
                    name: 'Федеральная рабочая программа по учебному предмету «Русский\n' +
                        'язык»',
                    childrenLinks: [],
                    url: '/sections/1002001'
                },
                {
                    id: 1002002,
                    parentId: 1002,
                    name: 'Федеральная рабочая программа по учебному предмету «Литературное чтение»',
                    childrenLinks: [],
                    url: '/sections/1002002'
                },
                {
                    id: 1002003,
                    parentId: 1002,
                    name: 'Федеральные рабочие программы по учебному предмету «Родной язык»',
                    childrenLinks: [
                        {
                            id: 100200301,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(русский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200301'
                        },
                        {
                            id: 100200302,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(абазинский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200302'
                        },
                        {
                            id: 100200303,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(аварский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200303'
                        },
                        {
                            id: 100200304,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(агульский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200304'
                        },
                        {
                            id: 100200305,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(адыгейский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200305'
                        },
                        {
                            id: 100200306,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(алтайский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200306'
                        },
                        {
                            id: 100200307,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(балкарский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200307'
                        },
                        {
                            id: 100200308,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(балкарский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200308'
                        },
                        {
                            id: 100200309,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(башкирский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200309'
                        },
                        {
                            id: 100200310,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(башкирский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200310'
                        },
                        {
                            id: 100200311,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Государственный (башкирский) язык Республики Башкортостан»',
                            childrenLinks: [],
                            url: '/sections/100200311'
                        },
                        {
                            id: 100200312,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(бурятский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200312'
                        },
                        {
                            id: 100200313,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Государственный (бурятский) язык Республики Бурятия»',
                            childrenLinks: [],
                            url: '/sections/100200313'
                        },
                        {
                            id: 100200314,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(вепсский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200314'
                        },
                        {
                            id: 100200315,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(даргинский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200315'
                        },
                        {
                            id: 100200316,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(долганский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200316'
                        },
                        {
                            id: 100200317,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(ингушский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200317'
                        },
                        {
                            id: 100200318,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(кабардино-черкесский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200318'
                        },
                        {
                            id: 100200319,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(кабардино-черкесский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200319'
                        },
                        {
                            id: 100200320,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(калмыцкий) язык»',
                            childrenLinks: [],
                            url: '/sections/100200320'
                        },
                        {
                            id: 100200321,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(карачаевский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200321'
                        },
                        {
                            id: 100200322,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(карельский) язык (ливвиковское наречие)»',
                            childrenLinks: [],
                            url: '/sections/100200322'
                        },
                        {
                            id: 100200323,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(карельский) язык (собственно карельское наречие)»',
                            childrenLinks: [],
                            url: '/sections/100200323'
                        },
                        {
                            id: 100200324,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(коми) язык»',
                            childrenLinks: [],
                            url: '/sections/100200324'
                        },
                        {
                            id: 100200325,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Государственный (коми) язык Республики Коми»',
                            childrenLinks: [],
                            url: '/sections/100200325'
                        },
                        {
                            id: 100200326,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(коми-пермяцкий) язык»',
                            childrenLinks: [],
                            url: '/sections/100200326'
                        },
                        {
                            id: 100200327,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(корякский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200327'
                        },
                        {
                            id: 100200328,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(крымскотатарский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200328'
                        },
                        {
                            id: 100200329,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Государственный (крымскотатарский) язык Республики Крым»',
                            childrenLinks: [],
                            url: '/sections/100200329'
                        },
                        {
                            id: 100200330,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(кумыкский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200330'
                        },
                        {
                            id: 100200331,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(лакский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200331'
                        },
                        {
                            id: 100200332,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(лезгинский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200332'
                        },
                        {
                            id: 100200333,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(марийский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200333'
                        },
                        {
                            id: 100200334,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Государственный (марийский (горный, луговой) язык Республики\n' +
                                'Марий Эл»',
                            childrenLinks: [],
                            url: '/sections/100200334'
                        },
                        {
                            id: 100200335,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(мокшанский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200335'
                        },
                        {
                            id: 100200336,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(нанайский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200336'
                        },
                        {
                            id: 100200337,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(негидальский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200337'
                        },
                        {
                            id: 100200338,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(ненецкий) язык»',
                            childrenLinks: [],
                            url: '/sections/100200338'
                        },
                        {
                            id: 100200339,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(ненецкий) язык»',
                            childrenLinks: [],
                            url: '/sections/100200339'
                        },
                        {
                            id: 100200340,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(нивхский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200340'
                        },
                        {
                            id: 100200341,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(ногайский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200341'
                        },
                        {
                            id: 100200342,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(осетинский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200342'
                        },
                        {
                            id: 100200343,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Государственный (осетинский) язык Республики Северная Осетия-\n' +
                                'Алания»',
                            childrenLinks: [],
                            url: '/sections/100200343'
                        },
                        {
                            id: 100200344,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(селькупский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200344'
                        },
                        {
                            id: 100200345,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(табасаранский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200345'
                        },
                        {
                            id: 100200346,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(татарский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200346'
                        },
                        {
                            id: 100200347,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(татарский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200347'
                        },
                        {
                            id: 100200348,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Государственный (татарский) язык Республики Татарстан»',
                            childrenLinks: [],
                            url: '/sections/100200348'
                        },
                        {
                            id: 100200349,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(телеутский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200349'
                        },
                        {
                            id: 100200350,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(телеутский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200350'
                        },
                        {
                            id: 100200351,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(тувинский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200351'
                        },
                        {
                            id: 100200352,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(удмуртский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200352'
                        },
                        {
                            id: 100200353,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(удмуртский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200353'
                        },
                        {
                            id: 100200354,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(удэгейский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200354'
                        },
                        // {
                        //     id: 100200355,
                        //     parentId: 1002003,
                        //     name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        //         '(украинский) язык»',
                        //     childrenLinks: [],
                        //     url: '/sections/100200355'
                        // },
                        {
                            id: 100200356,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(ульчский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200356'
                        },
                        {
                            id: 100200357,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(финский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200357'
                        },
                        {
                            id: 100200358,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(хакасский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200358'
                        },
                        {
                            id: 100200359,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(хакасский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200359'
                        },
                        {
                            id: 100200360,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Государственный (хакасский) язык Республики Хакасия»',
                            childrenLinks: [],
                            url: '/sections/100200360'
                        },
                        {
                            id: 100200361,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(хантыйский) язык (шурышкарский диалект)»',
                            childrenLinks: [],
                            url: '/sections/100200361'
                        },
                        {
                            id: 100200362,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(цахурский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200362'
                        },
                        {
                            id: 100200363,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(черкесский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200363'
                        },
                        {
                            id: 100200364,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(чеченский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200364'
                        },
                        {
                            id: 100200365,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(чувашский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200365'
                        },
                        {
                            id: 100200366,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(чувашский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200366'
                        },
                        {
                            id: 100200367,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Государственный (чувашский) язык Чувашской Республики –\n' +
                                'Чувашии»',
                            childrenLinks: [],
                            url: '/sections/100200367'
                        },
                        {
                            id: 1002003672,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (чукотский) язык»',
                            childrenLinks: [],
                            url: '/sections/1002003672'
                        },
                        {
                            id: 1002003671,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (шорский) язык»',
                            childrenLinks: [],
                            url: '/sections/1002003671'
                        },
                        {
                            id: 100200368,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(эвенкийский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200368'
                        },
                        {
                            id: 100200369,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(эвенкийский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200369'
                        },
                        {
                            id: 100200370,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(эвенский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200370'
                        },
                        {
                            id: 100200371,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(энецкий) язык»',
                            childrenLinks: [],
                            url: '/sections/100200371'
                        },
                        {
                            id: 100200372,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(эрзянский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200372'
                        },
                        {
                            id: 100200373,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(лесной юкагирский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200373'
                        },
                        {
                            id: 100200374,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(тундренный юкагирский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200374'
                        },
                        {
                            id: 100200375,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                                '(якутский) язык»',
                            childrenLinks: [],
                            url: '/sections/100200375'
                        },
                        {
                            id: 100200376,
                            parentId: 1002003,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Государственный язык (саха) Республики Саха (Якутия)»',
                            childrenLinks: [],
                            url: '/sections/100200376'
                        }
                    ],
                    url: '/sections/1002003'
                },
                {
                    id: 1002004,
                    parentId: 1002,
                    name: 'Федеральные рабочие программы по учебному предмету «Литературное чтение на родном языке»',
                    childrenLinks: [
                        {
                            id: 100200401,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (русском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200401'
                        },
                        {
                            id: 100200402,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (абазинском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200402'
                        },
                        {
                            id: 100200403,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (аварском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200403'
                        },
                        {
                            id: 100200404,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (агульском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200404'
                        },
                        {
                            id: 100200405,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (адыгейском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200405'
                        },
                        {
                            id: 100200406,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (алтайском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200406'
                        },
                        {
                            id: 100200407,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (балкарском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200407'
                        },
                        {
                            id: 100200408,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (башкирском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200408'
                        },
                        {
                            id: 100200409,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (башкирском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200409'
                        },
                        {
                            id: 100200410,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (бурятском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200410'
                        },
                        {
                            id: 100200411,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (вепсском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200411'
                        },
                        {
                            id: 100200412,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (даргинском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200412'
                        },
                        {
                            id: 100200413,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (долганском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200413'
                        },
                        {
                            id: 1002004131,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету «Литературное чтение на родном (ингушском) языке»',
                            childrenLinks: [],
                            url: '/sections/1002004131'
                        },
                        {
                            id: 100200414,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (кабардино-черкесском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200414'
                        },
                        {
                            id: 100200415,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (калмыцком) языке»',
                            childrenLinks: [],
                            url: '/sections/100200415'
                        },
                        {
                            id: 100200416,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (карачаевском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200416'
                        },
                        {
                            id: 100200417,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (карельском) языке (ливвиковское\n' +
                                'наречие)».',
                            childrenLinks: [],
                            url: '/sections/100200417'
                        },
                        {
                            id: 100200418,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (карельском) языке (собственно\n' +
                                'карельское наречие)»',
                            childrenLinks: [],
                            url: '/sections/100200418'
                        },
                        {
                            id: 100200419,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (коми) языке»',
                            childrenLinks: [],
                            url: '/sections/100200419'
                        },
                        {
                            id: 100200420,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (коми-пермяцком) языке»',
                            childrenLinks: [],
                            url: '/sections/100200420'
                        },
                        {
                            id: 100200421,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (крымскотатарском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200421'
                        },
                        {
                            id: 100200422,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (кумыкском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200422'
                        },
                        {
                            id: 100200423,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (лакском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200423'
                        },
                        {
                            id: 100200424,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (лезгинском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200424'
                        },
                        {
                            id: 100200425,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (марийском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200425'
                        },
                        {
                            id: 100200426,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (мокшанском, эрзянском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200426'
                        },
                        {
                            id: 1002004261,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету «Литературное чтение на родном (нанайском) языке»',
                            childrenLinks: [],
                            url: '/sections/1002004261'
                        },
                        {
                            id: 100200427,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (негидальском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200427'
                        },
                        {
                            id: 100200428,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (ненецком) языке»',
                            childrenLinks: [],
                            url: '/sections/100200428'
                        },
                        {
                            id: 100200429,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (ненецком) языке»',
                            childrenLinks: [],
                            url: '/sections/100200429'
                        },
                        {
                            id: 100200430,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (нивхском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200430'
                        },
                        {
                            id: 100200431,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (ногайском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200431'
                        },
                        {
                            id: 100200432,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (осетинском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200432'
                        },
                        {
                            id: 100200433,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (селькупском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200433'
                        },
                        {
                            id: 100200434,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (табасаранском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200434'
                        },
                        {
                            id: 100200435,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (татарском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200435'
                        },
                        {
                            id: 100200436,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (татарском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200436'
                        },
                        {
                            id: 100200437,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (телеутском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200437'
                        },
                        {
                            id: 100200438,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (тувинском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200438'
                        },
                        {
                            id: 100200439,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (удмуртском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200439'
                        },
                        {
                            id: 100200440,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (удэгейском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200440'
                        },
                        // {
                        //     id: 100200441,
                        //     parentId: 1002004,
                        //     name: 'Федеральная рабочая программа по учебному предмету\n' +
                        //         '«Литературное чтение на родном (украинском) языке»',
                        //     childrenLinks: [],
                        //     url: '/sections/100200441'
                        // },
                        {
                            id: 100200442,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (ульчском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200442'
                        },
                        {
                            id: 100200443,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (финском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200443'
                        },
                        {
                            id: 1002004431,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (хакасском) языке»',
                            childrenLinks: [],
                            url: '/sections/1002004431'
                        },
                        {
                            id: 100200444,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (хакасском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200444'
                        },
                        {
                            id: 1002004441,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (хантыйском) языке (шурышкарский диалект)',
                            childrenLinks: [],
                            url: '/sections/1002004441'
                        },
                        {
                            id: 100200445,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (цахурском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200445'
                        },
                        {
                            id: 100200446,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (черкесском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200446'
                        },
                        {
                            id: 100200447,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (чеченском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200447'
                        },
                        {
                            id: 100200448,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (чувашском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200448'
                        },
                        {
                            id: 100200449,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (чувашском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200449'
                        },
                        {
                            id: 100200450,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (эвенкийском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200450'
                        },
                        {
                            id: 1002004501,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету «Литературное чтение на родном (эвенском) языке»',
                            childrenLinks: [],
                            url: '/sections/1002004501'
                        },
                        {
                            id: 100200451,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (лесном юкагирском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200451'
                        },
                        {
                            id: 100200452,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (тундренном юкагирском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200452'
                        },
                        {
                            id: 100200453,
                            parentId: 1002004,
                            name: 'Федеральная рабочая программа по учебному предмету\n' +
                                '«Литературное чтение на родном (якутском) языке»',
                            childrenLinks: [],
                            url: '/sections/100200453'
                        }
                    ],
                    url: '/sections/1002004'
                },
                {
                    id: 1002005,
                    parentId: 1002,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Иностранный (английский) язык»',
                    childrenLinks: [],
                    url: '/sections/1002005'
                },
                {
                    id: 1002006,
                    parentId: 1002,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Иностранный (немецкий) язык»',
                    childrenLinks: [],
                    url: '/sections/1002006'
                },
                {
                    id: 1002007,
                    parentId: 1002,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Иностранный (французский) язык»',
                    childrenLinks: [],
                    url: '/sections/1002007'
                },
                {
                    id: 1002008,
                    parentId: 1002,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Иностранный (испанский) язык»',
                    childrenLinks: [],
                    url: '/sections/1002008'
                },
                {
                    id: 1002009,
                    parentId: 1002,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Иностранный (китайский) язык»',
                    childrenLinks: [],
                    url: '/sections/1002009'
                },
                {
                    id: 1002010,
                    parentId: 1002,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Математика»',
                    childrenLinks: [],
                    url: '/sections/1002010'
                },
                {
                    id: 1002011,
                    parentId: 1002,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Окружающий мир»',
                    childrenLinks: [],
                    url: '/sections/1002011'
                },
                {
                    id: 10020111,
                    parentId: 1002,
                    name: 'Федеральная рабочая программа по учебному предмету «Основы\n' +
                        'религиозных культур и светской этики»',
                    childrenLinks: [],
                    url: '/sections/10020111'
                },
                {
                    id: 1002012,
                    parentId: 1002,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Изобразительное искусство»',
                    childrenLinks: [],
                    url: '/sections/1002012'
                },
                {
                    id: 1002013,
                    parentId: 1002,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Музыка»',
                    childrenLinks: [],
                    url: '/sections/1002013'
                },
                {
                    id: 1002014,
                    parentId: 1002,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Труд (технология)»',
                    childrenLinks: [],
                    url: '/sections/1002014'
                },
                {
                    id: 1002015,
                    parentId: 1002,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Физическая культура»',
                    childrenLinks: [],
                    url: '/sections/1002015'
                },
                {
                    id: 1002016,
                    parentId: 1002,
                    name: 'Программа формирования универсальных учебных действий',
                    childrenLinks: [],
                    url: '/sections/1002016'
                },
                {
                    id: 1002017,
                    parentId: 1002,
                    name: 'Федеральная рабочая программа воспитания',
                    childrenLinks: [],
                    url: '/sections/1002017'
                }
            ],
            filesToDownload: [{url: './files/noo/III_noo.docx', downloadButtonName: 'Скачать раздел'}]
        },
        {
            id: 1003,
            parentId: 1,
            type: PageTypes.SECTION,
            title: 'IV. Организационный раздел',
            childrenLinks: [
                {
                    id: 1003001,
                    parentId: 1003,
                    name: 'Федеральный учебный план начального общего образования',
                    childrenLinks: [
                        {
                            id: 10030010,
                            parentId: 1003001,
                            name: 'Пояснительная записка',
                            childrenLinks: [],
                            url: '/sections/10030010'
                        },
                        {
                            id: 10030011,
                            parentId: 1003001,
                            name: 'Вариант 1',
                            childrenLinks: [],
                            url: '/sections/10030011'
                        },
                        {
                            id: 10030012,
                            parentId: 1003001,
                            name: 'Вариант 2',
                            childrenLinks: [],
                            url: '/sections/10030012'
                        },
                        {
                            id: 10030013,
                            parentId: 1003001,
                            name: 'Вариант 3',
                            childrenLinks: [],
                            url: '/sections/10030013'
                        },
                        {
                            id: 10030014,
                            parentId: 1003001,
                            name: 'Вариант 4',
                            childrenLinks: [],
                            url: '/sections/10030014'
                        },
                        {
                            id: 10030015,
                            parentId: 1003001,
                            name: 'Вариант 5',
                            childrenLinks: [],
                            url: '/sections/10030015'
                        }
                    ],
                    url: '/sections/1003001'
                },
                {
                    id: 1003002,
                    parentId: 1003,
                    name: 'Федеральный календарный учебный график',
                    childrenLinks: [],
                    url: '/sections/1003002'
                },
                {
                    id: 1003003,
                    parentId: 1003,
                    name: 'План внеурочной деятельности',
                    childrenLinks: [],
                    url: '/sections/1003003'
                },
                {
                    id: 1003004,
                    parentId: 1003,
                    name: 'Федеральный календарный план воспитательной работы',
                    childrenLinks: [],
                    url: '/sections/1003004'
                }
            ],
            filesToDownload: [{url: './files/noo/IV_noo.docx', downloadButtonName: 'Скачать раздел'}]
        },
        {
            id: 1001001,
            parentId: 1001,
            type: PageTypes.SECTION,
            title: 'Пояснительная записка',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/17.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/17.pdf'
        },
        {
            id: 1001002,
            parentId: 1001,
            type: PageTypes.SECTION,
            title: 'Планируемые результаты освоения ФОП НОО',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/18.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/18.pdf'
        },
        {
            id: 1001003,
            parentId: 1001,
            type: PageTypes.SECTION,
            title: 'Система оценки достижения планируемых результатов освоения\n' +
                'ФОП НОО',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/19.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/19.pdf'
        },
        {
            id: 1002001,
            parentId: 1002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Русский\n' +
                'язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/20.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/20.pdf'
        },
        {
            id: 1002002,
            parentId: 1002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Литературное чтение»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/21.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/21.pdf'
        },
        {
            id: 1002003,
            parentId: 1002,
            type: PageTypes.SECTION,
            title: 'Федеральные рабочие программы по учебному предмету «Родной язык»',
            childrenLinks: [
                {
                    id: 100200301,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(русский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200301'
                },
                {
                    id: 100200302,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(абазинский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200302'
                },
                {
                    id: 100200303,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(аварский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200303'
                },
                {
                    id: 100200304,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(агульский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200304'
                },
                {
                    id: 100200305,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(адыгейский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200305'
                },
                {
                    id: 100200306,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(алтайский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200306'
                },
                {
                    id: 100200307,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(балкарский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200307'
                },
                {
                    id: 100200308,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(балкарский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200308'
                },
                {
                    id: 100200309,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(башкирский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200309'
                },
                {
                    id: 100200310,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(башкирский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200310'
                },
                {
                    id: 100200311,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Государственный (башкирский) язык Республики Башкортостан»',
                    childrenLinks: [],
                    url: '/sections/100200311'
                },
                {
                    id: 100200312,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(бурятский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200312'
                },
                {
                    id: 100200313,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Государственный (бурятский) язык Республики Бурятия»',
                    childrenLinks: [],
                    url: '/sections/100200313'
                },
                {
                    id: 100200314,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(вепсский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200314'
                },
                {
                    id: 100200315,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(даргинский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200315'
                },
                {
                    id: 100200316,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(долганский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200316'
                },
                {
                    id: 100200317,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(ингушский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200317'
                },
                {
                    id: 100200318,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(кабардино-черкесский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200318'
                },
                {
                    id: 100200319,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(кабардино-черкесский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200319'
                },
                {
                    id: 100200320,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(калмыцкий) язык»',
                    childrenLinks: [],
                    url: '/sections/100200320'
                },
                {
                    id: 100200321,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(карачаевский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200321'
                },
                {
                    id: 100200322,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(карельский) язык (ливвиковское наречие)»',
                    childrenLinks: [],
                    url: '/sections/100200322'
                },
                {
                    id: 100200323,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(карельский) язык (собственно карельское наречие)»',
                    childrenLinks: [],
                    url: '/sections/100200323'
                },
                {
                    id: 100200324,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(коми) язык»',
                    childrenLinks: [],
                    url: '/sections/100200324'
                },
                {
                    id: 100200325,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Государственный (коми) язык Республики Коми»',
                    childrenLinks: [],
                    url: '/sections/100200325'
                },
                {
                    id: 100200326,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(коми-пермяцкий) язык»',
                    childrenLinks: [],
                    url: '/sections/100200326'
                },
                {
                    id: 100200327,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(корякский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200327'
                },
                {
                    id: 100200328,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(крымскотатарский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200328'
                },
                {
                    id: 100200329,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Государственный (крымскотатарский) язык Республики Крым»',
                    childrenLinks: [],
                    url: '/sections/100200329'
                },
                {
                    id: 100200330,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(кумыкский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200330'
                },
                {
                    id: 100200331,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(лакский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200331'
                },
                {
                    id: 100200332,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(лезгинский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200332'
                },
                {
                    id: 100200333,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(марийский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200333'
                },
                {
                    id: 100200334,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Государственный (марийский (горный, луговой) язык Республики\n' +
                        'Марий Эл»',
                    childrenLinks: [],
                    url: '/sections/100200334'
                },
                {
                    id: 100200335,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(мокшанский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200335'
                },
                {
                    id: 100200336,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(нанайский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200336'
                },
                {
                    id: 100200337,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(негидальский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200337'
                },
                {
                    id: 100200338,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(ненецкий) язык»',
                    childrenLinks: [],
                    url: '/sections/100200338'
                },
                {
                    id: 100200339,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(ненецкий) язык»',
                    childrenLinks: [],
                    url: '/sections/100200339'
                },
                {
                    id: 100200340,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(нивхский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200340'
                },
                {
                    id: 100200341,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(ногайский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200341'
                },
                {
                    id: 100200342,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(осетинский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200342'
                },
                {
                    id: 100200343,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Государственный (осетинский) язык Республики Северная Осетия-\n' +
                        'Алания»',
                    childrenLinks: [],
                    url: '/sections/100200343'
                },
                {
                    id: 100200344,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(селькупский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200344'
                },
                {
                    id: 100200345,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(табасаранский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200345'
                },
                {
                    id: 100200346,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(татарский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200346'
                },
                {
                    id: 100200347,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(татарский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200347'
                },
                {
                    id: 100200348,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Государственный (татарский) язык Республики Татарстан»',
                    childrenLinks: [],
                    url: '/sections/100200348'
                },
                {
                    id: 100200349,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(телеутский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200349'
                },
                {
                    id: 100200350,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(телеутский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200350'
                },
                {
                    id: 100200351,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(тувинский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200351'
                },
                {
                    id: 100200352,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(удмуртский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200352'
                },
                {
                    id: 100200353,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(удмуртский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200353'
                },
                {
                    id: 100200354,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(удэгейский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200354'
                },
                // {
                //     id: 100200355,
                //     parentId: 1002003,
                //     name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                //         '(украинский) язык»',
                //     childrenLinks: [],
                //     url: '/sections/100200355'
                // },
                {
                    id: 100200356,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(ульчский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200356'
                },
                {
                    id: 100200357,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(финский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200357'
                },
                {
                    id: 100200358,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(хакасский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200358'
                },
                {
                    id: 100200359,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(хакасский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200359'
                },
                {
                    id: 100200360,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Государственный (хакасский) язык Республики Хакасия»',
                    childrenLinks: [],
                    url: '/sections/100200360'
                },
                {
                    id: 100200361,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(хантыйский) язык (шурышкарский диалект)»',
                    childrenLinks: [],
                    url: '/sections/100200361'
                },
                {
                    id: 100200362,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(цахурский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200362'
                },
                {
                    id: 100200363,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(черкесский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200363'
                },
                {
                    id: 100200364,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(чеченский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200364'
                },
                {
                    id: 100200365,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(чувашский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200365'
                },
                {
                    id: 100200366,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(чувашский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200366'
                },
                {
                    id: 100200367,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Государственный (чувашский) язык Чувашской Республики –\n' +
                        'Чувашии»',
                    childrenLinks: [],
                    url: '/sections/100200367'
                },
                {
                    id: 1002003672,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (чукотский) язык»',
                    childrenLinks: [],
                    url: '/sections/1002003672'
                },
                {
                    id: 1002003671,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (шорский) язык»',
                    childrenLinks: [],
                    url: '/sections/1002003671'
                },
                {
                    id: 100200368,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(эвенкийский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200368'
                },
                {
                    id: 100200369,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(эвенкийский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200369'
                },
                {
                    id: 100200370,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(эвенский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200370'
                },
                {
                    id: 100200371,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(энецкий) язык»',
                    childrenLinks: [],
                    url: '/sections/100200371'
                },
                {
                    id: 100200372,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(эрзянский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200372'
                },
                {
                    id: 100200373,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(лесной юкагирский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200373'
                },
                {
                    id: 100200374,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(тундренный юкагирский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200374'
                },
                {
                    id: 100200375,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                        '(якутский) язык»',
                    childrenLinks: [],
                    url: '/sections/100200375'
                },
                {
                    id: 100200376,
                    parentId: 1002003,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Государственный язык (саха) Республики Саха (Якутия)»',
                    childrenLinks: [],
                    url: '/sections/100200376'
                }
            ],
            filesToDownload: [{url: './files/noo/22.docx', downloadButtonName: 'Скачать раздел'}],
        },
        {
            id: 1002004,
            parentId: 1002,
            type: PageTypes.SECTION,
            title: 'Федеральные рабочие программы по учебному предмету «Литературное чтение на родном языке»',
            childrenLinks: [
                {
                    id: 100200401,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (русском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200401'
                },
                {
                    id: 100200402,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (абазинском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200402'
                },
                {
                    id: 100200403,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (аварском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200403'
                },
                {
                    id: 100200404,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (агульском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200404'
                },
                {
                    id: 100200405,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (адыгейском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200405'
                },
                {
                    id: 100200406,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (алтайском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200406'
                },
                {
                    id: 100200407,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (балкарском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200407'
                },
                {
                    id: 100200408,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (башкирском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200408'
                },
                {
                    id: 100200409,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (башкирском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200409'
                },
                {
                    id: 100200410,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (бурятском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200410'
                },
                {
                    id: 100200411,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (вепсском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200411'
                },
                {
                    id: 100200412,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (даргинском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200412'
                },
                {
                    id: 100200413,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (долганском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200413'
                },
                {
                    id: 1002004131,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету «Литературное чтение на родном (ингушском) языке»',
                    childrenLinks: [],
                    url: '/sections/1002004131'
                },
                {
                    id: 100200414,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (кабардино-черкесском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200414'
                },
                {
                    id: 100200415,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (калмыцком) языке»',
                    childrenLinks: [],
                    url: '/sections/100200415'
                },
                {
                    id: 100200416,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (карачаевском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200416'
                },
                {
                    id: 100200417,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (карельском) языке (ливвиковское\n' +
                        'наречие)».',
                    childrenLinks: [],
                    url: '/sections/100200417'
                },
                {
                    id: 100200418,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (карельском) языке (собственно\n' +
                        'карельское наречие)»',
                    childrenLinks: [],
                    url: '/sections/100200418'
                },
                {
                    id: 100200419,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (коми) языке»',
                    childrenLinks: [],
                    url: '/sections/100200419'
                },
                {
                    id: 100200420,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (коми-пермяцком) языке»',
                    childrenLinks: [],
                    url: '/sections/100200420'
                },
                {
                    id: 100200421,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (крымскотатарском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200421'
                },
                {
                    id: 100200422,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (кумыкском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200422'
                },
                {
                    id: 100200423,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (лакском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200423'
                },
                {
                    id: 100200424,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (лезгинском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200424'
                },
                {
                    id: 100200425,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (марийском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200425'
                },
                {
                    id: 100200426,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (мокшанском, эрзянском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200426'
                },
                {
                    id: 1002004261,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету «Литературное чтение на родном (нанайском) языке»',
                    childrenLinks: [],
                    url: '/sections/1002004261'
                },
                {
                    id: 100200427,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (негидальском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200427'
                },
                {
                    id: 100200428,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (ненецком) языке»',
                    childrenLinks: [],
                    url: '/sections/100200428'
                },
                {
                    id: 100200429,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (ненецком) языке»',
                    childrenLinks: [],
                    url: '/sections/100200429'
                },
                {
                    id: 100200430,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (нивхском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200430'
                },
                {
                    id: 100200431,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (ногайском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200431'
                },
                {
                    id: 100200432,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (осетинском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200432'
                },
                {
                    id: 100200433,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (селькупском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200433'
                },
                {
                    id: 100200434,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (табасаранском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200434'
                },
                {
                    id: 100200435,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (татарском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200435'
                },
                {
                    id: 100200436,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (татарском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200436'
                },
                {
                    id: 100200437,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (телеутском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200437'
                },
                {
                    id: 100200438,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (тувинском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200438'
                },
                {
                    id: 100200439,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (удмуртском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200439'
                },
                {
                    id: 100200440,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (удэгейском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200440'
                },
                // {
                //     id: 100200441,
                //     parentId: 1002004,
                //     name: 'Федеральная рабочая программа по учебному предмету\n' +
                //         '«Литературное чтение на родном (украинском) языке»',
                //     childrenLinks: [],
                //     url: '/sections/100200441'
                // },
                {
                    id: 100200442,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (ульчском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200442'
                },
                {
                    id: 100200443,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (финском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200443'
                },
                {
                    id: 1002004431,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (хакасском) языке»',
                    childrenLinks: [],
                    url: '/sections/1002004431'
                },
                {
                    id: 100200444,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (хакасском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200444'
                },
                {
                    id: 1002004441,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (хантыйском) языке (шурышкарский диалект)',
                    childrenLinks: [],
                    url: '/sections/1002004441'
                },
                {
                    id: 100200445,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (цахурском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200445'
                },
                {
                    id: 100200446,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (черкесском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200446'
                },
                {
                    id: 100200447,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (чеченском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200447'
                },
                {
                    id: 100200448,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (чувашском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200448'
                },
                {
                    id: 100200449,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (чувашском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200449'
                },
                {
                    id: 100200450,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (эвенкийском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200450'
                },
                {
                    id: 1002004501,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету «Литературное чтение на родном (эвенском) языке»',
                    childrenLinks: [],
                    url: '/sections/1002004501'
                },
                {
                    id: 100200451,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (лесном юкагирском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200451'
                },
                {
                    id: 100200452,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (тундренном юкагирском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200452'
                },
                {
                    id: 100200453,
                    parentId: 1002004,
                    name: 'Федеральная рабочая программа по учебному предмету\n' +
                        '«Литературное чтение на родном (якутском) языке»',
                    childrenLinks: [],
                    url: '/sections/100200453'
                }
            ],
            filesToDownload: [{url: './files/noo/99.docx', downloadButtonName: 'Скачать раздел'}],
        },
        {
            id: 100200301,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(русский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/22.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/22.pdf'
        },
        {
            id: 100200302,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(абазинский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/23.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/23.pdf'
        },
        {
            id: 100200303,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(аварский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/24.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/24.pdf'
        },
        {
            id: 100200304,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(агульский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/25.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/25.pdf'
        },
        {
            id: 100200305,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(адыгейский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/26.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/26.pdf'
        },
        {
            id: 100200306,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(алтайский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/27.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/27.pdf'
        },
        {
            id: 100200307,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(балкарский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/28.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/28.pdf'
        },
        {
            id: 100200308,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(балкарский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/29.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/29.pdf'
        },
        {
            id: 100200309,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(башкирский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/30.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/30.pdf'
        },
        {
            id: 100200310,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(башкирский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/31.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/31.pdf'
        },
        {
            id: 100200311,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Государственный (башкирский) язык Республики Башкортостан»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/32.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/32.pdf'
        },
        {
            id: 100200312,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(бурятский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/33.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/33.pdf'
        },
        {
            id: 100200313,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Государственный (бурятский) язык Республики Бурятия»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/34.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/34.pdf'
        },
        {
            id: 100200314,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(вепсский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/35.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/35.pdf'
        },
        {
            id: 100200315,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(даргинский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/36.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/36.pdf'
        },
        {
            id: 100200316,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(долганский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/37.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/37.pdf'
        },
        {
            id: 100200317,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(ингушский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/38.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/38.pdf'
        },
        {
            id: 100200318,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(кабардино-черкесский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/39.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/39.pdf'
        },
        {
            id: 100200319,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(кабардино-черкесский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/40.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/40.pdf'
        },
        {
            id: 100200320,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(калмыцкий) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/41.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/41.pdf'
        },
        {
            id: 100200321,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(карачаевский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/42.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/42.pdf'
        },
        {
            id: 100200322,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(карельский) язык (ливвиковское наречие)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/43.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/43.pdf'
        },
        {
            id: 100200323,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(карельский) язык (собственно карельское наречие)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/44.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/44.pdf'
        },
        {
            id: 100200324,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(коми) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/45.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/45.pdf'
        },
        {
            id: 100200325,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Государственный (коми) язык Республики Коми»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/46.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/46.pdf'
        },
        {
            id: 100200326,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(коми-пермяцкий) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/47.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/47.pdf'
        },
        {
            id: 100200327,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(корякский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/48.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/48.pdf'
        },
        {
            id: 100200328,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(крымскотатарский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/49.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/49.pdf'
        },
        {
            id: 100200329,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Государственный (крымскотатарский) язык Республики Крым»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/50.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/50.pdf'
        },
        {
            id: 100200330,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(кумыкский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/51.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/51.pdf'
        },
        {
            id: 100200331,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(лакский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/52.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/52.pdf'
        },
        {
            id: 100200332,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(лезгинский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/53.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/53.pdf'
        },
        {
            id: 100200333,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(марийский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/54.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/54.pdf'
        },
        {
            id: 100200334,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Государственный (марийский (горный, луговой) язык Республики\n' +
                'Марий Эл»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/55.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/55.pdf'
        },
        {
            id: 100200335,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(мокшанский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/56.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/56.pdf'
        },
        {
            id: 100200336,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(нанайский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/57.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/57.pdf'
        },
        {
            id: 100200337,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(негидальский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/58.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/58.pdf'
        },
        {
            id: 100200338,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(ненецкий) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/59.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/59.pdf'
        },
        {
            id: 100200339,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(ненецкий) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/60.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/60.pdf'
        },
        {
            id: 100200340,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(нивхский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/61.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/61.pdf'
        },
        {
            id: 100200341,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(ногайский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/62.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/62.pdf'
        },
        {
            id: 100200342,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(осетинский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/63.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/63.pdf'
        },
        {
            id: 100200343,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Государственный (осетинский) язык Республики Северная Осетия-\n' +
                'Алания»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/64.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/64.pdf'
        },
        {
            id: 100200344,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(селькупский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/65.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/65.pdf'
        },
        {
            id: 100200345,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(табасаранский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/66.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/66.pdf'
        },
        {
            id: 100200346,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(татарский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/67.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/67.pdf'
        },
        {
            id: 100200347,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(татарский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/68.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/68.pdf'
        },
        {
            id: 100200348,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Государственный (татарский) язык Республики Татарстан»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/69.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/69.pdf'
        },
        {
            id: 100200349,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(телеутский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/70.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/70.pdf'
        },
        {
            id: 100200350,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(телеутский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/71.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/71.pdf'
        },
        {
            id: 100200351,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(тувинский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/72.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/72.pdf'
        },
        {
            id: 100200352,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(удмуртский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/73.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/73.pdf'
        },
        {
            id: 100200353,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(удмуртский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/74.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/74.pdf'
        },
        {
            id: 100200354,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(удэгейский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/75.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/75.pdf'
        },
        // {
        //     id: 100200355,
        //     parentId: 1002003,
        //     type: PageTypes.SECTION,
        //     title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
        //         '(украинский) язык»',
        //     childrenLinks: [],
        //     filesToDownload: [{url: './files/noo/76.docx', downloadButtonName: 'Скачать раздел'}],
        //     pdfUrl: './files/noo/76.pdf'
        // },
        {
            id: 100200356,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(ульчский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/77.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/77.pdf'
        },
        {
            id: 100200357,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(финский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/78.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/78.pdf'
        },
        {
            id: 100200358,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(хакасский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/79.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/79.pdf'
        },
        {
            id: 100200359,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(хакасский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/80.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/80.pdf'
        },
        {
            id: 100200360,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Государственный (хакасский) язык Республики Хакасия»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/81.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/81.pdf'
        },
        {
            id: 100200361,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(хантыйский) язык (шурышкарский диалект)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/82.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/82.pdf'
        },
        {
            id: 100200362,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(цахурский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/83.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/83.pdf'
        },
        {
            id: 100200363,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(черкесский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/84.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/84.pdf'
        },
        {
            id: 100200364,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(чеченский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/85.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/85.pdf'
        },
        {
            id: 100200365,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(чувашский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/86.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/86.pdf'
        },
        {
            id: 100200366,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(чувашский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/87.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/87.pdf'
        },
        {
            id: 100200367,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Государственный (чувашский) язык Чувашской Республики –\n' +
                'Чувашии»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/88.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/88.pdf'
        },
        {
            id: 1002003672,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (чукотский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/88_1.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/88_1.pdf'
        },
        {
            id: 1002003671,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: '89 Федеральная рабочая программа по учебному предмету «Родной (шорский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/89.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/89.pdf'
        },
        {
            id: 100200368,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(эвенкийский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/90.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/90.pdf'
        },
        {
            id: 100200369,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(эвенкийский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/91.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/91.pdf'
        },
        {
            id: 100200370,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(эвенский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/92.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/92.pdf'
        },
        {
            id: 100200371,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(энецкий) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/93.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/93.pdf'
        },
        {
            id: 100200372,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(эрзянский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/94.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/94.pdf'
        },
        {
            id: 100200373,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(лесной юкагирский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/95.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/95.pdf'
        },
        {
            id: 100200374,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(тундренный юкагирский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/96.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/96.pdf'
        },
        {
            id: 100200375,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной\n' +
                '(якутский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/97.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/97.pdf'
        },
        {
            id: 100200376,
            parentId: 1002003,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Государственный язык (саха) Республики Саха (Якутия)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/98.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/98.pdf'
        },
        {
            id: 100200401,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (русском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/99.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/99.pdf'
        },
        {
            id: 100200402,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (абазинском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/100.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/100.pdf'
        },
        {
            id: 100200403,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (аварском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/101.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/101.pdf'
        },
        {
            id: 100200404,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (агульском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/102.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/102.pdf'
        },
        {
            id: 100200405,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (адыгейском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/103.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/103.pdf'
        },
        {
            id: 100200406,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (алтайском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/104.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/104.pdf'
        },
        {
            id: 100200407,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (балкарском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/105.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/105.pdf'
        },
        {
            id: 100200408,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (башкирском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/106.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/106.pdf'
        },
        {
            id: 100200409,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (башкирском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/107.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/107.pdf'
        },
        {
            id: 100200410,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (бурятском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/108.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/108.pdf'
        },
        {
            id: 100200411,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (вепсском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/109.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/109.pdf'
        },
        {
            id: 100200412,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (даргинском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/110.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/110.pdf'
        },
        {
            id: 100200413,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (долганском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/111.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/111.pdf'
        },
        {
            id: 1002004131,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Литературное чтение на родном (ингушском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/112.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/112.pdf'
        },
        {
            id: 100200414,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (кабардино-черкесском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/113.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/113.pdf'
        },
        {
            id: 100200415,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (калмыцком) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/114.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/114.pdf'
        },
        {
            id: 100200416,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (карачаевском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/115.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/115.pdf'
        },
        {
            id: 100200417,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (карельском) языке (ливвиковское\n' +
                'наречие)».',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/116.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/116.pdf'
        },
        {
            id: 100200418,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (карельском) языке (собственно\n' +
                'карельское наречие)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/117.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/117.pdf'
        },
        {
            id: 100200419,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (коми) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/118.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/118.pdf'
        },
        {
            id: 100200420,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (коми-пермяцком) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/119.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/119.pdf'
        },
        {
            id: 100200421,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (крымскотатарском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/120.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/120.pdf'
        },
        {
            id: 100200422,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (кумыкском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/121.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/121.pdf'
        },
        {
            id: 100200423,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (лакском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/122.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/122.pdf'
        },
        {
            id: 100200424,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (лезгинском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/123.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/123.pdf'
        },
        {
            id: 100200425,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (марийском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/124.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/124.pdf'
        },
        {
            id: 100200426,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (мокшанском, эрзянском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/125.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/125.pdf'
        },
        {
            id: 1002004261,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Литературное чтение на родном (нанайском) языке».',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/126.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/126.pdf'
        },
        {
            id: 100200427,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (негидальском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/127.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/127.pdf'
        },
        {
            id: 100200428,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (ненецком) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/128.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/128.pdf'
        },
        {
            id: 100200429,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (ненецком) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/129.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/129.pdf'
        },
        {
            id: 100200430,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (нивхском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/130.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/130.pdf'
        },
        {
            id: 100200431,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (ногайском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/131.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/131.pdf'
        },
        {
            id: 100200432,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (осетинском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/132.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/132.pdf'
        },
        {
            id: 100200433,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (селькупском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/133.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/133.pdf'
        },
        {
            id: 100200434,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (табасаранском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/134.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/134.pdf'
        },
        {
            id: 100200435,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (татарском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/135.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/135.pdf'
        },
        {
            id: 100200436,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (татарском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/136.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/136.pdf'
        },
        {
            id: 100200437,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (телеутском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/137.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/137.pdf'
        },
        {
            id: 100200438,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (тувинском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/138.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/138.pdf'
        },
        {
            id: 100200439,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (удмуртском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/139.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/139.pdf'
        },
        {
            id: 100200440,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (удэгейском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/140.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/140.pdf'
        },
        // {
        //     id: 100200441,
        //     parentId: 1002004,
        //     type: PageTypes.SECTION,
        //     title: 'Федеральная рабочая программа по учебному предмету\n' +
        //         '«Литературное чтение на родном (украинском) языке»',
        //     childrenLinks: [],
        //     filesToDownload: [{url: './files/noo/141.docx', downloadButtonName: 'Скачать раздел'}],
        //     pdfUrl: './files/noo/141.pdf'
        // },
        {
            id: 100200442,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (ульчском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/142.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/142.pdf'
        },
        {
            id: 100200443,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (финском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/143.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/143.pdf'
        },
        {
            id: 1002004431,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (хакасском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/144.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/144.pdf'
        },
        {
            id: 100200444,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (хакасском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/145.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/145.pdf'
        },
        {
            id: 1002004441,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (хантыйском) языке (шурышкарский диалект)',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/146.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/146.pdf'
        },
        {
            id: 100200445,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (цахурском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/147.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/147.pdf'
        },
        {
            id: 100200446,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (черкесском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/148.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/148.pdf'
        },
        {
            id: 100200447,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (чеченском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/149.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/149.pdf'
        },
        {
            id: 100200448,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (чувашском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/150.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/150.pdf'
        },
        {
            id: 100200449,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (чувашском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/151.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/151.pdf'
        },
        {
            id: 100200450,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (эвенкийском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/152.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/152.pdf'
        },
        {
            id: 1002004501,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Литературное чтение на родном (эвенском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/153.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/153.pdf'
        },
        {
            id: 100200451,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (лесном юкагирском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/154.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/154.pdf'
        },
        {
            id: 100200452,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (тундренном юкагирском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/155.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/155.pdf'
        },
        {
            id: 100200453,
            parentId: 1002004,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Литературное чтение на родном (якутском) языке»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/156.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/156.pdf'
        },
        {
            id: 1002005,
            parentId: 1002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Иностранный (английский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/157.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/157.pdf'
        },
        {
            id: 1002006,
            parentId: 1002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Иностранный (немецкий) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/158.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/158.pdf'
        },
        {
            id: 1002007,
            parentId: 1002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Иностранный (французский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/159.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/159.pdf'
        },
        {
            id: 1002008,
            parentId: 1002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Иностранный (испанский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/160.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/160.pdf'
        },
        {
            id: 1002009,
            parentId: 1002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Иностранный (китайский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/161.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/161.pdf'
        },
        {
            id: 1002010,
            parentId: 1002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Математика»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/162.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/162.pdf'
        },
        {
            id: 1002011,
            parentId: 1002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Окружающий мир»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/163.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/163.pdf'
        },
        {
            id: 10020111,
            parentId: 1002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Основы\n' +
                'религиозных культур и светской этики»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/164.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/164.pdf'
        },
        {
            id: 1002012,
            parentId: 1002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Изобразительное искусство»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/165.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/165.pdf'
        },
        {
            id: 1002013,
            parentId: 1002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Музыка»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/166.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/166.pdf'
        },
        {
            id: 1002014,
            parentId: 1002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Труд (технология)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/167.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/167.pdf'
        },
        {
            id: 1002015,
            parentId: 1002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету\n' +
                '«Физическая культура»',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/168.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/168.pdf'
        },
        {
            id: 1002016,
            parentId: 1002,
            type: PageTypes.SECTION,
            title: 'Программа формирования универсальных учебных действий',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/169.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/169.pdf'
        },
        {
            id: 1002017,
            parentId: 1002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа воспитания',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/170.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/170.pdf'
        },
        {
            id: 1003001,
            parentId: 1003,
            type: PageTypes.SECTION,
            title: 'Федеральный учебный план начального общего образования',
            childrenLinks: [
                {
                    id: 10030010,
                    parentId: 1003001,
                    name: 'Пояснительная записка',
                    childrenLinks: [],
                    url: '/sections/10030010'
                },
                {
                    id: 10030011,
                    parentId: 1003001,
                    name: 'Вариант 1',
                    childrenLinks: [],
                    url: '/sections/10030011'
                },
                {
                    id: 10030012,
                    parentId: 1003001,
                    name: 'Вариант 2',
                    childrenLinks: [],
                    url: '/sections/10030012'
                },
                {
                    id: 10030013,
                    parentId: 1003001,
                    name: 'Вариант 3',
                    childrenLinks: [],
                    url: '/sections/10030013'
                },
                {
                    id: 10030014,
                    parentId: 1003001,
                    name: 'Вариант 4',
                    childrenLinks: [],
                    url: '/sections/10030014'
                },
                {
                    id: 10030015,
                    parentId: 1003001,
                    name: 'Вариант 5',
                    childrenLinks: [],
                    url: '/sections/10030015'
                }
            ],
            filesToDownload: [{url: './files/noo/171.docx', downloadButtonName: 'Скачать раздел'}],
        },
        {
            id: 1003002,
            parentId: 1003,
            type: PageTypes.SECTION,
            title: 'Федеральный календарный учебный график',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/172.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/172.pdf'
        },
        {
            id: 1003003,
            parentId: 1003,
            type: PageTypes.SECTION,
            title: 'План внеурочной деятельности',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/173.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/173.pdf'
        },
        {
            id: 1003004,
            parentId: 1003,
            type: PageTypes.SECTION,
            title: 'Федеральный календарный план воспитательной работы',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/174.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/174.pdf'
        },
        {
            id: 10030010,
            parentId: 1003001,
            type: PageTypes.SECTION,
            title: 'Пояснительная записка',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/171.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/171.pdf'
        },
        {
            id: 10030011,
            parentId: 1003001,
            type: PageTypes.SECTION,
            title: 'Вариант 1',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/variant1.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/variant1.pdf'
        },
        {
            id: 10030012,
            parentId: 1003001,
            type: PageTypes.SECTION,
            title: 'Вариант 2',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/variant2.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/variant2.pdf'
        },
        {
            id: 10030013,
            parentId: 1003001,
            type: PageTypes.SECTION,
            title: 'Вариант 3',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/variant3.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/variant3.pdf'
        },
        {
            id: 10030014,
            parentId: 1003001,
            type: PageTypes.SECTION,
            title: 'Вариант 4',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/variant4.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/variant4.pdf'
        },
        {
            id: 10030015,
            parentId: 1003001,
            type: PageTypes.SECTION,
            title: 'Вариант 5',
            childrenLinks: [],
            filesToDownload: [{url: './files/noo/variant5.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/noo/variant5.pdf'
        },
        {
            id: 2000,
            parentId: 2,
            type: PageTypes.SECTION,
            title: 'I. Общие положения',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/I_ooo.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/I_ooo.pdf'
        },
        {
            id: 2001,
            parentId: 2,
            type: PageTypes.SECTION,
            title: 'II. Целевой раздел',
            childrenLinks: [
                {
                    id: 2001001,
                    parentId: 2001,
                    name: 'Пояснительная записка',
                    childrenLinks: [],
                    url: '/sections/2001001'
                },
                {
                    id: 2001002,
                    parentId: 2001,
                    name: 'Планируемые результаты освоения ФОП ООО',
                    childrenLinks: [],
                    url: '/sections/2001002'
                },
                {
                    id: 2001003,
                    parentId: 2001,
                    name: 'Система оценки достижения планируемых результатов освоения\n' +
                        'ФОП ООО',
                    childrenLinks: [],
                    url: '/sections/2001003'
                }
            ]
        },
        {
            id: 2002,
            parentId: 2,
            type: PageTypes.SECTION,
            title: 'III. Содержательный раздел',
            childrenLinks: [
                {
                    id: 200201,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Русский язык»',
                    childrenLinks: [],
                    url: '/sections/200201'
                },
                {
                    id: 200202,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Литература»',
                    childrenLinks: [],
                    url: '/sections/200202'
                },
                {
                    id: 200203,
                    parentId: 2002,
                    name: 'Федеральные рабочие программы по учебному предмету «Родной язык»',
                    childrenLinks: [
                        {
                            id: 20020301,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (русский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020301'
                        },
                        {
                            id: 20020302,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (абазинский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020302'
                        },
                        {
                            id: 20020303,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (аварский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020303'
                        },
                        {
                            id: 20020304,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (адыгейский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020304'
                        },
                        {
                            id: 20020305,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (алтайский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020305'
                        },
                        {
                            id: 20020306,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (балкарский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020306'
                        },
                        {
                            id: 20020307,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (балкарский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020307'
                        },
                        {
                            id: 20020308,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (башкирский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020308'
                        },
                        {
                            id: 200203081,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (башкирский) язык»',
                            childrenLinks: [],
                            url: '/sections/200203081'
                        },
                        {
                            id: 20020309,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Государственный (башкирский) язык Республики Башкортостан»',
                            childrenLinks: [],
                            url: '/sections/20020309'
                        },
                        {
                            id: 20020310,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (бурятский) язык».',
                            childrenLinks: [],
                            url: '/sections/20020310'
                        },
                        {
                            id: 20020311,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Государственный (бурятский) язык Республики Бурятия»',
                            childrenLinks: [],
                            url: '/sections/20020311'
                        },
                        {
                            id: 20020312,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (вепсский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020312'
                        },
                        {
                            id: 20020313,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (даргинский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020313'
                        },
                        {
                            id: 20020314,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (долганский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020314'
                        },
                        {
                            id: 20020315,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (ингушский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020315'
                        },
                        {
                            id: 20020316,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (кабардино-черкесский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020316'
                        },
                        {
                            id: 20020317,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (кабардино-черкесский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020317'
                        },
                        {
                            id: 20020318,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (калмыцкий) язык»',
                            childrenLinks: [],
                            url: '/sections/20020318'
                        },
                        {
                            id: 20020319,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (карачаевский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020319'
                        },
                        {
                            id: 20020320,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (карельский) язык (ливвиковское наречие)»',
                            childrenLinks: [],
                            url: '/sections/20020320'
                        },
                        {
                            id: 20020321,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (карельский) язык (собственно карельское наречие)»',
                            childrenLinks: [],
                            url: '/sections/20020321'
                        },
                        {
                            id: 20020322,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (коми) язык»',
                            childrenLinks: [],
                            url: '/sections/20020322'
                        },
                        {
                            id: 20020323,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Государственный (коми) язык Республики Коми»',
                            childrenLinks: [],
                            url: '/sections/20020323'
                        },
                        {
                            id: 20020324,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (коми-пермяцкий) язык»',
                            childrenLinks: [],
                            url: '/sections/20020324'
                        },
                        {
                            id: 20020325,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (крымскотатарский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020325'
                        },
                        {
                            id: 20020326,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Государственный (крымскотатарский) язык Республики Крым»',
                            childrenLinks: [],
                            url: '/sections/20020326'
                        },
                        {
                            id: 20020327,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (кумыкский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020327'
                        },
                        {
                            id: 20020328,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (лакский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020328'
                        },
                        {
                            id: 20020329,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (лезгинский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020329'
                        },
                        {
                            id: 20020330,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (марийский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020330'
                        },
                        {
                            id: 20020331,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Государственный (марийский (горный, луговой) язык Республики Марий Эл»',
                            childrenLinks: [],
                            url: '/sections/20020331'
                        },
                        {
                            id: 20020332,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (мокшанский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020332'
                        },
                        {
                            id: 20020333,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (нанайский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020333'
                        },
                        {
                            id: 20020334,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (ненецкий) язык»',
                            childrenLinks: [],
                            url: '/sections/20020334'
                        },
                        {
                            id: 20020335,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (ненецкий) язык»',
                            childrenLinks: [],
                            url: '/sections/20020335'
                        },
                        {
                            id: 20020336,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (ногайский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020336'
                        },
                        {
                            id: 20020337,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (осетинский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020337'
                        },
                        {
                            id: 20020338,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Государственный (осетинский) язык Республики Северная Осетия-Алания»',
                            childrenLinks: [],
                            url: '/sections/20020338'
                        },
                        {
                            id: 20020339,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (селькупский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020339'
                        },
                        {
                            id: 20020340,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (табасаранский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020340'
                        },
                        {
                            id: 200203401,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (татарский) язык»',
                            childrenLinks: [],
                            url: '/sections/200203401'
                        },
                        {
                            id: 20020341,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (татарский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020341'
                        },
                        {
                            id: 20020342,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Государственный (татарский) язык Республики Татарстан»',
                            childrenLinks: [],
                            url: '/sections/20020342'
                        },
                        {
                            id: 20020343,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (тувинский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020343'
                        },
                        {
                            id: 20020344,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (удмуртский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020344'
                        },
                        {
                            id: 20020345,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (удмуртский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020345'
                        },
                        // {
                        //     id: 20020346,
                        //     parentId: 200203,
                        //     name: 'Федеральная рабочая программа по учебному предмету «Родной (украинский) язык»',
                        //     childrenLinks: [],
                        //     url: '/sections/20020346'
                        // },
                        {
                            id: 20020347,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (финский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020347'
                        },
                        {
                            id: 20020348,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (хакасский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020348'
                        },
                        {
                            id: 20020349,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (хакасский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020349'
                        },
                        {
                            id: 20020350,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Государственный (хакасский) язык Республики Хакасия»',
                            childrenLinks: [],
                            url: '/sections/20020350'
                        },
                        {
                            id: 20020351,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (хантыйский) язык (шурышкарский диалект)»',
                            childrenLinks: [],
                            url: '/sections/20020351'
                        },
                        {
                            id: 20020352,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (черкесский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020352'
                        },
                        {
                            id: 20020353,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (чеченский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020353'
                        },
                        {
                            id: 20020354,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (чувашский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020354'
                        },
                        {
                            id: 20020355,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (чувашский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020355'
                        },
                        {
                            id: 20020356,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Государственный (чувашский) язык Чувашской Республики – Чувашии»',
                            childrenLinks: [],
                            url: '/sections/20020356'
                        },
                        {
                            id: 200203561,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (чукотский) язык»',
                            childrenLinks: [],
                            url: '/sections/200203561'
                        },
                        {
                            id: 20020357,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (эвенкийский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020357'
                        },
                        {
                            id: 20020358,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (эвенский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020358'
                        },
                        {
                            id: 20020359,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (эрзянский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020359'
                        },
                        {
                            id: 20020360,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (лесной юкагирский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020360'
                        },
                        {
                            id: 20020361,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (тундренный юкагирский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020361'
                        },
                        {
                            id: 20020362,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (якутский) язык»',
                            childrenLinks: [],
                            url: '/sections/20020362'
                        },
                        {
                            id: 20020363,
                            parentId: 200203,
                            name: 'Федеральная рабочая программа по учебному предмету «Государственный язык (саха) Республики Саха (Якутия)»',
                            childrenLinks: [],
                            url: '/sections/20020363'
                        }

                    ],
                    url: '/sections/200203'
                },
                {
                    id: 200204,
                    parentId: 2002,
                    name: 'Федеральные рабочие программы по учебному предмету «Литература на родном языке».',
                    childrenLinks: [
                        {
                            id: 20020401,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (русская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020401'
                        },
                        {
                            id: 20020402,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (абазинская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020402'
                        },
                        {
                            id: 20020403,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (аварская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020403'
                        },
                        {
                            id: 20020404,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (адыгейская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020404'
                        },
                        {
                            id: 20020405,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (алтайская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020405'
                        },
                        {
                            id: 20020406,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (балкарская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020406'
                        },
                        {
                            id: 20020407,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (башкирская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020407'
                        },
                        {
                            id: 20020408,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (башкирская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020408'
                        },
                        {
                            id: 20020409,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (бурятская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020409'
                        },
                        {
                            id: 20020410,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (вепсская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020410'
                        },
                        {
                            id: 20020411,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (даргинская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020411'
                        },
                        {
                            id: 20020412,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (долганская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020412'
                        },
                        {
                            id: 20020413,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (ингушская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020413'
                        },
                        {
                            id: 20020414,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (кабардино-черкесская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020414'
                        },
                        {
                            id: 20020415,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (калмыцкая) литература»',
                            childrenLinks: [],
                            url: '/sections/20020415'
                        },
                        {
                            id: 20020416,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (карачаевская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020416'
                        },
                        {
                            id: 20020417,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (карельская) литература (ливвиковское наречие)»',
                            childrenLinks: [],
                            url: '/sections/20020417'
                        },
                        {
                            id: 20020418,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (карельская) литература (собственно карельское наречие)»',
                            childrenLinks: [],
                            url: '/sections/20020418'
                        },
                        {
                            id: 20020419,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (коми) литература»',
                            childrenLinks: [],
                            url: '/sections/20020419'
                        },
                        {
                            id: 20020420,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (коми-пермяцкая) литература»',
                            childrenLinks: [],
                            url: '/sections/20020420'
                        },
                        {
                            id: 20020421,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (крымскотатарская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020421'
                        },
                        {
                            id: 20020422,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (кумыкская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020422'
                        },
                        {
                            id: 20020423,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (лакская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020423'
                        },
                        {
                            id: 20020424,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (лезгинская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020424'
                        },
                        {
                            id: 20020425,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (марийская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020425'
                        },
                        {
                            id: 20020426,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (мордовская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020426'
                        },
                        {
                            id: 20020427,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (нанайская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020427'
                        },
                        {
                            id: 20020428,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (ненецкая) литература»',
                            childrenLinks: [],
                            url: '/sections/20020428'
                        },
                        {
                            id: 20020429,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (ненецкая) литература»',
                            childrenLinks: [],
                            url: '/sections/20020429'
                        },
                        {
                            id: 20020430,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (ногайская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020430'
                        },
                        {
                            id: 20020431,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (осетинская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020431'
                        },
                        {
                            id: 200204311,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (табасаранская) литература»',
                            childrenLinks: [],
                            url: '/sections/200204311'
                        },
                        {
                            id: 20020432,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (татарская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020432'
                        },
                        {
                            id: 20020433,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (татарская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020433'
                        },
                        {
                            id: 20020434,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (тувинская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020434'
                        },
                        {
                            id: 20020435,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (удмуртская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020435'
                        },
                        // {
                        //     id: 20020436,
                        //     parentId: 200204,
                        //     name: 'Федеральная рабочая программа по учебному предмету «Родная (украинская) литература»',
                        //     childrenLinks: [],
                        //     url: '/sections/20020436'
                        // },
                        {
                            id: 20020437,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (финская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020437'
                        },
                        {
                            id: 20020438,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (хакасская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020438'
                        },
                        {
                            id: 20020439,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (хакасская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020439'
                        },
                        {
                            id: 20020440,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (хантыйская) литература (шурышкарский диалект)»',
                            childrenLinks: [],
                            url: '/sections/20020440'
                        },
                        {
                            id: 20020441,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (черкесская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020441'
                        },
                        {
                            id: 20020442,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (чеченская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020442'
                        },
                        {
                            id: 20020443,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (чувашская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020443'
                        },
                        {
                            id: 20020444,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (чувашская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020444'
                        },
                        {
                            id: 20020445,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (эвенкийская) литература».',
                            childrenLinks: [],
                            url: '/sections/20020445'
                        },
                        {
                            id: 20020446,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (эвенская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020446'
                        },
                        {
                            id: 20020447,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (юкагирская) литература (на лесном юкагирском языке)»',
                            childrenLinks: [],
                            url: '/sections/20020447'
                        },
                        {
                            id: 20020448,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (юкагирская) литература (на тундренном юкагирском языке)»',
                            childrenLinks: [],
                            url: '/sections/20020448'
                        },
                        {
                            id: 20020449,
                            parentId: 200204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (якутская) литература»',
                            childrenLinks: [],
                            url: '/sections/20020449'
                        }
                    ],
                    url: '/sections/200204'
                },
                {
                    id: 200205,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Иностранный (английский) язык»',
                    childrenLinks: [],
                    url: '/sections/200205'
                },
                {
                    id: 200206,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Иностранный (немецкий) язык»',
                    childrenLinks: [],
                    url: '/sections/200206'
                },
                {
                    id: 200207,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Иностранный (французский) язык»',
                    childrenLinks: [],
                    url: '/sections/200207'
                },
                {
                    id: 200208,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Иностранный (испанский) язык»',
                    childrenLinks: [],
                    url: '/sections/200208'
                },
                {
                    id: 200209,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Иностранный (китайский) язык»',
                    childrenLinks: [],
                    url: '/sections/200209'
                },
                {
                    id: 200210,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (английский) язык»',
                    childrenLinks: [],
                    url: '/sections/200210'
                },
                {
                    id: 200211,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (немецкий) язык»',
                    childrenLinks: [],
                    url: '/sections/200211'
                },
                {
                    id: 200212,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (французский) язык»',
                    childrenLinks: [],
                    url: '/sections/200212'
                },
                {
                    id: 200213,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (испанский) язык»',
                    childrenLinks: [],
                    url: '/sections/200213'
                },
                {
                    id: 200214,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (китайский) язык»',
                    childrenLinks: [],
                    url: '/sections/200214'
                },
                {
                    id: 200215,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Математика» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/200215'
                },
                {
                    id: 200216,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Математика» (углублённый уровень)',
                    childrenLinks: [],
                    url: '/sections/200216'
                },
                {
                    id: 200217,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Информатика» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/200217'
                },
                {
                    id: 200218,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Информатика» (углублённый уровень)',
                    childrenLinks: [],
                    url: '/sections/200218'
                },
                {
                    id: 200219,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «История»',
                    childrenLinks: [],
                    url: '/sections/200219'
                },
                {
                    id: 200220,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Обществознание»',
                    childrenLinks: [],
                    url: '/sections/200220'
                },
                {
                    id: 200221,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «География»',
                    childrenLinks: [],
                    url: '/sections/200221'
                },
                {
                    id: 200222,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Физика» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/200222'
                },
                {
                    id: 200223,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Физика» (углублённый уровень)',
                    childrenLinks: [],
                    url: '/sections/200223'
                },
                {
                    id: 200224,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Химия» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/200224'
                },
                {
                    id: 200225,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Химия» (углубленный уровень)',
                    childrenLinks: [],
                    url: '/sections/200225'
                },
                {
                    id: 200226,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Биология» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/200226'
                },
                {
                    id: 200227,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Биология» (углублённый уровень)',
                    childrenLinks: [],
                    url: '/sections/200227'
                },
                {
                    id: 200229,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Изобразительное искусство»',
                    childrenLinks: [],
                    url: '/sections/200229'
                },
                {
                    id: 2002291,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Духовно-нравственная культура России»',
                    childrenLinks: [],
                    url: '/sections/2002291'
                },
                {
                    id: 200230,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Музыка»',
                    childrenLinks: [],
                    url: '/sections/200230'
                },
                {
                    id: 200231,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Труд (технология)»',
                    childrenLinks: [],
                    url: '/sections/200231'
                },
                {
                    id: 200233,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Основы безопасности и защиты Родины»',
                    childrenLinks: [],
                    url: '/sections/200233'
                },
                {
                    id: 200232,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа по учебному предмету «Физическая культура»',
                    childrenLinks: [],
                    url: '/sections/200232'
                },
                {
                    id: 200234,
                    parentId: 2002,
                    name: 'Программа формирования универсальных учебных действий',
                    childrenLinks: [],
                    url: '/sections/200234'
                },
                {
                    id: 200235,
                    parentId: 2002,
                    name: 'Федеральная рабочая программа воспитания',
                    childrenLinks: [],
                    url: '/sections/200235'
                }
            ],
            filesToDownload: [{url: './files/ooo/III_ooo.docx', downloadButtonName: 'Скачать раздел'}],
        },
        {
            id: 2003,
            parentId: 2,
            type: PageTypes.SECTION,
            title: 'IV. Организационный раздел',
            childrenLinks: [
                {
                    id: 2003001,
                    parentId: 2003,
                    name: 'Федеральный учебный план основного общего образования',
                    childrenLinks: [
                        {
                            id: 20030010,
                            parentId: 2003001,
                            name: 'Пояснительная записка',
                            childrenLinks: [],
                            url: '/sections/20030010'
                        },
                        {
                            id: 200301,
                            parentId: 2003001,
                            name: 'На 01.09.2024 г.',
                            childrenLinks: [
                                {
                                    id: 20030011,
                                    parentId: 200301,
                                    name: 'Вариант 1',
                                    childrenLinks: [],
                                    url: '/sections/20030011'
                                },
                                {
                                    id: 20030012,
                                    parentId: 200301,
                                    name: 'Вариант 2',
                                    childrenLinks: [],
                                    url: '/sections/20030012'
                                },
                                {
                                    id: 20030013,
                                    parentId: 200301,
                                    name: 'Вариант 3',
                                    childrenLinks: [],
                                    url: '/sections/20030013'
                                },
                                {
                                    id: 20030014,
                                    parentId: 200301,
                                    name: 'Вариант 4',
                                    childrenLinks: [],
                                    url: '/sections/20030014'
                                },
                                {
                                    id: 20030015,
                                    parentId: 200301,
                                    name: 'Вариант 5',
                                    childrenLinks: [],
                                    url: '/sections/20030015'
                                },
                                {
                                    id: 20030016,
                                    parentId: 200301,
                                    name: 'Вариант 6',
                                    childrenLinks: [],
                                    url: '/sections/20030016'
                                }
                            ],
                            url: '/sections/200301'
                        },
                        {
                            id: 200302,
                            parentId: 2003001,
                            name: 'На 01.09.2025 г.',
                            childrenLinks: [
                                {
                                    id: 200300111,
                                    parentId: 200301,
                                    name: 'Вариант 1',
                                    childrenLinks: [],
                                    url: '/sections/200300111'
                                },
                                {
                                    id: 200300121,
                                    parentId: 200301,
                                    name: 'Вариант 2',
                                    childrenLinks: [],
                                    url: '/sections/200300121'
                                },
                                {
                                    id: 200300131,
                                    parentId: 200301,
                                    name: 'Вариант 3',
                                    childrenLinks: [],
                                    url: '/sections/200300131'
                                },
                                {
                                    id: 200300141,
                                    parentId: 200301,
                                    name: 'Вариант 4',
                                    childrenLinks: [],
                                    url: '/sections/200300141'
                                },
                                {
                                    id: 200300151,
                                    parentId: 200301,
                                    name: 'Вариант 5',
                                    childrenLinks: [],
                                    url: '/sections/200300151'
                                },
                                {
                                    id: 200300161,
                                    parentId: 200301,
                                    name: 'Вариант 6',
                                    childrenLinks: [],
                                    url: '/sections/200300161'
                                }
                            ],
                            url: '/sections/200302'
                        },
                    ],
                    url: '/sections/2003001'
                },
                {
                    id: 2003002,
                    parentId: 2003,
                    name: 'Федеральный календарный учебный график',
                    childrenLinks: [],
                    url: '/sections/2003002'
                },
                {
                    id: 2003003,
                    parentId: 2003,
                    name: 'План внеурочной деятельности',
                    childrenLinks: [],
                    url: '/sections/2003003'
                },
                {
                    id: 2003004,
                    parentId: 2003,
                    name: 'Федеральный календарный план воспитательной работы',
                    childrenLinks: [],
                    url: '/sections/2003004'
                }
            ],
            filesToDownload: [{url: './files/ooo/IV_ooo.docx', downloadButtonName: 'Скачать раздел'}],
        },
        {
            id: 2001001,
            parentId: 2001,
            type: PageTypes.SECTION,
            title: 'Пояснительная записка',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/16.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/16.pdf'
        },
        {
            id: 2001002,
            parentId: 2001,
            type: PageTypes.SECTION,
            title: 'Планируемые результаты освоения ФОП ООО',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/17.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/17.pdf'
        },
        {
            id: 2001003,
            parentId: 2001,
            type: PageTypes.SECTION,
            title: 'Система оценки достижения планируемых результатов освоения\n' +
                'ФОП ООО',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/18.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/18.pdf'
        },
        {
            id: 200201,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Русский язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/19.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/19.pdf'
        },
        {
            id: 200202,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/20.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/20.pdf'
        },
        {
            id: 200203,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральные рабочие программы по учебному предмету «Родной язык»',
            childrenLinks: [
                {
                    id: 20020301,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (русский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020301'
                },
                {
                    id: 20020302,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (абазинский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020302'
                },
                {
                    id: 20020303,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (аварский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020303'
                },
                {
                    id: 20020304,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (адыгейский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020304'
                },
                {
                    id: 20020305,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (алтайский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020305'
                },
                {
                    id: 20020306,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (балкарский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020306'
                },
                {
                    id: 20020307,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (балкарский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020307'
                },
                {
                    id: 20020308,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (башкирский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020308'
                },
                {
                    id: 200203081,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (башкирский) язык»',
                    childrenLinks: [],
                    url: '/sections/200203081'
                },
                {
                    id: 20020309,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (башкирский) язык Республики Башкортостан»',
                    childrenLinks: [],
                    url: '/sections/20020309'
                },
                {
                    id: 20020310,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (бурятский) язык».',
                    childrenLinks: [],
                    url: '/sections/20020310'
                },
                {
                    id: 20020311,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (бурятский) язык Республики Бурятия»',
                    childrenLinks: [],
                    url: '/sections/20020311'
                },
                {
                    id: 20020312,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (вепсский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020312'
                },
                {
                    id: 20020313,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (даргинский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020313'
                },
                {
                    id: 20020314,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (долганский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020314'
                },
                {
                    id: 20020315,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (ингушский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020315'
                },
                {
                    id: 20020316,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (кабардино-черкесский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020316'
                },
                {
                    id: 20020317,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (кабардино-черкесский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020317'
                },
                {
                    id: 20020318,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (калмыцкий) язык»',
                    childrenLinks: [],
                    url: '/sections/20020318'
                },
                {
                    id: 20020319,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (карачаевский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020319'
                },
                {
                    id: 20020320,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (карельский) язык (ливвиковское наречие)»',
                    childrenLinks: [],
                    url: '/sections/20020320'
                },
                {
                    id: 20020321,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (карельский) язык (собственно карельское наречие)»',
                    childrenLinks: [],
                    url: '/sections/20020321'
                },
                {
                    id: 20020322,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (коми) язык»',
                    childrenLinks: [],
                    url: '/sections/20020322'
                },
                {
                    id: 20020323,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (коми) язык Республики Коми»',
                    childrenLinks: [],
                    url: '/sections/20020323'
                },
                {
                    id: 20020324,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (коми-пермяцкий) язык»',
                    childrenLinks: [],
                    url: '/sections/20020324'
                },
                {
                    id: 20020325,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (крымскотатарский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020325'
                },
                {
                    id: 20020326,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (крымскотатарский) язык Республики Крым»',
                    childrenLinks: [],
                    url: '/sections/20020326'
                },
                {
                    id: 20020327,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (кумыкский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020327'
                },
                {
                    id: 20020328,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (лакский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020328'
                },
                {
                    id: 20020329,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (лезгинский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020329'
                },
                {
                    id: 20020330,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (марийский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020330'
                },
                {
                    id: 20020331,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (марийский (горный, луговой) язык Республики Марий Эл»',
                    childrenLinks: [],
                    url: '/sections/20020331'
                },
                {
                    id: 20020332,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (мокшанский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020332'
                },
                {
                    id: 20020333,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (нанайский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020333'
                },
                {
                    id: 20020334,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (ненецкий) язык»',
                    childrenLinks: [],
                    url: '/sections/20020334'
                },
                {
                    id: 20020335,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (ненецкий) язык»',
                    childrenLinks: [],
                    url: '/sections/20020335'
                },
                {
                    id: 20020336,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (ногайский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020336'
                },
                {
                    id: 20020337,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (осетинский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020337'
                },
                {
                    id: 20020338,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (осетинский) язык Республики Северная Осетия-Алания»',
                    childrenLinks: [],
                    url: '/sections/20020338'
                },
                {
                    id: 20020339,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (селькупский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020339'
                },
                {
                    id: 20020340,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (табасаранский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020340'
                },
                {
                    id: 200203401,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (татарский) язык»',
                    childrenLinks: [],
                    url: '/sections/200203401'
                },
                {
                    id: 20020341,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (татарский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020341'
                },
                {
                    id: 20020342,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (татарский) язык Республики Татарстан»',
                    childrenLinks: [],
                    url: '/sections/20020342'
                },
                {
                    id: 20020343,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (тувинский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020343'
                },
                {
                    id: 20020344,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (удмуртский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020344'
                },
                {
                    id: 20020345,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (удмуртский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020345'
                },
                // {
                //     id: 20020346,
                //     parentId: 200203,
                //     name: 'Федеральная рабочая программа по учебному предмету «Родной (украинский) язык»',
                //     childrenLinks: [],
                //     url: '/sections/20020346'
                // },
                {
                    id: 20020347,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (финский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020347'
                },
                {
                    id: 20020348,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (хакасский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020348'
                },
                {
                    id: 20020349,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (хакасский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020349'
                },
                {
                    id: 20020350,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (хакасский) язык Республики Хакасия»',
                    childrenLinks: [],
                    url: '/sections/20020350'
                },
                {
                    id: 20020351,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (хантыйский) язык (шурышкарский диалект)»',
                    childrenLinks: [],
                    url: '/sections/20020351'
                },
                {
                    id: 20020352,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (черкесский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020352'
                },
                {
                    id: 20020353,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (чеченский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020353'
                },
                {
                    id: 20020354,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (чувашский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020354'
                },
                {
                    id: 20020355,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (чувашский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020355'
                },
                {
                    id: 20020356,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (чувашский) язык Чувашской Республики – Чувашии»',
                    childrenLinks: [],
                    url: '/sections/20020356'
                },
                {
                    id: 200203561,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (чукотский) язык»',
                    childrenLinks: [],
                    url: '/sections/200203561'
                },
                {
                    id: 20020357,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (эвенкийский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020357'
                },
                {
                    id: 20020358,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (эвенский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020358'
                },
                {
                    id: 20020359,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (эрзянский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020359'
                },
                {
                    id: 20020360,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (лесной юкагирский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020360'
                },
                {
                    id: 20020361,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (тундренный юкагирский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020361'
                },
                {
                    id: 20020362,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (якутский) язык»',
                    childrenLinks: [],
                    url: '/sections/20020362'
                },
                {
                    id: 20020363,
                    parentId: 200203,
                    name: 'Федеральная рабочая программа по учебному предмету «Государственный язык (саха) Республики Саха (Якутия)»',
                    childrenLinks: [],
                    url: '/sections/20020363'
                }

            ]
        },
        {
            id: 20020301,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (русский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/21.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/21.pdf'
        },
        {
            id: 20020302,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (абазинский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/22.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/22.pdf'
        },
        {
            id: 20020303,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (аварский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/23.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/23.pdf'
        },
        {
            id: 20020304,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (адыгейский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/24.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/24.pdf'
        },
        {
            id: 20020305,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (алтайский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/25.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/25.pdf'
        },
        {
            id: 20020306,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (балкарский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/26.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/26.pdf'
        },
        {
            id: 20020307,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (балкарский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/27.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/27.pdf'
        },
        {
            id: 20020308,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (башкирский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/28.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/28.pdf'
        },
        {
            id: 200203081,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (башкирский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/29.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/29.pdf'
        },
        {
            id: 20020309,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Государственный (башкирский) язык Республики Башкортостан»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/30.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/30.pdf'
        },
        {
            id: 20020310,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (бурятский) язык».',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/31.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/31.pdf'
        },
        {
            id: 20020311,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Государственный (бурятский) язык Республики Бурятия»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/32.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/32.pdf'
        },
        {
            id: 20020312,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (вепсский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/33.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/33.pdf'
        },
        {
            id: 20020313,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (даргинский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/34.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/34.pdf'
        },
        {
            id: 20020314,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (долганский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/35.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/35.pdf'
        },
        {
            id: 20020315,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (ингушский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/36.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/36.pdf'
        },
        {
            id: 20020316,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (кабардино-черкесский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/37.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/37.pdf'
        },
        {
            id: 20020317,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (кабардино-черкесский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/38.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/38.pdf'
        },
        {
            id: 20020318,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (калмыцкий) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/39.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/39.pdf'
        },
        {
            id: 20020319,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (карачаевский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/40.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/40.pdf'
        },
        {
            id: 20020320,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (карельский) язык (ливвиковское наречие)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/41.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/41.pdf'
        },
        {
            id: 20020321,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (карельский) язык (собственно карельское наречие)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/42.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/42.pdf'
        },
        {
            id: 20020322,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (коми) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/43.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/43.pdf'
        },
        {
            id: 20020323,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Государственный (коми) язык Республики Коми»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/44.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/44.pdf'
        },
        {
            id: 20020324,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (коми-пермяцкий) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/45.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/45.pdf'
        },
        {
            id: 20020325,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (крымскотатарский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/46.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/46.pdf'
        },
        {
            id: 20020326,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Государственный (крымскотатарский) язык Республики Крым»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/47.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/47.pdf'
        },
        {
            id: 20020327,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (кумыкский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/48.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/48.pdf'
        },
        {
            id: 20020328,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (лакский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/49.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/49.pdf'
        },
        {
            id: 20020329,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (лезгинский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/50.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/50.pdf'
        },
        {
            id: 20020330,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (марийский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/51.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/51.pdf'
        },
        {
            id: 20020331,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Государственный (марийский (горный, луговой) язык Республики Марий Эл»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/52.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/52.pdf'
        },
        {
            id: 20020332,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (мокшанский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/53.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/53.pdf'
        },
        {
            id: 20020333,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (нанайский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/54.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/54.pdf'
        },
        {
            id: 20020334,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (ненецкий) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/55.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/55.pdf'
        },
        {
            id: 20020335,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (ненецкий) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/56.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/56.pdf'
        },
        {
            id: 20020336,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (ногайский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/57.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/57.pdf'
        },
        {
            id: 20020337,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (осетинский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/58.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/58.pdf'
        },
        {
            id: 20020338,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Государственный (осетинский) язык Республики Северная Осетия-Алания»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/59.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/59.pdf'
        },
        {
            id: 20020339,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (селькупский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/60.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/60.pdf'
        },
        {
            id: 20020340,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (табасаранский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/61.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/61.pdf'
        },
        {
            id: 200203401,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (татарский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/62.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/62.pdf'
        },
        {
            id: 20020341,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (татарский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/63.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/63.pdf'
        },
        {
            id: 20020342,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Государственный (татарский) язык Республики Татарстан»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/64.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/64.pdf'
        },
        {
            id: 20020343,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (тувинский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/65.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/65.pdf'
        },
        {
            id: 20020344,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (удмуртский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/66.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/66.pdf'
        },
        {
            id: 20020345,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (удмуртский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/67.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/67.pdf'
        },
        // {
        //     id: 20020346,
        //     parentId: 200203,
        //     type: PageTypes.SECTION,
        //     title: 'Федеральная рабочая программа по учебному предмету «Родной (украинский) язык»',
        //     childrenLinks: [],
        //     filesToDownload: [{url: './files/ooo/68.docx', downloadButtonName: 'Скачать раздел'}],
        //     pdfUrl: './files/ooo/68.pdf'
        // },
        {
            id: 20020347,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (финский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/69.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/69.pdf'
        },
        {
            id: 20020348,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (хакасский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/70.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/70.pdf'
        },
        {
            id: 20020349,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (хакасский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/71.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/71.pdf'
        },
        {
            id: 20020350,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Государственный (хакасский) язык Республики Хакасия»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/72.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/72.pdf'
        },
        {
            id: 20020351,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (хантыйский) язык (шурышкарский диалект)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/73.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/73.pdf'
        },
        {
            id: 20020352,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (черкесский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/74.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/74.pdf'
        },
        {
            id: 20020353,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (чеченский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/75.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/75.pdf'
        },
        {
            id: 20020354,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (чувашский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/76.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/76.pdf'
        },
        {
            id: 20020355,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (чувашский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/77.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/77.pdf'
        },
        {
            id: 20020356,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Государственный (чувашский) язык Чувашской Республики – Чувашии»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/78.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/78.pdf'
        },
        {
            id: 200203561,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (чукотский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/78_1.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/78_1.pdf'
        },
        {
            id: 20020357,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (эвенкийский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/79.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/79.pdf'
        },
        {
            id: 20020358,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (эвенский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/80.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/80.pdf'
        },
        {
            id: 20020359,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (эрзянский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/81.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/81.pdf'
        },
        {
            id: 20020360,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (лесной юкагирский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/82.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/82.pdf'
        },
        {
            id: 20020361,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (тундренный юкагирский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/83.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/83.pdf'
        },
        {
            id: 20020362,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (якутский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/84.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/84.pdf'
        },
        {
            id: 20020363,
            parentId: 200203,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Государственный язык (саха) Республики Саха (Якутия)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/85.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/85.pdf'
        },
        {
            id: 200204,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральные рабочие программы по учебному предмету «Литература на родном языке».',
            childrenLinks: [
                {
                    id: 20020401,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (русская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020401'
                },
                {
                    id: 20020402,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (абазинская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020402'
                },
                {
                    id: 20020403,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (аварская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020403'
                },
                {
                    id: 20020404,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (адыгейская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020404'
                },
                {
                    id: 20020405,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (алтайская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020405'
                },
                {
                    id: 20020406,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (балкарская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020406'
                },
                {
                    id: 20020407,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (башкирская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020407'
                },
                {
                    id: 20020408,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (башкирская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020408'
                },
                {
                    id: 20020409,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (бурятская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020409'
                },
                {
                    id: 20020410,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (вепсская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020410'
                },
                {
                    id: 20020411,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (даргинская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020411'
                },
                {
                    id: 20020412,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (долганская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020412'
                },
                {
                    id: 20020413,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (ингушская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020413'
                },
                {
                    id: 20020414,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (кабардино-черкесская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020414'
                },
                {
                    id: 20020415,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (калмыцкая) литература»',
                    childrenLinks: [],
                    url: '/sections/20020415'
                },
                {
                    id: 20020416,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (карачаевская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020416'
                },
                {
                    id: 20020417,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (карельская) литература (ливвиковское наречие)»',
                    childrenLinks: [],
                    url: '/sections/20020417'
                },
                {
                    id: 20020418,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (карельская) литература (собственно карельское наречие)»',
                    childrenLinks: [],
                    url: '/sections/20020418'
                },
                {
                    id: 20020419,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (коми) литература»',
                    childrenLinks: [],
                    url: '/sections/20020419'
                },
                {
                    id: 20020420,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (коми-пермяцкая) литература»',
                    childrenLinks: [],
                    url: '/sections/20020420'
                },
                {
                    id: 20020421,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (крымскотатарская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020421'
                },
                {
                    id: 20020422,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (кумыкская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020422'
                },
                {
                    id: 20020423,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (лакская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020423'
                },
                {
                    id: 20020424,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (лезгинская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020424'
                },
                {
                    id: 20020425,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (марийская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020425'
                },
                {
                    id: 20020426,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (мордовская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020426'
                },
                {
                    id: 20020427,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (нанайская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020427'
                },
                {
                    id: 20020428,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (ненецкая) литература»',
                    childrenLinks: [],
                    url: '/sections/20020428'
                },
                {
                    id: 20020429,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (ненецкая) литература»',
                    childrenLinks: [],
                    url: '/sections/20020429'
                },
                {
                    id: 20020430,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (ногайская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020430'
                },
                {
                    id: 20020431,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (осетинская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020431'
                },
                {
                    id: 200204311,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (табасаранская) литература»',
                    childrenLinks: [],
                    url: '/sections/200204311'
                },
                {
                    id: 20020432,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (татарская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020432'
                },
                {
                    id: 20020433,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (татарская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020433'
                },
                {
                    id: 20020434,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (тувинская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020434'
                },
                {
                    id: 20020435,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (удмуртская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020435'
                },
                // {
                //     id: 20020436,
                //     parentId: 200204,
                //     name: 'Федеральная рабочая программа по учебному предмету «Родная (украинская) литература»',
                //     childrenLinks: [],
                //     url: '/sections/20020436'
                // },
                {
                    id: 20020437,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (финская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020437'
                },
                {
                    id: 20020438,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (хакасская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020438'
                },
                {
                    id: 20020439,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (хакасская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020439'
                },
                {
                    id: 20020440,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (хантыйская) литература (шурышкарский диалект)»',
                    childrenLinks: [],
                    url: '/sections/20020440'
                },
                {
                    id: 20020441,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (черкесская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020441'
                },
                {
                    id: 20020442,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (чеченская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020442'
                },
                {
                    id: 20020443,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (чувашская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020443'
                },
                {
                    id: 20020444,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (чувашская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020444'
                },
                {
                    id: 20020445,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (эвенкийская) литература».',
                    childrenLinks: [],
                    url: '/sections/20020445'
                },
                {
                    id: 20020446,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (эвенская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020446'
                },
                {
                    id: 20020447,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (юкагирская) литература (на лесном юкагирском языке)»',
                    childrenLinks: [],
                    url: '/sections/20020447'
                },
                {
                    id: 20020448,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (юкагирская) литература (на тундренном юкагирском языке)»',
                    childrenLinks: [],
                    url: '/sections/20020448'
                },
                {
                    id: 20020449,
                    parentId: 200204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (якутская) литература»',
                    childrenLinks: [],
                    url: '/sections/20020449'
                }
            ]
        },
        {
            id: 20020401,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (русская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/86.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/86.pdf'
        },
        {
            id: 20020402,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (абазинская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/87.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/87.pdf'
        },
        {
            id: 20020403,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (аварская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/88.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/88.pdf'
        },
        {
            id: 20020404,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (адыгейская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/89.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/89.pdf'
        },
        {
            id: 20020405,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (алтайская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/90.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/90.pdf'
        },
        {
            id: 20020406,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (балкарская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/91.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/91.pdf'
        },
        {
            id: 20020407,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (башкирская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/92.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/92.pdf'
        },
        {
            id: 20020408,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (башкирская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/93.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/93.pdf'
        },
        {
            id: 20020409,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (бурятская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/94.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/94.pdf'
        },
        {
            id: 20020410,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (вепсская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/95.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/95.pdf'
        },
        {
            id: 20020411,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (даргинская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/96.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/96.pdf'
        },
        {
            id: 20020412,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (долганская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/97.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/97.pdf'
        },
        {
            id: 20020413,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (ингушская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/98.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/98.pdf'
        },
        {
            id: 20020414,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (кабардино-черкесская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/99.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/99.pdf'
        },
        {
            id: 20020415,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (калмыцкая) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/100.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/100.pdf'
        },
        {
            id: 20020416,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (карачаевская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/101.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/101.pdf'
        },
        {
            id: 20020417,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (карельская) литература (ливвиковское наречие)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/102.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/102.pdf'
        },
        {
            id: 20020418,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (карельская) литература (собственно карельское наречие)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/103.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/103.pdf'
        },
        {
            id: 20020419,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (коми) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/104.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/104.pdf'
        },
        {
            id: 20020420,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (коми-пермяцкая) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/105.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/105.pdf'
        },
        {
            id: 20020421,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (крымскотатарская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/106.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/106.pdf'
        },
        {
            id: 20020422,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (кумыкская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/107.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/107.pdf'
        },
        {
            id: 20020423,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (лакская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/108.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/108.pdf'
        },
        {
            id: 20020424,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (лезгинская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/109.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/109.pdf'
        },
        {
            id: 20020425,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (марийская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/110.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/110.pdf'
        },
        {
            id: 20020426,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (мордовская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/111.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/111.pdf'
        },
        {
            id: 20020427,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (нанайская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/112.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/112.pdf'
        },
        {
            id: 20020428,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (ненецкая) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/113.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/113.pdf'
        },
        {
            id: 20020429,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (ненецкая) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/114.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/114.pdf'
        },
        {
            id: 20020430,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (ногайская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/115.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/115.pdf'
        },
        {
            id: 20020431,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (осетинская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/116.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/116.pdf'
        },
        {
            id: 200204311,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (табасаранская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/117.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/117.pdf'
        },
        {
            id: 20020432,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (татарская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/118.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/118.pdf'
        },
        {
            id: 20020433,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (татарская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/119.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/119.pdf'
        },
        {
            id: 20020434,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (тувинская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/120.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/120.pdf'
        },
        {
            id: 20020435,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (удмуртская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/121.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/121.pdf'
        },
        // {
        //     id: 20020436,
        //     parentId: 200204,
        //     type: PageTypes.SECTION,
        //     title: 'Федеральная рабочая программа по учебному предмету «Родная (украинская) литература»',
        //     childrenLinks: [],
        //     filesToDownload: [{url: './files/ooo/122.docx', downloadButtonName: 'Скачать раздел'}],
        //     pdfUrl: './files/ooo/122.pdf'
        // },
        {
            id: 20020437,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (финская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/123.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/123.pdf'
        },
        {
            id: 20020438,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (хакасская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/124.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/124.pdf'
        },
        {
            id: 20020439,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (хакасская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/125.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/125.pdf'
        },
        {
            id: 20020440,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (хантыйская) литература (шурышкарский диалект)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/126.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/126.pdf'
        },
        {
            id: 20020441,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (черкесская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/127.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/127.pdf'
        },
        {
            id: 20020442,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (чеченская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/128.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/128.pdf'
        },
        {
            id: 20020443,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (чувашская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/129.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/129.pdf'
        },
        {
            id: 20020444,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (чувашская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/130.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/130.pdf'
        },
        {
            id: 20020445,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (эвенкийская) литература».',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/131.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/131.pdf'
        },
        {
            id: 20020446,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (эвенская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/132.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/132.pdf'
        },
        {
            id: 20020447,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (юкагирская) литература (на лесном юкагирском языке)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/133.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/133.pdf'
        },
        {
            id: 20020448,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (юкагирская) литература (на тундренном юкагирском языке)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/134.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/134.pdf'
        },
        {
            id: 20020449,
            parentId: 200204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (якутская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/135.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/135.pdf'
        },
        {
            id: 200205,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Иностранный (английский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/136.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/136.pdf'
        },
        {
            id: 200206,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Иностранный (немецкий) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/137.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/137.pdf'
        },
        {
            id: 200207,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Иностранный (французский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/138.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/138.pdf'
        },
        {
            id: 200208,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Иностранный (испанский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/139.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/139.pdf'
        },
        {
            id: 200209,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Иностранный (китайский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/140.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/140.pdf'
        },
        {
            id: 200210,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (английский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/141.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/141.pdf'
        },
        {
            id: 200211,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (немецкий) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/142.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/142.pdf'
        },
        {
            id: 200212,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (французский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/143.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/143.pdf'
        },
        {
            id: 200213,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (испанский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/144.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/144.pdf'
        },
        {
            id: 200214,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (китайский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/145.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/145.pdf'
        },
        {
            id: 200215,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Математика» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/146.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/146.pdf'
        },
        {
            id: 200216,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Математика» (углублённый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/147.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/147.pdf'
        },
        {
            id: 200217,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Информатика» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/148.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/148.pdf'
        },
        {
            id: 200218,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Информатика» (углублённый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/149.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/149.pdf'
        },
        {
            id: 200219,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «История»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/150.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/150.pdf'
        },
        {
            id: 200220,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Обществознание»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/151.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/151.pdf'
        },
        {
            id: 200221,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «География»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/152.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/152.pdf'
        },
        {
            id: 200222,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Физика» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/153.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/153.pdf'
        },
        {
            id: 200223,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Физика» (углублённый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/154.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/154.pdf'
        },
        {
            id: 200224,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Химия» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/155.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/155.pdf'
        },
        {
            id: 200225,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Химия» (углубленный уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/156.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/156.pdf'
        },
        {
            id: 200226,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Биология» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/157.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/157.pdf'
        },
        {
            id: 200227,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Биология» (углублённый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/158.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/158.pdf'
        },
        {
            id: 200229,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Изобразительное искусство»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/160.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/160.pdf'
        },
        {
            id: 2002291,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Духовно-нравственная культура России»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/160_1.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/160_1.pdf'
        },
        {
            id: 200230,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Музыка»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/161.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/161.pdf'
        },
        {
            id: 200231,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Труд (технология)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/162.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/162.pdf'
        },
        {
            id: 200233,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Основы безопасности и защиты Родины»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/162_1.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/162_1.pdf'
        },
        {
            id: 200232,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Физическая культура»',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/163.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/163.pdf'
        },
        {
            id: 200234,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Программа формирования универсальных учебных действий',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/165.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/165.pdf'
        },
        {
            id: 200235,
            parentId: 2002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа воспитания',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/166.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/166.pdf'
        },
        {
            id: 2003001,
            parentId: 2003,
            type: PageTypes.SECTION,
            title: 'Федеральный учебный план основного общего образования',
            childrenLinks: [
                {
                    id: 20030010,
                    parentId: 2003001,
                    name: 'Пояснительная записка',
                    childrenLinks: [],
                    url: '/sections/20030010'
                },
                {
                    id: 200301,
                    parentId: 2003001,
                    name: 'На 01.09.2024 г.',
                    childrenLinks: [
                        {
                            id: 20030011,
                            parentId: 200301,
                            name: 'Вариант 1',
                            childrenLinks: [],
                            url: '/sections/20030011'
                        },
                        {
                            id: 20030012,
                            parentId: 200301,
                            name: 'Вариант 2',
                            childrenLinks: [],
                            url: '/sections/20030012'
                        },
                        {
                            id: 20030013,
                            parentId: 200301,
                            name: 'Вариант 3',
                            childrenLinks: [],
                            url: '/sections/20030013'
                        },
                        {
                            id: 20030014,
                            parentId: 200301,
                            name: 'Вариант 4',
                            childrenLinks: [],
                            url: '/sections/20030014'
                        },
                        {
                            id: 20030015,
                            parentId: 200301,
                            name: 'Вариант 5',
                            childrenLinks: [],
                            url: '/sections/20030015'
                        },
                        {
                            id: 20030016,
                            parentId: 200301,
                            name: 'Вариант 6',
                            childrenLinks: [],
                            url: '/sections/20030016'
                        }
                    ],
                    url: '/sections/200301'
                },
                {
                    id: 200302,
                    parentId: 2003001,
                    name: 'На 01.09.2025 г.',
                    childrenLinks: [
                        {
                            id: 200300111,
                            parentId: 200301,
                            name: 'Вариант 1',
                            childrenLinks: [],
                            url: '/sections/200300111'
                        },
                        {
                            id: 200300121,
                            parentId: 200301,
                            name: 'Вариант 2',
                            childrenLinks: [],
                            url: '/sections/200300121'
                        },
                        {
                            id: 200300131,
                            parentId: 200301,
                            name: 'Вариант 3',
                            childrenLinks: [],
                            url: '/sections/200300131'
                        },
                        {
                            id: 200300141,
                            parentId: 200301,
                            name: 'Вариант 4',
                            childrenLinks: [],
                            url: '/sections/200300141'
                        },
                        {
                            id: 200300151,
                            parentId: 200301,
                            name: 'Вариант 5',
                            childrenLinks: [],
                            url: '/sections/200300151'
                        },
                        {
                            id: 200300161,
                            parentId: 200301,
                            name: 'Вариант 6',
                            childrenLinks: [],
                            url: '/sections/200300161'
                        }
                    ],
                    url: '/sections/200302'
                },
            ]
        },
        {
            id: 2003002,
            parentId: 2003,
            type: PageTypes.SECTION,
            title: 'Федеральный календарный учебный график',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/168.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/168.pdf'
        },
        {
            id: 2003003,
            parentId: 2003,
            type: PageTypes.SECTION,
            title: 'План внеурочной деятельности',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/169.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/169.pdf'
        },
        {
            id: 2003004,
            parentId: 2003,
            type: PageTypes.SECTION,
            title: 'Федеральный календарный план воспитательной работы',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/170.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/170.pdf'
        },
        {
            id: 200301,
            parentId: 2003001,
            type: PageTypes.SECTION,
            title: 'На 01.09.2024 г.',
            childrenLinks: [
                {
                    id: 20030011,
                    parentId: 200301,
                    name: 'Вариант 1',
                    childrenLinks: [],
                    url: '/sections/20030011'
                },
                {
                    id: 20030012,
                    parentId: 200301,
                    name: 'Вариант 2',
                    childrenLinks: [],
                    url: '/sections/20030012'
                },
                {
                    id: 20030013,
                    parentId: 200301,
                    name: 'Вариант 3',
                    childrenLinks: [],
                    url: '/sections/20030013'
                },
                {
                    id: 20030014,
                    parentId: 200301,
                    name: 'Вариант 4',
                    childrenLinks: [],
                    url: '/sections/20030014'
                },
                {
                    id: 20030015,
                    parentId: 200301,
                    name: 'Вариант 5',
                    childrenLinks: [],
                    url: '/sections/20030015'
                },
                {
                    id: 20030016,
                    parentId: 200301,
                    name: 'Вариант 6',
                    childrenLinks: [],
                    url: '/sections/20030016'
                }
            ]
        },
        {
            id: 200302,
            parentId: 2003001,
            type: PageTypes.SECTION,
            title: 'На 01.09.2025 г.',
            childrenLinks: [
                {
                    id: 200300111,
                    parentId: 200301,
                    name: 'Вариант 1',
                    childrenLinks: [],
                    url: '/sections/200300111'
                },
                {
                    id: 200300121,
                    parentId: 200301,
                    name: 'Вариант 2',
                    childrenLinks: [],
                    url: '/sections/200300121'
                },
                {
                    id: 200300131,
                    parentId: 200301,
                    name: 'Вариант 3',
                    childrenLinks: [],
                    url: '/sections/200300131'
                },
                {
                    id: 200300141,
                    parentId: 200301,
                    name: 'Вариант 4',
                    childrenLinks: [],
                    url: '/sections/200300141'
                },
                {
                    id: 200300151,
                    parentId: 200301,
                    name: 'Вариант 5',
                    childrenLinks: [],
                    url: '/sections/200300151'
                },
                {
                    id: 200300161,
                    parentId: 200301,
                    name: 'Вариант 6',
                    childrenLinks: [],
                    url: '/sections/200300161'
                }
            ]
        },
        {
            id: 20030010,
            parentId: 2003001,
            type: PageTypes.SECTION,
            title: 'Пояснительная записка',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/167.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/167.pdf'
        },
        {
            id: 20030011,
            parentId: 200301,
            type: PageTypes.SECTION,
            title: 'Вариант 1',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/variant1_2024.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/variant1_2024.pdf'
        },
        {
            id: 20030012,
            parentId: 200301,
            type: PageTypes.SECTION,
            title: 'Вариант 2',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/variant2_2024.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/variant2_2024.pdf'
        },
        {
            id: 20030013,
            parentId: 200301,
            type: PageTypes.SECTION,
            title: 'Вариант 3',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/variant3_2024.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/variant3_2024.pdf'
        },
        {
            id: 20030014,
            parentId: 200301,
            type: PageTypes.SECTION,
            title: 'Вариант 4',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/variant4_2024.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/variant4_2024.pdf'
        },
        {
            id: 20030015,
            parentId: 200301,
            type: PageTypes.SECTION,
            title: 'Вариант 5',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/variant5_2024.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/variant5_2024.pdf'
        },
        {
            id: 20030016,
            parentId: 200301,
            type: PageTypes.SECTION,
            title: 'Вариант 6',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/variant6_2024.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/variant6_2024.pdf'
        },
        {
            id: 200300111,
            parentId: 200302,
            type: PageTypes.SECTION,
            title: 'Вариант 1',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/variant1_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/variant1_2025.pdf'
        },
        {
            id: 200300121,
            parentId: 200302,
            type: PageTypes.SECTION,
            title: 'Вариант 2',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/variant2_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/variant2_2025.pdf'
        },
        {
            id: 200300131,
            parentId: 200302,
            type: PageTypes.SECTION,
            title: 'Вариант 3',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/variant3_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/variant3_2025.pdf'
        },
        {
            id: 200300141,
            parentId: 200302,
            type: PageTypes.SECTION,
            title: 'Вариант 4',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/variant4_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/variant4_2025.pdf'
        },
        {
            id: 200300151,
            parentId: 200302,
            type: PageTypes.SECTION,
            title: 'Вариант 5',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/variant5_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/variant5_2025.pdf'
        },
        {
            id: 200300161,
            parentId: 200302,
            type: PageTypes.SECTION,
            title: 'Вариант 6',
            childrenLinks: [],
            filesToDownload: [{url: './files/ooo/variant6_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/ooo/variant6_2025.pdf'
        },
        {
            id: 3000,
            parentId: 3,
            type: PageTypes.SECTION,
            title: 'I. Общие положения',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/I_soo.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/I_soo.pdf'
        },
        {
            id: 3001,
            parentId: 3,
            type: PageTypes.SECTION,
            title: 'II. Целевой раздел',
            childrenLinks: [
                {
                    id: 3001001,
                    parentId: 3001,
                    name: 'Пояснительная записка',
                    childrenLinks: [],
                    url: '/sections/3001001'
                },
                {
                    id: 3001002,
                    parentId: 3001,
                    name: 'Планируемые результаты освоения ФОП СОО',
                    childrenLinks: [],
                    url: '/sections/3001002'
                },
                {
                    id: 3001003,
                    parentId: 3001,
                    name: 'Система оценки достижения планируемых результатов освоения\n' +
                        'ФОП СОО',
                    childrenLinks: [],
                    url: '/sections/3001003'
                }
            ]
        },
        {
            id: 3002,
            parentId: 3,
            type: PageTypes.SECTION,
            title: 'III. Содержательный раздел',
            childrenLinks: [
                {
                    id: 300201,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Русский язык» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/300201'
                },
                {
                    id: 300202,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Литература» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/300202'
                },
                {
                    id: 300203,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Литература» (углублённый уровень)',
                    childrenLinks: [],
                    url: '/sections/300203'
                },
                {
                    id: 300204,
                    parentId: 3002,
                    name: 'Федеральные рабочие программы по учебному предмету «Родной язык»',
                    childrenLinks: [
                        {
                            id: 30020401,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной язык (русский)»',
                            childrenLinks: [],
                            url: '/sections/30020401'
                        },
                        {
                            id: 30020402,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (абазинский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020402'
                        },
                        {
                            id: 300204021,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (аварский) язык»',
                            childrenLinks: [],
                            url: '/sections/300204021'
                        },
                        {
                            id: 30020403,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (адыгейский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020403'
                        },
                        {
                            id: 30020404,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (алтайский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020404'
                        },
                        {
                            id: 30020405,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (балкарский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020405'
                        },
                        {
                            id: 30020406,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (балкарский) язык».',
                            childrenLinks: [],
                            url: '/sections/30020406'
                        },
                        {
                            id: 30020407,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (башкирский) язык» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/30020407'
                        },
                        {
                            id: 30020408,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Государственный (башкирский) язык Республики Башкортостан»',
                            childrenLinks: [],
                            url: '/sections/30020408'
                        },
                        {
                            id: 30020409,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Государственный (бурятский) язык Республики Бурятия»',
                            childrenLinks: [],
                            url: '/sections/30020409'
                        },
                        {
                            id: 30020410,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (вепсский) язык» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/30020410'
                        },
                        {
                            id: 300204101,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (даргинский) язык»',
                            childrenLinks: [],
                            url: '/sections/300204101'
                        },
                        {
                            id: 30020411,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (кабардино-черкесский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020411'
                        },
                        {
                            id: 30020412,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (кабардино-черкесский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020412'
                        },
                        {
                            id: 30020413,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (карачаевский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020413'
                        },
                        {
                            id: 30020414,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (карельский) язык (ливвиковское наречие)» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/30020414'
                        },
                        {
                            id: 30020415,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (карельский) язык (собственно карельское наречие)» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/30020415'
                        },
                        {
                            id: 30020416,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (коми) язык»',
                            childrenLinks: [],
                            url: '/sections/30020416'
                        },
                        {
                            id: 30020417,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (крымскотатарский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020417'
                        },
                        {
                            id: 30020418,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Государственный (крымскотатарский) язык Республики Крым»',
                            childrenLinks: [],
                            url: '/sections/30020418'
                        },
                        {
                            id: 300204181,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (кумыкский) язык»',
                            childrenLinks: [],
                            url: '/sections/300204181'
                        },
                        {
                            id: 300204182,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (лакский) язык»',
                            childrenLinks: [],
                            url: '/sections/300204182'
                        },
                        {
                            id: 300204183,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (лезгинский) язык»',
                            childrenLinks: [],
                            url: '/sections/300204183'
                        },
                        {
                            id: 30020419,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (марийский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020419'
                        },
                        {
                            id: 30020420,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Государственный (марийский (горный, луговой) язык Республики Марий Эл»',
                            childrenLinks: [],
                            url: '/sections/30020420'
                        },
                        {
                            id: 30020421,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (мокшанский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020421'
                        },
                        {
                            id: 30020422,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (нанайский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020422'
                        },
                        {
                            id: 30020423,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (ногайский) язык» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/30020423'
                        },
                        {
                            id: 30020424,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (осетинский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020424'
                        },
                        {
                            id: 30020425,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Государственный (осетинский) язык Республики Северная Осетия – Алания»',
                            childrenLinks: [],
                            url: '/sections/30020425'
                        },
                        {
                            id: 300204251,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (табасаранский) язык»',
                            childrenLinks: [],
                            url: '/sections/300204251'
                        },
                        {
                            id: 30020426,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (татарский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020426'
                        },
                        {
                            id: 30020427,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Государственный (татарский) язык Республики Татарстан»',
                            childrenLinks: [],
                            url: '/sections/30020427'
                        },
                        {
                            id: 30020428,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (тувинский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020428'
                        },
                        {
                            id: 30020429,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (удмуртский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020429'
                        },
                        {
                            id: 30020430,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (удмуртский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020430'
                        },
                        // {
                        //     id: 30020431,
                        //     parentId: 300204,
                        //     name: 'Федеральная рабочая программа по учебному предмету «Родной (украинский) язык»',
                        //     childrenLinks: [],
                        //     url: '/sections/30020431'
                        // },
                        {
                            id: 30020432,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (финский) язык» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/30020432'
                        },
                        {
                            id: 30020433,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (хакасский) язык» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/30020433'
                        },
                        {
                            id: 30020434,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (хакасский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020434'
                        },
                        {
                            id: 30020435,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (хантыйский) язык (шурышкарский диалект)»',
                            childrenLinks: [],
                            url: '/sections/30020435'
                        },
                        {
                            id: 30020436,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (черкесский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020436'
                        },
                        {
                            id: 30020437,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (чеченский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020437'
                        },
                        {
                            id: 30020438,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (чувашский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020438'
                        },
                        {
                            id: 30020439,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Государственный (чувашский) язык Чувашской Республики – Чувашии»',
                            childrenLinks: [],
                            url: '/sections/30020439'
                        },
                        {
                            id: 30020440,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (эрзянский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020440'
                        },
                        {
                            id: 30020441,
                            parentId: 300204,
                            name: 'Федеральная рабочая программа по учебному предмету «Родной (якутский) язык»',
                            childrenLinks: [],
                            url: '/sections/30020441'
                        }
                    ],
                    url: '/sections/300204'
                },
                {
                    id: 300205,
                    parentId: 3002,
                    name: 'Федеральные рабочие программы по учебному предмету «Литература на родном языке»',
                    childrenLinks: [
                        {
                            id: 30020501,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная литература (русская)»',
                            childrenLinks: [],
                            url: '/sections/30020501'
                        },
                        {
                            id: 30020502,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (абазинская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020502'
                        },
                        {
                            id: 300205021,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (аварская) литература»',
                            childrenLinks: [],
                            url: '/sections/300205021'
                        },
                        {
                            id: 30020503,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (адыгейская) литература».',
                            childrenLinks: [],
                            url: '/sections/30020503'
                        },
                        {
                            id: 30020504,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (алтайская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020504'
                        },
                        {
                            id: 30020505,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (балкарская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020505'
                        },
                        {
                            id: 30020506,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (башкирская) литература» (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/30020506'
                        },
                        {
                            id: 30020507,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (бурятская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020507'
                        },
                        {
                            id: 30020508,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (вепсская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020508'
                        },
                        {
                            id: 300205081,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (даргинская) литература»',
                            childrenLinks: [],
                            url: '/sections/300205081'
                        },
                        {
                            id: 30020509,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (ингушская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020509'
                        },
                        {
                            id: 30020510,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (кабардино-черкесская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020510'
                        },
                        {
                            id: 30020511,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (калмыцкая) литература»',
                            childrenLinks: [],
                            url: '/sections/30020511'
                        },
                        {
                            id: 30020512,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (карачаевская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020512'
                        },
                        {
                            id: 30020513,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (карельская) литература (ливвиковское наречие)»',
                            childrenLinks: [],
                            url: '/sections/30020513'
                        },
                        {
                            id: 30020514,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (карельская) литература (собственно карельское наречие)»',
                            childrenLinks: [],
                            url: '/sections/30020514'
                        },
                        {
                            id: 30020515,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (коми) литература»',
                            childrenLinks: [],
                            url: '/sections/30020515'
                        },
                        {
                            id: 30020516,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (крымскотатарская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020516'
                        },
                        {
                            id: 300205161,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (кумыкская) литература»',
                            childrenLinks: [],
                            url: '/sections/300205161'
                        },
                        {
                            id: 300205162,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (лакская) литература»',
                            childrenLinks: [],
                            url: '/sections/300205162'
                        },
                        {
                            id: 300205163,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (лезгинская) литература»',
                            childrenLinks: [],
                            url: '/sections/300205163'
                        },
                        {
                            id: 30020517,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (марийская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020517'
                        },
                        {
                            id: 30020518,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (мордовская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020518'
                        },
                        {
                            id: 30020519,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (нанайская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020519'
                        },
                        {
                            id: 30020520,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (ногайская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020520'
                        },
                        {
                            id: 30020521,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (осетинская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020521'
                        },
                        {
                            id: 300205211,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (табасаранская) литература»',
                            childrenLinks: [],
                            url: '/sections/300205211'
                        },
                        {
                            id: 30020522,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (татарская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020522'
                        },
                        {
                            id: 30020523,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (тувинская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020523'
                        },
                        {
                            id: 30020524,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (удмуртская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020524'
                        },
                        // {
                        //     id: 30020525,
                        //     parentId: 300205,
                        //     name: 'Федеральная рабочая программа по учебному предмету «Родная (украинская) литература»',
                        //     childrenLinks: [],
                        //     url: '/sections/30020525'
                        // },
                        {
                            id: 30020526,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (финская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020526'
                        },
                        {
                            id: 30020527,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (хакасская) литература (базовый уровень)',
                            childrenLinks: [],
                            url: '/sections/30020527'
                        },
                        {
                            id: 30020528,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (хакасская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020528'
                        },
                        {
                            id: 30020529,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (хантыйская) литература (шурышкарский диалект)»',
                            childrenLinks: [],
                            url: '/sections/30020529'
                        },
                        {
                            id: 30020530,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (черкесская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020530'
                        },
                        {
                            id: 30020531,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (чеченская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020531'
                        },
                        {
                            id: 30020532,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (чувашская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020532'
                        },
                        {
                            id: 30020533,
                            parentId: 300205,
                            name: 'Федеральная рабочая программа по учебному предмету «Родная (якутская) литература»',
                            childrenLinks: [],
                            url: '/sections/30020533'
                        }
                    ],
                    url: '/sections/300205'
                },
                {
                    id: 300206,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Иностранный (английский) язык (базовый уровень)»',
                    childrenLinks: [],
                    url: '/sections/300206'
                },
                {
                    id: 300207,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Английский язык» (углублённый уровень)',
                    childrenLinks: [],
                    url: '/sections/300207'
                },
                {
                    id: 300208,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Иностранный (немецкий) язык (базовый уровень)»',
                    childrenLinks: [],
                    url: '/sections/300208'
                },
                {
                    id: 300209,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Иностранный (немецкий) язык (углублённый уровень)»',
                    childrenLinks: [],
                    url: '/sections/300209'
                },
                {
                    id: 300210,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Французский язык» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/300210'
                },
                {
                    id: 300211,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Французский язык» (углублённый уровень)',
                    childrenLinks: [],
                    url: '/sections/300211'
                },
                {
                    id: 300212,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Иностранный (испанский) язык (базовый уровень)»',
                    childrenLinks: [],
                    url: '/sections/300212'
                },
                {
                    id: 300213,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Иностранный (испанский) язык (углублённый уровень)»',
                    childrenLinks: [],
                    url: '/sections/300213'
                },
                {
                    id: 300214,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Китайский язык» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/300214'
                },
                {
                    id: 300215,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Китайский язык» (углублённый уровень)',
                    childrenLinks: [],
                    url: '/sections/300215'
                },
                {
                    id: 300216,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Английский язык. Второй иностранный язык» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/300216'
                },
                {
                    id: 300217,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (немецкий) язык (базовый уровень)»',
                    childrenLinks: [],
                    url: '/sections/300217'
                },
                {
                    id: 300218,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (французский) язык (базовый уровень)»',
                    childrenLinks: [],
                    url: '/sections/300218'
                },
                {
                    id: 300219,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (испанский) язык (базовый уровень)»',
                    childrenLinks: [],
                    url: '/sections/300219'
                },
                {
                    id: 300220,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Китайский язык. Второй иностранный язык» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/300220'
                },
                {
                    id: 300221,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Математика» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/300221'
                },
                {
                    id: 300222,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Математика» (углублённый уровень)',
                    childrenLinks: [],
                    url: '/sections/300222'
                },
                {
                    id: 300223,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Информатика» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/300223'
                },
                {
                    id: 300224,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Информатика» (углублённый уровень)',
                    childrenLinks: [],
                    url: '/sections/300224'
                },
                {
                    id: 300225,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Физика» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/300225'
                },
                {
                    id: 300226,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Физика» (углублённый уровень)',
                    childrenLinks: [],
                    url: '/sections/300226'
                },
                {
                    id: 300227,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Химия» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/300227'
                },
                {
                    id: 300228,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Химия» (углублённый уровень)',
                    childrenLinks: [],
                    url: '/sections/300228'
                },
                {
                    id: 300229,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Биология» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/300229'
                },
                {
                    id: 300230,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Биология» (углублённый уровень)',
                    childrenLinks: [],
                    url: '/sections/300230'
                },
                {
                    id: 300231,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «История» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/300231'
                },
                {
                    id: 3002311,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «История» (базовый уровень) (вступает в силу с 01 сентября 2025 года)',
                    childrenLinks: [],
                    url: '/sections/3002311'
                },
                {
                    id: 300232,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «История» (углублённый уровень)',
                    childrenLinks: [],
                    url: '/sections/300232'
                },
                {
                    id: 300233,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Обществознание» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/300233'
                },
                {
                    id: 3002331,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Обществознание» (базовый уровень) (вступает в силу с 01 сентября 2025 года) ',
                    childrenLinks: [],
                    url: '/sections/3002331'
                },
                {
                    id: 300234,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Обществознание» (углублённый уровень)',
                    childrenLinks: [],
                    url: '/sections/300234'
                },
                {
                    id: 300235,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «География» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/300235'
                },
                {
                    id: 300236,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «География» (углублённый уровень)',
                    childrenLinks: [],
                    url: '/sections/300236'
                },
                {
                    id: 300237,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Физическая культура»',
                    childrenLinks: [],
                    url: '/sections/300237'
                },
                {
                    id: 300238,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа по учебному предмету «Основы безопасности и защиты Родины» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/300238'
                },
                {
                    id: 300239,
                    parentId: 3002,
                    name: 'Программа формирования универсальных учебных действий',
                    childrenLinks: [],
                    url: '/sections/300239'
                },
                {
                    id: 300240,
                    parentId: 3002,
                    name: 'Федеральная рабочая программа воспитания',
                    childrenLinks: [],
                    url: '/sections/300240'
                }
            ],
            filesToDownload: [{url: './files/soo/III_soo.docx', downloadButtonName: 'Скачать раздел'}],
        },
        {
            id: 3003,
            parentId: 3,
            type: PageTypes.SECTION,
            title: 'IV. Организационный раздел',
            childrenLinks: [
                {
                    id: 3003001,
                    parentId: 3003,
                    name: 'Федеральный учебный план среднего общего образования',
                    childrenLinks: [
                        {
                            id: 30030010,
                            parentId: 3003001,
                            name: 'Пояснительная записка',
                            childrenLinks: [],
                            url: '/sections/30030010'
                        },
                        {
                            id: 300300111,
                            parentId: 300302,
                            name: 'Технологический профиль',
                            childrenLinks: [
                                {
                                    id: 30030011011,
                                    parentId: 300300111,
                                    name: 'Пример учебного плана технологического (инженерного) и агротехнологического профилей (с углубленным изучением математики и физики) (вариант 1)',
                                    childrenLinks: [],
                                    url: '/sections/30030011011'
                                },
                                {
                                    id: 30030011021,
                                    parentId: 300300111,
                                    name: 'Пример учебного плана технологического (информационно-технологического) профиля (с углубленным изучением математики и информатики) (вариант 2)',
                                    childrenLinks: [],
                                    url: '/sections/30030011021'
                                }
                            ],
                            url: '/sections/300300111'
                        },
                        {
                            id: 300300121,
                            parentId: 300302,
                            name: 'Естественно-научный и агротехнологический профили',
                            childrenLinks: [
                                {
                                    id: 30030012011,
                                    parentId: 300300121,
                                    name: 'Пример учебного плана естественно-научного и агротехнологического профилей',
                                    childrenLinks: [],
                                    url: '/sections/30030012011'
                                }
                            ],
                            url: '/sections/300300121'
                        },
                        {
                            id: 300300131,
                            parentId: 300302,
                            name: 'Гуманитарный профиль',
                            childrenLinks: [
                                {
                                    id: 30030013011,
                                    parentId: 300300131,
                                    name: 'Пример учебного плана гуманитарного профиля (вариант 1)',
                                    childrenLinks: [],
                                    url: '/sections/30030013011'
                                },
                                {
                                    id: 30030013021,
                                    parentId: 300300131,
                                    name: 'Пример учебного плана гуманитарного профиля (вариант 2)',
                                    childrenLinks: [],
                                    url: '/sections/30030013021'
                                },
                                {
                                    id: 30030013031,
                                    parentId: 300300131,
                                    name: 'Пример учебного плана гуманитарного профиля (вариант 3)',
                                    childrenLinks: [],
                                    url: '/sections/30030013031'
                                },
                                {
                                    id: 30030013041,
                                    parentId: 300300131,
                                    name: 'Пример учебного плана гуманитарного профиля (вариант 4)',
                                    childrenLinks: [],
                                    url: '/sections/30030013041'
                                },
                                {
                                    id: 30030013051,
                                    parentId: 300300131,
                                    name: 'Пример учебного плана гуманитарного профиля (вариант 5)',
                                    childrenLinks: [],
                                    url: '/sections/30030013051'
                                },
                                {
                                    id: 30030013061,
                                    parentId: 300300131,
                                    name: 'Пример учебного плана гуманитарного профиля (вариант 6)',
                                    childrenLinks: [],
                                    url: '/sections/30030013061'
                                }
                            ],
                            url: '/sections/300300131'
                        },
                        {
                            id: 300300141,
                            parentId: 300302,
                            name: 'Социально-экономический профиль',
                            childrenLinks: [
                                {
                                    id: 30030014011,
                                    parentId: 300300141,
                                    name: 'Пример учебного плана социально-экономического профиля (вариант 1)',
                                    childrenLinks: [],
                                    url: '/sections/30030014011'
                                },
                                {
                                    id: 30030014021,
                                    parentId: 300300141,
                                    name: 'Пример учебного плана социально-экономического профиля (вариант 2)',
                                    childrenLinks: [],
                                    url: '/sections/30030014021'
                                },
                                {
                                    id: 30030014031,
                                    parentId: 300300141,
                                    name: 'Пример учебного плана социально-экономического профиля (вариант 3 с углубленным изучением обществознания и географии)',
                                    childrenLinks: [],
                                    url: '/sections/30030014031'
                                }
                            ],
                            url: '/sections/300300141'
                        },
                        {
                            id: 300300151,
                            parentId: 300302,
                            name: 'Универсальный профиль',
                            childrenLinks: [
                                {
                                    id: 30030015011,
                                    parentId: 300300151,
                                    name: 'Универсальный профиль',
                                    childrenLinks: [],
                                    url: '/sections/30030015011'
                                }
                            ],
                            url: '/sections/300300151'
                        },
                        {
                            id: 300300161,
                            parentId: 300302,
                            name: 'Учебные планы с профильной возможностью, предусматривающие изучение государственных языков республик Российской Федерации из числа языков народов Российской Федерации',
                            childrenLinks: [
                                {
                                    id: 30030016011,
                                    parentId: 300300161,
                                    name: 'Пример учебного плана технологического (инженерного) профиля (с углубленным изучением математики и физики) с изучением родных языков',
                                    childrenLinks: [],
                                    url: '/sections/30030016011'
                                },
                                {
                                    id: 30030016021,
                                    parentId: 300300161,
                                    name: 'Пример учебного плана технологического (информационно-технологического) профиля (с углубленным изучением математики и информатики) с изучением родных языков',
                                    childrenLinks: [],
                                    url: '/sections/30030016021'
                                },
                                {
                                    id: 30030016031,
                                    parentId: 300300161,
                                    name: 'Пример учебного плана естественно-научного профиля с изучением родных языков',
                                    childrenLinks: [],
                                    url: '/sections/30030016031'
                                },
                                {
                                    id: 30030016041,
                                    parentId: 300300161,
                                    name: 'Пример учебного плана социально-экономического профиля с изучением родных языков',
                                    childrenLinks: [],
                                    url: '/sections/30030016041'
                                },
                                {
                                    id: 30030016051,
                                    parentId: 300300161,
                                    name: 'Пример учебного плана гуманитарного профиля с изучением родных языков',
                                    childrenLinks: [],
                                    url: '/sections/30030016051'
                                },
                                {
                                    id: 30030016061,
                                    parentId: 300300161,
                                    name: 'Пример учебного плана универсального профиля с изучением родных языков',
                                    childrenLinks: [],
                                    url: '/sections/30030016061'
                                }
                            ],
                            url: '/sections/300300161'
                        },
                    ],
                    url: '/sections/3003001'
                },
                {
                    id: 3003002,
                    parentId: 3003,
                    name: 'Федеральный календарный учебный график',
                    childrenLinks: [],
                    url: '/sections/3003002'
                },
                {
                    id: 3003003,
                    parentId: 3003,
                    name: 'План внеурочной деятельности',
                    childrenLinks: [],
                    url: '/sections/3003003'
                },
                {
                    id: 3003004,
                    parentId: 3003,
                    name: 'Федеральный календарный план воспитательной работы',
                    childrenLinks: [],
                    url: '/sections/3003004'
                }
            ],
            filesToDownload: [{url: './files/soo/IV_soo_2025.docx', downloadButtonName: 'Скачать раздел'}],
        },
        {
            id: 3001001,
            parentId: 3001,
            type: PageTypes.SECTION,
            title: 'Пояснительная записка',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/16.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/16.pdf'
        },
        {
            id: 3001002,
            parentId: 3001,
            type: PageTypes.SECTION,
            title: 'Планируемые результаты освоения ФОП СОО',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/17.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/17.pdf'
        },
        {
            id: 3001003,
            parentId: 3001,
            type: PageTypes.SECTION,
            title: 'Система оценки достижения планируемых результатов освоения\n' +
                'ФОП СОО',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/18.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/18.pdf'
        },
        {
            id: 300201,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Русский язык» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/19.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/19.pdf'
        },
        {
            id: 300202,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Литература» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/20.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/20.pdf'
        },
        {
            id: 300203,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Литература» (углублённый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/21.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/21.pdf'
        },
        {
            id: 300204,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральные рабочие программы по учебному предмету «Родной язык»',
            childrenLinks: [
                {
                    id: 30020401,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной язык (русский)»',
                    childrenLinks: [],
                    url: '/sections/30020401'
                },
                {
                    id: 30020402,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (абазинский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020402'
                },
                {
                    id: 300204021,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (аварский) язык»',
                    childrenLinks: [],
                    url: '/sections/300204021'
                },
                {
                    id: 30020403,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (адыгейский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020403'
                },
                {
                    id: 30020404,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (алтайский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020404'
                },
                {
                    id: 30020405,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (балкарский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020405'
                },
                {
                    id: 30020406,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (балкарский) язык».',
                    childrenLinks: [],
                    url: '/sections/30020406'
                },
                {
                    id: 30020407,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (башкирский) язык» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/30020407'
                },
                {
                    id: 30020408,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (башкирский) язык Республики Башкортостан»',
                    childrenLinks: [],
                    url: '/sections/30020408'
                },
                {
                    id: 30020409,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (бурятский) язык Республики Бурятия»',
                    childrenLinks: [],
                    url: '/sections/30020409'
                },
                {
                    id: 30020410,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (вепсский) язык» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/30020410'
                },
                {
                    id: 300204101,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (даргинский) язык»',
                    childrenLinks: [],
                    url: '/sections/300204101'
                },
                {
                    id: 30020411,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (кабардино-черкесский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020411'
                },
                {
                    id: 30020412,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (кабардино-черкесский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020412'
                },
                {
                    id: 30020413,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (карачаевский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020413'
                },
                {
                    id: 30020414,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (карельский) язык (ливвиковское наречие)» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/30020414'
                },
                {
                    id: 30020415,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (карельский) язык (собственно карельское наречие)» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/30020415'
                },
                {
                    id: 30020416,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (коми) язык»',
                    childrenLinks: [],
                    url: '/sections/30020416'
                },
                {
                    id: 30020417,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (крымскотатарский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020417'
                },
                {
                    id: 30020418,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (крымскотатарский) язык Республики Крым»',
                    childrenLinks: [],
                    url: '/sections/30020418'
                },
                {
                    id: 300204181,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (кумыкский) язык»',
                    childrenLinks: [],
                    url: '/sections/300204181'
                },
                {
                    id: 300204182,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (лакский) язык»',
                    childrenLinks: [],
                    url: '/sections/300204182'
                },
                {
                    id: 300204183,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (лезгинский) язык»',
                    childrenLinks: [],
                    url: '/sections/300204183'
                },
                {
                    id: 30020419,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (марийский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020419'
                },
                {
                    id: 30020420,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (марийский (горный, луговой) язык Республики Марий Эл»',
                    childrenLinks: [],
                    url: '/sections/30020420'
                },
                {
                    id: 30020421,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (мокшанский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020421'
                },
                {
                    id: 30020422,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (нанайский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020422'
                },
                {
                    id: 30020423,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (ногайский) язык» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/30020423'
                },
                {
                    id: 30020424,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (осетинский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020424'
                },
                {
                    id: 30020425,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (осетинский) язык Республики Северная Осетия – Алания»',
                    childrenLinks: [],
                    url: '/sections/30020425'
                },
                {
                    id: 300204251,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (табасаранский) язык»',
                    childrenLinks: [],
                    url: '/sections/300204251'
                },
                {
                    id: 30020426,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (татарский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020426'
                },
                {
                    id: 30020427,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (татарский) язык Республики Татарстан»',
                    childrenLinks: [],
                    url: '/sections/30020427'
                },
                {
                    id: 30020428,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (тувинский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020428'
                },
                {
                    id: 30020429,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (удмуртский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020429'
                },
                {
                    id: 30020430,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (удмуртский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020430'
                },
                // {
                //     id: 30020431,
                //     parentId: 300204,
                //     name: 'Федеральная рабочая программа по учебному предмету «Родной (украинский) язык»',
                //     childrenLinks: [],
                //     url: '/sections/30020431'
                // },
                {
                    id: 30020432,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (финский) язык» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/30020432'
                },
                {
                    id: 30020433,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (хакасский) язык» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/30020433'
                },
                {
                    id: 30020434,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (хакасский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020434'
                },
                {
                    id: 30020435,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (хантыйский) язык (шурышкарский диалект)»',
                    childrenLinks: [],
                    url: '/sections/30020435'
                },
                {
                    id: 30020436,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (черкесский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020436'
                },
                {
                    id: 30020437,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (чеченский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020437'
                },
                {
                    id: 30020438,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (чувашский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020438'
                },
                {
                    id: 30020439,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Государственный (чувашский) язык Чувашской Республики – Чувашии»',
                    childrenLinks: [],
                    url: '/sections/30020439'
                },
                {
                    id: 30020440,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (эрзянский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020440'
                },
                {
                    id: 30020441,
                    parentId: 300204,
                    name: 'Федеральная рабочая программа по учебному предмету «Родной (якутский) язык»',
                    childrenLinks: [],
                    url: '/sections/30020441'
                }
            ]
        },
        {
            id: 30020401,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной язык (русский)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/22.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/22.pdf'
        },
        {
            id: 30020402,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (абазинский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/23.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/23.pdf'
        },
        {
            id: 300204021,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (аварский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/23_1.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/23_1.pdf'
        },
        {
            id: 30020403,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (адыгейский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/24.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/24.pdf'
        },
        {
            id: 30020404,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (алтайский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/25.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/25.pdf'
        },
        {
            id: 30020405,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (балкарский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/26.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/26.pdf'
        },
        {
            id: 30020406,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (балкарский) язык».',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/27.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/27.pdf'
        },
        {
            id: 30020407,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (башкирский) язык» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/28.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/28.pdf'
        },
        {
            id: 30020408,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Государственный (башкирский) язык Республики Башкортостан»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/29.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/29.pdf'
        },
        {
            id: 30020409,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Государственный (бурятский) язык Республики Бурятия»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/30.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/30.pdf'
        },
        {
            id: 30020410,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (вепсский) язык» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/31.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/31.pdf'
        },
        {
            id: 300204101,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (даргинский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/31_1.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/31_1.pdf'
        },
        {
            id: 30020411,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (кабардино-черкесский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/32.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/32.pdf'
        },
        {
            id: 30020412,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (кабардино-черкесский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/33.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/33.pdf'
        },
        {
            id: 30020413,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (карачаевский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/34.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/34.pdf'
        },
        {
            id: 30020414,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (карельский) язык (ливвиковское наречие)» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/35.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/35.pdf'
        },
        {
            id: 30020415,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (карельский) язык (собственно карельское наречие)» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/36.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/36.pdf'
        },
        {
            id: 30020416,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (коми) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/37.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/37.pdf'
        },
        {
            id: 30020417,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (крымскотатарский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/38.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/38.pdf'
        },
        {
            id: 30020418,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Государственный (крымскотатарский) язык Республики Крым»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/39.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/39.pdf'
        },
        {
            id: 300204181,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (кумыкский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/39_1.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/39_1.pdf'
        },
        {
            id: 300204182,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (лакский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/39_2.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/39_2.pdf'
        },
        {
            id: 300204183,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (лезгинский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/39_3.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/39_3.pdf'
        },
        {
            id: 30020419,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (марийский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/40.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/40.pdf'
        },
        {
            id: 30020420,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Государственный (марийский (горный, луговой) язык Республики Марий Эл»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/41.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/41.pdf'
        },
        {
            id: 30020421,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (мокшанский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/42.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/42.pdf'
        },
        {
            id: 30020422,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (нанайский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/43.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/43.pdf'
        },
        {
            id: 30020423,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (ногайский) язык» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/44.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/44.pdf'
        },
        {
            id: 30020424,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (осетинский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/45.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/45.pdf'
        },
        {
            id: 30020425,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Государственный (осетинский) язык Республики Северная Осетия – Алания»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/46.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/46.pdf'
        },
        {
            id: 300204251,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (табасаранский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/46_1.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/46_1.pdf'
        },
        {
            id: 30020426,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (татарский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/47.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/47.pdf'
        },
        {
            id: 30020427,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Государственный (татарский) язык Республики Татарстан»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/48.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/48.pdf'
        },
        {
            id: 30020428,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (тувинский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/49.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/49.pdf'
        },
        {
            id: 30020429,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (удмуртский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/50.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/50.pdf'
        },
        {
            id: 30020430,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (удмуртский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/51.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/51.pdf'
        },
        // {
        //     id: 30020431,
        //     parentId: 300204,
        //     type: PageTypes.SECTION,
        //     title: 'Федеральная рабочая программа по учебному предмету «Родной (украинский) язык»',
        //     childrenLinks: [],
        //     filesToDownload: [{url: './files/soo/52.docx', downloadButtonName: 'Скачать раздел'}],
        //     pdfUrl: './files/soo/52.pdf'
        // },
        {
            id: 30020432,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (финский) язык» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/53.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/53.pdf'
        },
        {
            id: 30020433,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (хакасский) язык» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/54.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/54.pdf'
        },
        {
            id: 30020434,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (хакасский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/55.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/55.pdf'
        },
        {
            id: 30020435,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (хантыйский) язык (шурышкарский диалект)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/56.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/56.pdf'
        },
        {
            id: 30020436,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (черкесский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/57.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/57.pdf'
        },
        {
            id: 30020437,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (чеченский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/58.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/58.pdf'
        },
        {
            id: 30020438,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (чувашский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/59.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/59.pdf'
        },
        {
            id: 30020439,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Государственный (чувашский) язык Чувашской Республики – Чувашии»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/60.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/60.pdf'
        },
        {
            id: 30020440,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (эрзянский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/61.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/61.pdf'
        },
        {
            id: 30020441,
            parentId: 300204,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родной (якутский) язык»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/62.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/62.pdf'
        },
        {
            id: 300205,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральные рабочие программы по учебному предмету «Литература на родном языке»',
            childrenLinks: [
                {
                    id: 30020501,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная литература (русская)»',
                    childrenLinks: [],
                    url: '/sections/30020501'
                },
                {
                    id: 30020502,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (абазинская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020502'
                },
                {
                    id: 300205021,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (аварская) литература»',
                    childrenLinks: [],
                    url: '/sections/300205021'
                },
                {
                    id: 30020503,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (адыгейская) литература».',
                    childrenLinks: [],
                    url: '/sections/30020503'
                },
                {
                    id: 30020504,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (алтайская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020504'
                },
                {
                    id: 30020505,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (балкарская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020505'
                },
                {
                    id: 30020506,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (башкирская) литература» (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/30020506'
                },
                {
                    id: 30020507,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (бурятская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020507'
                },
                {
                    id: 30020508,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (вепсская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020508'
                },
                {
                    id: 300205081,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (даргинская) литература»',
                    childrenLinks: [],
                    url: '/sections/300205081'
                },
                {
                    id: 30020509,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (ингушская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020509'
                },
                {
                    id: 30020510,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (кабардино-черкесская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020510'
                },
                {
                    id: 30020511,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (калмыцкая) литература»',
                    childrenLinks: [],
                    url: '/sections/30020511'
                },
                {
                    id: 30020512,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (карачаевская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020512'
                },
                {
                    id: 30020513,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (карельская) литература (ливвиковское наречие)»',
                    childrenLinks: [],
                    url: '/sections/30020513'
                },
                {
                    id: 30020514,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (карельская) литература (собственно карельское наречие)»',
                    childrenLinks: [],
                    url: '/sections/30020514'
                },
                {
                    id: 30020515,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (коми) литература»',
                    childrenLinks: [],
                    url: '/sections/30020515'
                },
                {
                    id: 30020516,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (крымскотатарская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020516'
                },
                {
                    id: 300205161,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (кумыкская) литература»',
                    childrenLinks: [],
                    url: '/sections/300205161'
                },
                {
                    id: 300205162,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (лакская) литература»',
                    childrenLinks: [],
                    url: '/sections/300205162'
                },
                {
                    id: 300205163,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (лезгинская) литература»',
                    childrenLinks: [],
                    url: '/sections/300205163'
                },
                {
                    id: 30020517,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (марийская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020517'
                },
                {
                    id: 30020518,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (мордовская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020518'
                },
                {
                    id: 30020519,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (нанайская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020519'
                },
                {
                    id: 30020520,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (ногайская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020520'
                },
                {
                    id: 30020521,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (осетинская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020521'
                },
                {
                    id: 300205211,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (табасаранская) литература»',
                    childrenLinks: [],
                    url: '/sections/300205211'
                },
                {
                    id: 30020522,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (татарская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020522'
                },
                {
                    id: 30020523,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (тувинская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020523'
                },
                {
                    id: 30020524,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (удмуртская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020524'
                },
                // {
                //     id: 30020525,
                //     parentId: 300205,
                //     name: 'Федеральная рабочая программа по учебному предмету «Родная (украинская) литература»',
                //     childrenLinks: [],
                //     url: '/sections/30020525'
                // },
                {
                    id: 30020526,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (финская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020526'
                },
                {
                    id: 30020527,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (хакасская) литература (базовый уровень)',
                    childrenLinks: [],
                    url: '/sections/30020527'
                },
                {
                    id: 30020528,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (хакасская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020528'
                },
                {
                    id: 30020529,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (хантыйская) литература (шурышкарский диалект)»',
                    childrenLinks: [],
                    url: '/sections/30020529'
                },
                {
                    id: 30020530,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (черкесская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020530'
                },
                {
                    id: 30020531,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (чеченская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020531'
                },
                {
                    id: 30020532,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (чувашская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020532'
                },
                {
                    id: 30020533,
                    parentId: 300205,
                    name: 'Федеральная рабочая программа по учебному предмету «Родная (якутская) литература»',
                    childrenLinks: [],
                    url: '/sections/30020533'
                }
            ]
        },
        {
            id: 30020501,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная литература (русская)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/63.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/63.pdf'
        },
        {
            id: 30020502,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (абазинская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/64.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/64.pdf'
        },
        {
            id: 300205021,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (аварская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/64_1.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/64_1.pdf'
        },
        {
            id: 30020503,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (адыгейская) литература».',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/65.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/65.pdf'
        },
        {
            id: 30020504,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (алтайская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/66.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/66.pdf'
        },
        {
            id: 30020505,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (балкарская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/67.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/67.pdf'
        },
        {
            id: 30020506,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (башкирская) литература» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/68.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/68.pdf'
        },
        {
            id: 30020507,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (бурятская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/69.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/69.pdf'
        },
        {
            id: 30020508,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (вепсская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/70.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/70.pdf'
        },
        {
            id: 300205081,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (даргинская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/70_1.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/70_1.pdf'
        },
        {
            id: 30020509,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (ингушская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/71.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/71.pdf'
        },
        {
            id: 30020510,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (кабардино-черкесская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/72.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/72.pdf'
        },
        {
            id: 30020511,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (калмыцкая) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/73.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/73.pdf'
        },
        {
            id: 30020512,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (карачаевская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/74.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/74.pdf'
        },
        {
            id: 30020513,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (карельская) литература (ливвиковское наречие)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/75.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/75.pdf'
        },
        {
            id: 30020514,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (карельская) литература (собственно карельское наречие)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/76.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/76.pdf'
        },
        {
            id: 30020515,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (коми) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/77.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/77.pdf'
        },
        {
            id: 30020516,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (крымскотатарская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/78.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/78.pdf'
        },
        {
            id: 300205161,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (кумыкская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/78_1.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/78_1.pdf'
        },
        {
            id: 300205162,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (лакская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/78_2.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/78_2.pdf'
        },
        {
            id: 300205163,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (лезгинская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/78_3.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/78_3.pdf'
        },
        {
            id: 30020517,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (марийская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/79.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/79.pdf'
        },
        {
            id: 30020518,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (мордовская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/80.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/80.pdf'
        },
        {
            id: 30020519,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (нанайская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/81.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/81.pdf'
        },
        {
            id: 30020520,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (ногайская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/82.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/82.pdf'
        },
        {
            id: 30020521,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (осетинская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/83.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/83.pdf'
        },
        {
            id: 300205211,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (табасаранская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/83_1.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/83_1.pdf'
        },
        {
            id: 30020522,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (татарская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/84.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/84.pdf'
        },
        {
            id: 30020523,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (тувинская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/85.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/85.pdf'
        },
        {
            id: 30020524,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (удмуртская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/86.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/86.pdf'
        },
        // {
        //     id: 30020525,
        //     parentId: 300205,
        //     type: PageTypes.SECTION,
        //     title: 'Федеральная рабочая программа по учебному предмету «Родная (украинская) литература»',
        //     childrenLinks: [],
        //     filesToDownload: [{url: './files/soo/87.docx', downloadButtonName: 'Скачать раздел'}],
        //     pdfUrl: './files/soo/87.pdf'
        // },
        {
            id: 30020526,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (финская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/88.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/88.pdf'
        },
        {
            id: 30020527,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (хакасская) литература (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/89.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/89.pdf'
        },
        {
            id: 30020528,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (хакасская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/90.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/90.pdf'
        },
        {
            id: 30020529,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (хантыйская) литература (шурышкарский диалект)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/91.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/91.pdf'
        },
        {
            id: 30020530,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (черкесская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/92.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/92.pdf'
        },
        {
            id: 30020531,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (чеченская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/93.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/93.pdf'
        },
        {
            id: 30020532,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (чувашская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/94.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/94.pdf'
        },
        {
            id: 30020533,
            parentId: 300205,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Родная (якутская) литература»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/95.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/95.pdf'
        },
        {
            id: 300206,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Иностранный (английский) язык (базовый уровень)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/96.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/96.pdf'
        },
        {
            id: 300207,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Английский язык» (углублённый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/97.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/97.pdf'
        },
        {
            id: 300208,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Иностранный (немецкий) язык (базовый уровень)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/98.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/98.pdf'
        },
        {
            id: 300209,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Иностранный (немецкий) язык (углублённый уровень)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/99.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/99.pdf'
        },
        {
            id: 300210,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Французский язык» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/100.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/100.pdf'
        },
        {
            id: 300211,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Французский язык» (углублённый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/101.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/101.pdf'
        },
        {
            id: 300212,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Иностранный (испанский) язык (базовый уровень)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/102.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/102.pdf'
        },
        {
            id: 300213,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Иностранный (испанский) язык (углублённый уровень)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/103.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/103.pdf'
        },
        {
            id: 300214,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Китайский язык» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/104.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/104.pdf'
        },
        {
            id: 300215,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Китайский язык» (углублённый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/105.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/105.pdf'
        },
        {
            id: 300216,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Английский язык. Второй иностранный язык» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/106.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/106.pdf'
        },
        {
            id: 300217,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (немецкий) язык (базовый уровень)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/107.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/107.pdf'
        },
        {
            id: 300218,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (французский) язык (базовый уровень)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/108.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/108.pdf'
        },
        {
            id: 300219,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Второй иностранный (испанский) язык (базовый уровень)»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/109.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/109.pdf'
        },
        {
            id: 300220,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Китайский язык. Второй иностранный язык» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/110.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/110.pdf'
        },
        {
            id: 300221,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Математика» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/111.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/111.pdf'
        },
        {
            id: 300222,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Математика» (углублённый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/112.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/112.pdf'
        },
        {
            id: 300223,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Информатика» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/113.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/113.pdf'
        },
        {
            id: 300224,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Информатика» (углублённый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/114.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/114.pdf'
        },
        {
            id: 300225,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Физика» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/115.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/115.pdf'
        },
        {
            id: 300226,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Физика» (углублённый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/116.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/116.pdf'
        },
        {
            id: 300227,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Химия» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/117.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/117.pdf'
        },
        {
            id: 300228,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Химия» (углублённый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/118.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/118.pdf'
        },
        {
            id: 300229,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Биология» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/119.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/119.pdf'
        },
        {
            id: 300230,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Биология» (углублённый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/120.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/120.pdf'
        },
        {
            id: 300231,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «История» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/121.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/121.pdf'
        },
        {
            id: 3002311,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «История» (базовый уровень) (вступает в силу с 01 сентября 2025 года) ',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/121_1.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/121_1.pdf'
        },
        {
            id: 300232,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «История» (углублённый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/122.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/122.pdf'
        },
        {
            id: 300233,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Обществознание» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/123.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/123.pdf'
        },
        {
            id: 3002331,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Обществознание» (базовый уровень) (вступает в силу с 01 сентября 2025 года) ',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/123_1.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/123_1.pdf'
        },
        {
            id: 300234,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Обществознание» (углублённый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/124.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/124.pdf'
        },
        {
            id: 300235,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «География» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/125.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/125.pdf'
        },
        {
            id: 300236,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «География» (углублённый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/126.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/126.pdf'
        },
        {
            id: 300237,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Физическая культура»',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/127.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/127.pdf'
        },
        {
            id: 300238,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа по учебному предмету «Основы безопасности и защиты Родины» (базовый уровень)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/127_1.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/127_1.pdf'
        },
        {
            id: 300239,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Программа формирования универсальных учебных действий',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/129.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/129.pdf'
        },
        {
            id: 300240,
            parentId: 3002,
            type: PageTypes.SECTION,
            title: 'Федеральная рабочая программа воспитания',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/130.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/130.pdf'
        },
        {
            id: 3003001,
            parentId: 3003,
            type: PageTypes.SECTION,
            title: 'Федеральный учебный план среднего общего образования',
            childrenLinks: [
                {
                    id: 30030010,
                    parentId: 3003001,
                    name: 'Пояснительная записка',
                    childrenLinks: [],
                    url: '/sections/30030010'
                },
                {
                    id: 300300111,
                    parentId: 300302,
                    name: 'Технологический профиль',
                    childrenLinks: [
                        {
                            id: 30030011011,
                            parentId: 300300111,
                            name: 'Пример учебного плана технологического (инженерного) и агротехнологического профилей (с углубленным изучением математики и физики) (вариант 1)',
                            childrenLinks: [],
                            url: '/sections/30030011011'
                        },
                        {
                            id: 30030011021,
                            parentId: 300300111,
                            name: 'Пример учебного плана технологического (информационно-технологического) профиля (с углубленным изучением математики и информатики) (вариант 2)',
                            childrenLinks: [],
                            url: '/sections/30030011021'
                        }
                    ],
                    url: '/sections/300300111'
                },
                {
                    id: 300300121,
                    parentId: 300302,
                    name: 'Естественно-научный и агротехнологический профили',
                    childrenLinks: [
                        {
                            id: 30030012011,
                            parentId: 300300121,
                            name: 'Пример учебного плана естественно-научного и агротехнологического профилей',
                            childrenLinks: [],
                            url: '/sections/30030012011'
                        }
                    ],
                    url: '/sections/300300121'
                },
                {
                    id: 300300131,
                    parentId: 300302,
                    name: 'Гуманитарный профиль',
                    childrenLinks: [
                        {
                            id: 30030013011,
                            parentId: 300300131,
                            name: 'Пример учебного плана гуманитарного профиля (вариант 1)',
                            childrenLinks: [],
                            url: '/sections/30030013011'
                        },
                        {
                            id: 30030013021,
                            parentId: 300300131,
                            name: 'Пример учебного плана гуманитарного профиля (вариант 2)',
                            childrenLinks: [],
                            url: '/sections/30030013021'
                        },
                        {
                            id: 30030013031,
                            parentId: 300300131,
                            name: 'Пример учебного плана гуманитарного профиля (вариант 3)',
                            childrenLinks: [],
                            url: '/sections/30030013031'
                        },
                        {
                            id: 30030013041,
                            parentId: 300300131,
                            name: 'Пример учебного плана гуманитарного профиля (вариант 4)',
                            childrenLinks: [],
                            url: '/sections/30030013041'
                        },
                        {
                            id: 30030013051,
                            parentId: 300300131,
                            name: 'Пример учебного плана гуманитарного профиля (вариант 5)',
                            childrenLinks: [],
                            url: '/sections/30030013051'
                        },
                        {
                            id: 30030013061,
                            parentId: 300300131,
                            name: 'Пример учебного плана гуманитарного профиля (вариант 6)',
                            childrenLinks: [],
                            url: '/sections/30030013061'
                        }
                    ],
                    url: '/sections/300300131'
                },
                {
                    id: 300300141,
                    parentId: 300302,
                    name: 'Социально-экономический профиль',
                    childrenLinks: [
                        {
                            id: 30030014011,
                            parentId: 300300141,
                            name: 'Пример учебного плана социально-экономического профиля (вариант 1)',
                            childrenLinks: [],
                            url: '/sections/30030014011'
                        },
                        {
                            id: 30030014021,
                            parentId: 300300141,
                            name: 'Пример учебного плана социально-экономического профиля (вариант 2)',
                            childrenLinks: [],
                            url: '/sections/30030014021'
                        },
                        {
                            id: 30030014031,
                            parentId: 300300141,
                            name: 'Пример учебного плана социально-экономического профиля (вариант 3 с углубленным изучением обществознания и географии)',
                            childrenLinks: [],
                            url: '/sections/30030014031'
                        }
                    ],
                    url: '/sections/300300141'
                },
                {
                    id: 300300151,
                    parentId: 300302,
                    name: 'Универсальный профиль',
                    childrenLinks: [
                        {
                            id: 30030015011,
                            parentId: 300300151,
                            name: 'Универсальный профиль',
                            childrenLinks: [],
                            url: '/sections/30030015011'
                        }
                    ],
                    url: '/sections/300300151'
                },
                {
                    id: 300300161,
                    parentId: 300302,
                    name: 'Учебные планы с профильной возможностью, предусматривающие изучение государственных языков республик Российской Федерации из числа языков народов Российской Федерации',
                    childrenLinks: [
                        {
                            id: 30030016011,
                            parentId: 300300161,
                            name: 'Пример учебного плана технологического (инженерного) профиля (с углубленным изучением математики и физики) с изучением родных языков',
                            childrenLinks: [],
                            url: '/sections/30030016011'
                        },
                        {
                            id: 30030016021,
                            parentId: 300300161,
                            name: 'Пример учебного плана технологического (информационно-технологического) профиля (с углубленным изучением математики и информатики) с изучением родных языков',
                            childrenLinks: [],
                            url: '/sections/30030016021'
                        },
                        {
                            id: 30030016031,
                            parentId: 300300161,
                            name: 'Пример учебного плана естественно-научного профиля с изучением родных языков',
                            childrenLinks: [],
                            url: '/sections/30030016031'
                        },
                        {
                            id: 30030016041,
                            parentId: 300300161,
                            name: 'Пример учебного плана социально-экономического профиля с изучением родных языков',
                            childrenLinks: [],
                            url: '/sections/30030016041'
                        },
                        {
                            id: 30030016051,
                            parentId: 300300161,
                            name: 'Пример учебного плана гуманитарного профиля с изучением родных языков',
                            childrenLinks: [],
                            url: '/sections/30030016051'
                        },
                        {
                            id: 30030016061,
                            parentId: 300300161,
                            name: 'Пример учебного плана универсального профиля с изучением родных языков',
                            childrenLinks: [],
                            url: '/sections/30030016061'
                        }
                    ],
                    url: '/sections/300300161'
                },
            ]
        },
        {
            id: 3003002,
            parentId: 3003,
            type: PageTypes.SECTION,
            title: 'Федеральный календарный учебный график',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/132.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/132.pdf'
        },
        {
            id: 3003003,
            parentId: 3003,
            type: PageTypes.SECTION,
            title: 'План внеурочной деятельности',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/133.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/133.pdf'
        },
        {
            id: 3003004,
            parentId: 3003,
            type: PageTypes.SECTION,
            title: 'Федеральный календарный план воспитательной работы',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/134.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/134.pdf'
        },
        {
            id: 30030010,
            parentId: 3003001,
            type: PageTypes.SECTION,
            title: 'Пояснительная записка',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/131.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/131.pdf'
        },
        {
            id: 300300111,
            parentId: 3003001,
            type: PageTypes.SECTION,
            title: 'Технологический профиль',
            childrenLinks: [
                {
                    id: 30030011011,
                    parentId: 300300111,
                    name: 'Пример учебного плана технологического (инженерного) и агротехнологического профилей (с углубленным изучением математики и физики) (вариант 1)',
                    childrenLinks: [],
                    url: '/sections/30030011011'
                },
                {
                    id: 30030011021,
                    parentId: 300300111,
                    name: 'Пример учебного плана технологического (информационно-технологического) профиля (с углубленным изучением математики и информатики) (вариант 2)',
                    childrenLinks: [],
                    url: '/sections/30030011021'
                }
            ]
        },
        {
            id: 30030011011,
            parentId: 300300111,
            type: PageTypes.SECTION,
            title: 'Пример учебного плана технологического (инженерного) и агротехнологического профилей (с углубленным изучением математики и физики) (вариант 1)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/tech_variant1_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/tech_variant1_2025.pdf'
        },
        {
            id: 30030011021,
            parentId: 300300111,
            type: PageTypes.SECTION,
            title: 'Пример учебного плана технологического (информационно-технологического) профиля (с углубленным изучением математики и информатики) (вариант 2)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/tech_variant2_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/tech_variant2_2025.pdf'
        },
        {
            id: 300300121,
            parentId: 3003001,
            type: PageTypes.SECTION,
            title: 'Естественно-научный и агротехнологический профили',
            childrenLinks: [
                {
                    id: 30030012011,
                    parentId: 300300121,
                    name: 'Пример учебного плана естественно-научного и агротехнологического профилей',
                    childrenLinks: [],
                    url: '/sections/30030012011'
                }
            ]
        },
        {
            id: 30030012011,
            parentId: 300300121,
            type: PageTypes.SECTION,
            title: 'Пример учебного плана естественно-научного и агротехнологического профилей',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/est_variant_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/est_variant_2025.pdf'
        },
        {
            id: 300300131,
            parentId: 3003001,
            type: PageTypes.SECTION,
            title: 'Гуманитарный профиль',
            childrenLinks: [
                {
                    id: 30030013011,
                    parentId: 300300131,
                    name: 'Пример учебного плана гуманитарного профиля (вариант 1)',
                    childrenLinks: [],
                    url: '/sections/30030013011'
                },
                {
                    id: 30030013021,
                    parentId: 300300131,
                    name: 'Пример учебного плана гуманитарного профиля (вариант 2)',
                    childrenLinks: [],
                    url: '/sections/30030013021'
                },
                {
                    id: 30030013031,
                    parentId: 300300131,
                    name: 'Пример учебного плана гуманитарного профиля (вариант 3)',
                    childrenLinks: [],
                    url: '/sections/30030013031'
                },
                {
                    id: 30030013041,
                    parentId: 300300131,
                    name: 'Пример учебного плана гуманитарного профиля (вариант 4)',
                    childrenLinks: [],
                    url: '/sections/30030013041'
                },
                {
                    id: 30030013051,
                    parentId: 300300131,
                    name: 'Пример учебного плана гуманитарного профиля (вариант 5)',
                    childrenLinks: [],
                    url: '/sections/30030013051'
                },
                {
                    id: 30030013061,
                    parentId: 300300131,
                    name: 'Пример учебного плана гуманитарного профиля (вариант 6)',
                    childrenLinks: [],
                    url: '/sections/30030013061'
                }
            ]
        },
        {
            id: 30030013011,
            parentId: 300300131,
            type: PageTypes.SECTION,
            title: 'Пример учебного плана гуманитарного профиля (вариант 1)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/gum_variant1_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/gum_variant1_2025.pdf'
        },
        {
            id: 30030013021,
            parentId: 300300131,
            type: PageTypes.SECTION,
            title: 'Пример учебного плана гуманитарного профиля (вариант 2)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/gum_variant2_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/gum_variant2_2025.pdf'
        },
        {
            id: 30030013031,
            parentId: 300300131,
            type: PageTypes.SECTION,
            title: 'Пример учебного плана гуманитарного профиля (вариант 3)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/gum_variant3_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/gum_variant3_2025.pdf'
        },
        {
            id: 30030013041,
            parentId: 300300131,
            type: PageTypes.SECTION,
            title: 'Пример учебного плана гуманитарного профиля (вариант 4)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/gum_variant4_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/gum_variant4_2025.pdf'
        },
        {
            id: 30030013051,
            parentId: 300300131,
            type: PageTypes.SECTION,
            title: 'Пример учебного плана гуманитарного профиля (вариант 5)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/gum_variant5_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/gum_variant5_2025.pdf'
        },
        {
            id: 30030013061,
            parentId: 300300131,
            type: PageTypes.SECTION,
            title: 'Пример учебного плана гуманитарного профиля (вариант 6)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/gum_variant6_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/gum_variant6_2025.pdf'
        },
        {
            id: 300300141,
            parentId: 3003001,
            type: PageTypes.SECTION,
            title: 'Социально-экономический профиль',
            childrenLinks: [
                {
                    id: 30030014011,
                    parentId: 300300141,
                    name: 'Пример учебного плана социально-экономического профиля (вариант 1)',
                    childrenLinks: [],
                    url: '/sections/30030014011'
                },
                {
                    id: 30030014021,
                    parentId: 300300141,
                    name: 'Пример учебного плана социально-экономического профиля (вариант 2)',
                    childrenLinks: [],
                    url: '/sections/30030014021'
                },
                {
                    id: 30030014031,
                    parentId: 300300141,
                    name: 'Пример учебного плана социально-экономического профиля (вариант 3 с углубленным изучением обществознания и географии)',
                    childrenLinks: [],
                    url: '/sections/30030014031'
                }
            ]
        },
        {
            id: 30030014011,
            parentId: 300300141,
            type: PageTypes.SECTION,
            title: 'Пример учебного плана социально-экономического профиля (вариант 1)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/soc_variant1_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/soc_variant1_2025.pdf'
        },
        {
            id: 30030014021,
            parentId: 300300141,
            type: PageTypes.SECTION,
            title: 'Пример учебного плана социально-экономического профиля (вариант 2)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/soc_variant2_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/soc_variant2_2025.pdf'
        },
        {
            id: 30030014031,
            parentId: 300300141,
            type: PageTypes.SECTION,
            title: 'Пример учебного плана социально-экономического профиля (вариант 3 с углубленным изучением обществознания и географии)',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/soc_variant3_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/soc_variant3_2025.pdf'
        },
        {
            id: 300300151,
            parentId: 3003001,
            type: PageTypes.SECTION,
            title: 'Универсальный профиль',
            childrenLinks: [
                {
                    id: 30030015011,
                    parentId: 300300151,
                    name: 'Универсальный профиль',
                    childrenLinks: [],
                    url: '/sections/30030015011'
                }
            ]
        },
        {
            id: 30030015011,
            parentId: 300300151,
            type: PageTypes.SECTION,
            title: 'Универсальный профиль',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/uni_variant_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/uni_variant_2025.pdf'
        },
        {
            id: 300300161,
            parentId: 3003001,
            type: PageTypes.SECTION,
            title: 'Учебные планы с профильной возможностью, предусматривающие изучение государственных языков республик Российской Федерации из числа языков народов Российской Федерации',
            childrenLinks: [
                {
                    id: 30030016011,
                    parentId: 300300161,
                    name: 'Пример учебного плана технологического (инженерного) профиля (с углубленным изучением математики и физики) с изучением родных языков',
                    childrenLinks: [],
                    url: '/sections/30030016011'
                },
                {
                    id: 30030016021,
                    parentId: 300300161,
                    name: 'Пример учебного плана технологического (информационно-технологического) профиля (с углубленным изучением математики и информатики) с изучением родных языков',
                    childrenLinks: [],
                    url: '/sections/30030016021'
                },
                {
                    id: 30030016031,
                    parentId: 300300161,
                    name: 'Пример учебного плана естественно-научного профиля с изучением родных языков',
                    childrenLinks: [],
                    url: '/sections/30030016031'
                },
                {
                    id: 30030016041,
                    parentId: 300300161,
                    name: 'Пример учебного плана социально-экономического профиля с изучением родных языков',
                    childrenLinks: [],
                    url: '/sections/30030016041'
                },
                {
                    id: 30030016051,
                    parentId: 300300161,
                    name: 'Пример учебного плана гуманитарного профиля с изучением родных языков',
                    childrenLinks: [],
                    url: '/sections/30030016051'
                },
                {
                    id: 30030016061,
                    parentId: 300300161,
                    name: 'Пример учебного плана универсального профиля с изучением родных языков',
                    childrenLinks: [],
                    url: '/sections/30030016061'
                }
            ]
        },
        {
            id: 30030016011,
            parentId: 300300161,
            type: PageTypes.SECTION,
            title: 'Пример учебного плана технологического (инженерного) профиля (с углубленным изучением математики и физики) с изучением родных языков',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/tech_variant1_rod_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/tech_variant1_rod_2025.pdf'
        },
        {
            id: 30030016021,
            parentId: 300300161,
            type: PageTypes.SECTION,
            title: 'Пример учебного плана технологического (информационно-технологического) профиля (с углубленным изучением математики и информатики) с изучением родных языков',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/tech_variant2_rod_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/tech_variant2_rod_2025.pdf'
        },
        {
            id: 30030016031,
            parentId: 300300161,
            type: PageTypes.SECTION,
            title: 'Пример учебного плана естественно-научного профиля с изучением родных языков',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/est_variant_rod_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/est_variant_rod_2025.pdf'
        },
        {
            id: 30030016041,
            parentId: 300300161,
            type: PageTypes.SECTION,
            title: 'Пример учебного плана социально-экономического профиля с изучением родных языков',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/soc_variant_rod_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/soc_variant_rod_2025.pdf'
        },
        {
            id: 30030016051,
            parentId: 300300161,
            type: PageTypes.SECTION,
            title: 'Пример учебного плана гуманитарного профиля с изучением родных языков',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/gum_variant_rod_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/gum_variant_rod_2025.pdf'
        },
        {
            id: 30030016061,
            parentId: 300300161,
            type: PageTypes.SECTION,
            title: 'Пример учебного плана универсального профиля с изучением родных языков',
            childrenLinks: [],
            filesToDownload: [{url: './files/soo/uni_variant_rod_2025.docx', downloadButtonName: 'Скачать раздел'}],
            pdfUrl: './files/soo/uni_variant_rod_2025.pdf'
        }
    ]
};
